export const data = { content:"{\"openapi\":\"3.1.1\",\"paths\":{\"/auth/me\":{\"get\":{\"description\":\"Retrieves the authenticated user's profile information including personal details and roles\",\"operationId\":\"AuthenticationController_signIn\",\"parameters\":[],\"responses\":{\"201\":{\"description\":\"\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\",\"example\":\"uuid\"},\"sub\":{\"type\":\"string\",\"example\":\"sub\"},\"email\":{\"type\":\"string\",\"example\":\"email@example.com\"},\"email_verified\":{\"type\":\"object\",\"example\":false},\"first_name\":{\"type\":\"object\",\"example\":\"John\"},\"last_name\":{\"type\":\"object\",\"example\":\"Doe\"}},\"required\":[\"id\",\"sub\",\"email\",\"email_verified\",\"first_name\"]}}}},\"401\":{\"description\":\"Invalid login request\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Bearer token not provided\",\"error\":\"Unauthorized\",\"statusCode\":401}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get information about the current user\",\"tags\":[\"Auth\"]}},\"/organizations\":{\"post\":{\"operationId\":\"OrganizationsController_create\",\"parameters\":[],\"requestBody\":{\"required\":true,\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"name\":{\"description\":\"Organization name\",\"type\":\"string\",\"maxLength\":191,\"minLength\":1},\"active\":{\"description\":\"Whether the organization is active\",\"type\":\"boolean\",\"default\":true},\"invoice_address\":{\"description\":\"The address to reference in invoices for the Organization\",\"type\":\"object\",\"properties\":{\"line1\":{\"type\":\"string\"},\"line2\":{\"type\":\"string\"},\"city\":{\"type\":\"string\"},\"state\":{\"type\":\"string\"},\"zip_code\":{\"type\":\"string\"},\"country\":{\"description\":\"Two letters country code\",\"type\":\"string\"}},\"required\":[\"line1\",\"city\",\"state\",\"zip_code\",\"country\"]},\"invoice_email\":{\"description\":\"The email to send invoices to for the Organization\",\"type\":\"string\",\"format\":\"email\"},\"invoice_name\":{\"description\":\"The name that should appear in invoices for the Organization\",\"type\":\"string\",\"minLength\":1}},\"required\":[\"name\",\"invoice_address\",\"invoice_email\",\"invoice_name\"]}}}},\"responses\":{\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":[{\"code\":\"invalid_type\",\"expected\":\"boolean\",\"received\":\"undefined\",\"path\":[\"active\"],\"message\":\"Required\"}],\"statusCode\":400}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Create a new organization\",\"tags\":[\"Organizations\"]},\"get\":{\"operationId\":\"OrganizationsController_findAll\",\"parameters\":[{\"name\":\"page\",\"required\":false,\"in\":\"query\",\"description\":\"Which page of results to fetch\",\"schema\":{\"default\":1,\"example\":\"1\",\"type\":\"string\"}},{\"name\":\"pageSize\",\"required\":false,\"in\":\"query\",\"description\":\"The size of a page of results to fetch\",\"schema\":{\"default\":10,\"example\":\"10\",\"type\":\"string\"}},{\"name\":\"search\",\"required\":true,\"in\":\"query\",\"description\":\"Filter organizations by name\",\"schema\":{\"type\":\"string\"}},{\"name\":\"active\",\"required\":true,\"in\":\"query\",\"description\":\"Filter organizations by active status\",\"schema\":{\"type\":\"boolean\"}}],\"responses\":{\"200\":{\"description\":\"Successfully received model list\",\"content\":{\"application/json\":{\"schema\":{\"allOf\":[{\"type\":\"object\",\"properties\":{\"data\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"name\":{\"type\":\"string\",\"example\":\"Account 1\"},\"id\":{\"type\":\"string\",\"example\":\"0fa33117-4026-43ad-94fe-2a6189ef582c\"},\"active\":{\"type\":\"boolean\",\"example\":false},\"created_at\":{\"format\":\"date-time\",\"type\":\"string\",\"example\":\"2011-10-05T14:48:00.000Z\"},\"updated_at\":{\"format\":\"date-time\",\"type\":\"string\",\"example\":\"2011-10-05T14:48:00.000Z\"}},\"required\":[\"name\",\"id\",\"active\",\"created_at\",\"updated_at\"]}},\"meta\":{\"type\":\"object\",\"properties\":{\"count\":{\"type\":\"number\"},\"lastPage\":{\"type\":\"number\"},\"currentPage\":{\"type\":\"number\"},\"totalPerPage\":{\"type\":\"number\"},\"prevPage\":{\"type\":\"number\",\"nullable\":true,\"example\":1},\"nextPage\":{\"type\":\"number\",\"nullable\":true,\"example\":null}},\"required\":[\"count\",\"lastPage\",\"currentPage\",\"totalPerPage\",\"prevPage\",\"nextPage\"]}}},{\"properties\":{\"data\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"name\":{\"type\":\"string\",\"example\":\"Account 1\"},\"id\":{\"type\":\"string\",\"example\":\"0fa33117-4026-43ad-94fe-2a6189ef582c\"},\"active\":{\"type\":\"boolean\",\"example\":false},\"created_at\":{\"format\":\"date-time\",\"type\":\"string\",\"example\":\"2011-10-05T14:48:00.000Z\"},\"updated_at\":{\"format\":\"date-time\",\"type\":\"string\",\"example\":\"2011-10-05T14:48:00.000Z\"}},\"required\":[\"name\",\"id\",\"active\",\"created_at\",\"updated_at\"]}}}}]}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"List all organizations\",\"tags\":[\"Organizations\"]}},\"/organizations/name-conflicts\":{\"get\":{\"operationId\":\"OrganizationsController_nameConflicts\",\"parameters\":[{\"name\":\"name\",\"required\":true,\"in\":\"query\",\"description\":\"Organization name to check\",\"schema\":{\"type\":\"string\"}},{\"name\":\"exclude_id\",\"required\":true,\"in\":\"query\",\"description\":\"Organization ID to exclude from conflict check\",\"schema\":{\"type\":\"string\"}}],\"responses\":{\"200\":{\"description\":\"\"}},\"security\":[{\"bearer\":[]}],\"summary\":\"Check if an organization name conflicts with others\",\"tags\":[\"Organizations\"]}},\"/organizations/{id}\":{\"get\":{\"operationId\":\"OrganizationsController_findOne\",\"parameters\":[{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"404\":{\"description\":\"Organization not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get an organization by ID\",\"tags\":[\"Organizations\"]},\"patch\":{\"operationId\":\"OrganizationsController_update\",\"parameters\":[{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"requestBody\":{\"required\":true,\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"name\":{\"description\":\"Organization name\",\"type\":\"string\",\"maxLength\":191,\"minLength\":1},\"active\":{\"description\":\"Whether the organization is active\",\"type\":\"boolean\",\"default\":true},\"invoice_address\":{\"description\":\"The address to reference in invoices for the Organization\",\"type\":\"object\",\"properties\":{\"line1\":{\"type\":\"string\"},\"line2\":{\"type\":\"string\"},\"city\":{\"type\":\"string\"},\"state\":{\"type\":\"string\"},\"zip_code\":{\"type\":\"string\"},\"country\":{\"description\":\"Two letters country code\",\"type\":\"string\"}},\"required\":[\"line1\",\"city\",\"state\",\"zip_code\",\"country\"]},\"invoice_email\":{\"description\":\"The email to send invoices to for the Organization\",\"type\":\"string\",\"format\":\"email\"},\"invoice_name\":{\"description\":\"The name that should appear in invoices for the Organization\",\"type\":\"string\",\"minLength\":1}}}}}},\"responses\":{\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":[{\"code\":\"invalid_type\",\"expected\":\"boolean\",\"received\":\"undefined\",\"path\":[\"active\"],\"message\":\"Required\"}],\"statusCode\":400}}}},\"403\":{\"description\":\"Forbidden - Write access required\"},\"404\":{\"description\":\"Organization not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Update an organization\",\"tags\":[\"Organizations\"]},\"delete\":{\"operationId\":\"OrganizationsController_remove\",\"parameters\":[{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"400\":{\"description\":\"Cannot delete organization - has dependent entities\"},\"403\":{\"description\":\"Forbidden - Write access required\"},\"404\":{\"description\":\"Organization not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Delete an organization\",\"tags\":[\"Organizations\"]}},\"/organizations/{id}/invitations\":{\"post\":{\"operationId\":\"OrganizationsController_createOrganizationsOnUsers\",\"parameters\":[{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"requestBody\":{\"required\":true,\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"role\":{\"description\":\"The role of the user with respect to the organization\",\"type\":\"string\",\"enum\":[\"admin\",\"write\",\"read\",\"restricted\"],\"x-enumNames\":[\"admin\",\"write\",\"read\",\"restricted\"]},\"email\":{\"description\":\"The email of the user\",\"type\":\"string\",\"format\":\"email\"},\"advertisers\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"id\":{\"description\":\"The id of the advertiser\",\"type\":\"string\",\"format\":\"uuid\"},\"role\":{\"description\":\"The role of the users with respect to the advertiser\",\"type\":\"string\",\"enum\":[\"admin\",\"write\",\"read\"],\"x-enumNames\":[\"admin\",\"write\",\"read\"]}},\"required\":[\"id\",\"role\"]}}},\"required\":[\"role\",\"email\"]}}}},\"responses\":{\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":[{\"code\":\"invalid_type\",\"expected\":\"string\",\"received\":\"undefined\",\"path\":[\"role\"],\"message\":\"Required\"}],\"statusCode\":400}}}},\"403\":{\"description\":\"Forbidden - Admin access required\"}},\"security\":[{\"bearer\":[]}],\"summary\":\"Invite users to an organization\",\"tags\":[\"Organizations\"]}},\"/organizations/{id}/users\":{\"get\":{\"operationId\":\"OrganizationsController_organizationsOnUsers\",\"parameters\":[{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"page\",\"required\":false,\"in\":\"query\",\"description\":\"Which page of results to fetch\",\"schema\":{\"default\":1,\"example\":\"1\",\"type\":\"string\"}},{\"name\":\"pageSize\",\"required\":false,\"in\":\"query\",\"description\":\"The size of a page of results to fetch\",\"schema\":{\"default\":10,\"example\":\"10\",\"type\":\"string\"}}],\"responses\":{\"403\":{\"description\":\"Forbidden - Admin access required\"},\"404\":{\"description\":\"Organization not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get the users in an organization\",\"tags\":[\"Organizations\"]}},\"/organizations/{id}/users/{user_id}\":{\"get\":{\"operationId\":\"OrganizationsController_organizationsOnUser\",\"parameters\":[{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"user_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the user\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"403\":{\"description\":\"Forbidden - Admin access required\"},\"404\":{\"description\":\"User not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get a user in an organization\",\"tags\":[\"Organizations\"]},\"delete\":{\"operationId\":\"OrganizationsController_removeOrganizationOnUser\",\"parameters\":[{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"user_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the user\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"403\":{\"description\":\"Forbidden - Admin access required\"},\"404\":{\"description\":\"User not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Remove a user from an organization\",\"tags\":[\"Organizations\"]}},\"/organizations/{id}/roles\":{\"get\":{\"operationId\":\"OrganizationsController_getRoles\",\"parameters\":[{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"404\":{\"description\":\"Organization not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get the roles of the user in an organization\",\"tags\":[\"Organizations\"]}},\"/organizations/{id}/invoice-data\":{\"get\":{\"operationId\":\"OrganizationsController_getInvoiceData\",\"parameters\":[{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"404\":{\"description\":\"Organization not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get the invoice data of an organization\",\"tags\":[\"Organizations\"]}},\"/organizations/{id}/impressions-stats\":{\"post\":{\"operationId\":\"OrganizationsController_generateImpressionStats\",\"parameters\":[{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"requestBody\":{\"required\":true,\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"advertisers\":{\"description\":\"Advertiser IDs\",\"type\":\"array\",\"items\":{\"type\":\"string\",\"format\":\"uuid\"}},\"campaigns\":{\"description\":\"Campaign IDs\",\"type\":\"array\",\"items\":{\"type\":\"string\",\"format\":\"uuid\"}},\"line_items\":{\"description\":\"Line item IDs\",\"type\":\"array\",\"items\":{\"type\":\"string\",\"format\":\"uuid\"}},\"creatives\":{\"description\":\"Creative IDs\",\"type\":\"array\",\"items\":{\"type\":\"string\",\"format\":\"uuid\"}}}}}}},\"responses\":{\"403\":{\"description\":\"Forbidden - Read access required\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"Organization not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get impression statistics related to entities of an organization\",\"tags\":[\"Organizations\"]}},\"/organizations/{id}/conversion-events\":{\"get\":{\"operationId\":\"OrganizationsController_getAvailableEvents\",\"parameters\":[{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"advertiser_id\",\"required\":true,\"in\":\"query\",\"description\":\"Filter by advertiser id\",\"schema\":{\"type\":\"array\",\"items\":{\"type\":\"string\"}}},{\"name\":\"event_name\",\"required\":true,\"in\":\"query\",\"description\":\"Filter by event name\",\"schema\":{\"type\":\"string\"}},{\"name\":\"event_source\",\"required\":true,\"in\":\"query\",\"description\":\"Filter by event source\",\"schema\":{\"type\":\"string\"}},{\"name\":\"page_size\",\"required\":true,\"in\":\"query\",\"description\":\"The size of a page of results to fetch\",\"schema\":{\"type\":\"number\"}},{\"name\":\"page\",\"required\":true,\"in\":\"query\",\"description\":\"The page of results to fetch\",\"schema\":{\"type\":\"number\"}}],\"responses\":{\"404\":{\"description\":\"Advertiser not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get conversion events related to entities of an organization\",\"tags\":[\"Organizations\"]}},\"/organizations/{organization_id}/advertisers\":{\"post\":{\"operationId\":\"AdvertisersController_create\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"requestBody\":{\"required\":true,\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"name\":{\"description\":\"The name of the advertiser\",\"type\":\"string\",\"minLength\":1,\"maxLength\":191},\"description\":{\"description\":\"A description to attach to the advertiser\",\"type\":\"string\",\"maxLength\":191},\"domain\":{\"description\":\"The domain the advertiser refers to\",\"type\":\"string\",\"format\":\"uri\"},\"category_key\":{\"description\":\"The category the advertiser refers to\",\"type\":\"string\",\"maxLength\":191},\"app_bundle\":{\"description\":\"The app bundle for the advertiser\",\"type\":\"string\",\"maxLength\":191},\"active\":{\"description\":\"Whether the advertiser should be active\",\"type\":\"boolean\",\"default\":true},\"default_continent\":{\"description\":\"The continent the advertiser should operate into\",\"type\":\"string\",\"enum\":[\"EMEA\",\"NAM\",\"APAC\"],\"x-enumNames\":[\"EMEA\",\"NAM\",\"APAC\"]}},\"required\":[\"name\",\"domain\",\"category_key\"]}}}},\"responses\":{\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":[{\"code\":\"invalid_type\",\"expected\":\"boolean\",\"received\":\"undefined\",\"path\":[\"active\"],\"message\":\"Required\"}],\"error\":\"Bad Request\",\"statusCode\":400}}}},\"403\":{\"description\":\"Forbidden - Admin access required\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Create a new advertiser\",\"tags\":[\"Advertisers\"]},\"get\":{\"operationId\":\"AdvertisersController_findAll\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"page\",\"required\":false,\"in\":\"query\",\"description\":\"Which page of results to fetch\",\"schema\":{\"default\":1,\"example\":\"1\",\"type\":\"string\"}},{\"name\":\"pageSize\",\"required\":false,\"in\":\"query\",\"description\":\"The size of a page of results to fetch\",\"schema\":{\"default\":10,\"example\":\"10\",\"type\":\"string\"}},{\"name\":\"search\",\"required\":true,\"in\":\"query\",\"description\":\"Search advertisers by name\",\"schema\":{\"type\":\"string\"}},{\"name\":\"status\",\"required\":true,\"in\":\"query\",\"description\":\"Filter advertisers by status\",\"schema\":{\"type\":\"string\",\"enum\":[\"active\",\"inactive\",\"all\"]}}],\"responses\":{\"200\":{\"description\":\"Successfully received model list\",\"content\":{\"application/json\":{\"schema\":{\"allOf\":[{\"type\":\"object\",\"properties\":{\"data\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"name\":{\"type\":\"string\",\"example\":\"Advertiser 1\"},\"id\":{\"type\":\"string\",\"example\":\"0fa33117-4026-43ad-94fe-2a6189ef582c\"},\"active\":{\"type\":\"boolean\",\"example\":false},\"dsp_id\":{\"type\":\"object\",\"example\":null},\"dsp_context_status\":{\"type\":\"string\",\"enum\":[\"PENDING\",\"FAILED\",\"SYNCED\"]},\"domain\":{\"type\":\"string\",\"example\":\"https://example.com\"},\"app_bundle\":{\"type\":\"object\",\"example\":\"com.example\"},\"alternative_id\":{\"type\":\"object\",\"example\":\"123\"},\"category_key\":{\"type\":\"string\",\"example\":\"IAB19\"},\"created_at\":{\"format\":\"date-time\",\"type\":\"string\",\"example\":\"2011-10-05T14:48:00.000Z\"},\"updated_at\":{\"format\":\"date-time\",\"type\":\"string\",\"example\":\"2011-10-05T14:48:00.000Z\"},\"description\":{\"type\":\"object\",\"example\":\"Advertiser Description\"},\"currency_key\":{\"type\":\"string\",\"example\":\"USD\"},\"default_continent\":{\"type\":\"string\",\"enum\":[\"EMEA\",\"NAM\",\"APAC\"],\"example\":\"NAM\"},\"organization_id\":{\"type\":\"string\",\"example\":\"0fa33117-4026-43ad-94fe-2a6189ef582d\"}},\"required\":[\"name\",\"id\",\"active\",\"dsp_id\",\"dsp_context_status\",\"domain\",\"app_bundle\",\"alternative_id\",\"category_key\",\"created_at\",\"updated_at\",\"description\",\"currency_key\",\"default_continent\",\"organization_id\"]}},\"meta\":{\"type\":\"object\",\"properties\":{\"count\":{\"type\":\"number\"},\"lastPage\":{\"type\":\"number\"},\"currentPage\":{\"type\":\"number\"},\"totalPerPage\":{\"type\":\"number\"},\"prevPage\":{\"type\":\"number\",\"nullable\":true,\"example\":1},\"nextPage\":{\"type\":\"number\",\"nullable\":true,\"example\":null}},\"required\":[\"count\",\"lastPage\",\"currentPage\",\"totalPerPage\",\"prevPage\",\"nextPage\"]}}},{\"properties\":{\"data\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"name\":{\"type\":\"string\",\"example\":\"Advertiser 1\"},\"id\":{\"type\":\"string\",\"example\":\"0fa33117-4026-43ad-94fe-2a6189ef582c\"},\"active\":{\"type\":\"boolean\",\"example\":false},\"dsp_id\":{\"type\":\"object\",\"example\":null},\"dsp_context_status\":{\"type\":\"string\",\"enum\":[\"PENDING\",\"FAILED\",\"SYNCED\"]},\"domain\":{\"type\":\"string\",\"example\":\"https://example.com\"},\"app_bundle\":{\"type\":\"object\",\"example\":\"com.example\"},\"alternative_id\":{\"type\":\"object\",\"example\":\"123\"},\"category_key\":{\"type\":\"string\",\"example\":\"IAB19\"},\"created_at\":{\"format\":\"date-time\",\"type\":\"string\",\"example\":\"2011-10-05T14:48:00.000Z\"},\"updated_at\":{\"format\":\"date-time\",\"type\":\"string\",\"example\":\"2011-10-05T14:48:00.000Z\"},\"description\":{\"type\":\"object\",\"example\":\"Advertiser Description\"},\"currency_key\":{\"type\":\"string\",\"example\":\"USD\"},\"default_continent\":{\"type\":\"string\",\"enum\":[\"EMEA\",\"NAM\",\"APAC\"],\"example\":\"NAM\"},\"organization_id\":{\"type\":\"string\",\"example\":\"0fa33117-4026-43ad-94fe-2a6189ef582d\"}},\"required\":[\"name\",\"id\",\"active\",\"dsp_id\",\"dsp_context_status\",\"domain\",\"app_bundle\",\"alternative_id\",\"category_key\",\"created_at\",\"updated_at\",\"description\",\"currency_key\",\"default_continent\",\"organization_id\"]}}}}]}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"List all advertisers for the organization\",\"tags\":[\"Advertisers\"]}},\"/organizations/{organization_id}/advertisers/{id}\":{\"get\":{\"operationId\":\"AdvertisersController_findOne\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the advertiser\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"404\":{\"description\":\"Advertiser not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get an advertiser by ID\",\"tags\":[\"Advertisers\"]},\"patch\":{\"operationId\":\"AdvertisersController_update\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the advertiser\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"requestBody\":{\"required\":true,\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"name\":{\"description\":\"The name of the advertiser\",\"type\":\"string\",\"minLength\":1,\"maxLength\":191},\"description\":{\"description\":\"A description to attach to the advertiser\",\"type\":\"string\",\"maxLength\":191},\"domain\":{\"description\":\"The domain the advertiser refers to\",\"type\":\"string\",\"format\":\"uri\"},\"category_key\":{\"description\":\"The category the advertiser refers to\",\"type\":\"string\",\"maxLength\":191},\"app_bundle\":{\"description\":\"The app bundle for the advertiser\",\"type\":\"string\",\"maxLength\":191},\"active\":{\"description\":\"Whether the advertiser should be active\",\"type\":\"boolean\",\"default\":true},\"default_continent\":{\"description\":\"The continent the advertiser should operate into\",\"type\":\"string\",\"enum\":[\"EMEA\",\"NAM\",\"APAC\"],\"x-enumNames\":[\"EMEA\",\"NAM\",\"APAC\"]}}}}}},\"responses\":{\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":[{\"code\":\"invalid_type\",\"expected\":\"boolean\",\"received\":\"undefined\",\"path\":[\"active\"],\"message\":\"Required\"}],\"error\":\"Bad Request\",\"statusCode\":400}}}},\"403\":{\"description\":\"Forbidden - Write access needed\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"Advertiser not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Update an advertiser\",\"tags\":[\"Advertisers\"]},\"delete\":{\"operationId\":\"AdvertisersController_remove\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the advertiser\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Advertiser cannot be deleted because it has campaigns\",\"statusCode\":400}}}},\"403\":{\"description\":\"Forbidden - Write access needed\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"Advertiser not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Delete an advertiser\",\"tags\":[\"Advertisers\"]}},\"/organizations/{organization_id}/advertisers/{id}/users\":{\"get\":{\"operationId\":\"AdvertisersController_advertisersOnUsers\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the advertiser\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"403\":{\"description\":\"Forbidden - Admin access needed\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"Advertiser not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get all users associated with an advertiser\",\"tags\":[\"Advertisers\"]}},\"/organizations/{organization_id}/advertisers/{id}/users/{user_id}\":{\"get\":{\"operationId\":\"AdvertisersController_advertisersOnUser\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the advertiser\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"user_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the user\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"403\":{\"description\":\"Forbidden - Admin access needed\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"Advertiser not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get a specific user association with an advertiser\",\"tags\":[\"Advertisers\"]}},\"/organizations/{organization_id}/advertisers/{id}/reporting/dashboard\":{\"get\":{\"operationId\":\"AdvertisersController_getDashboard\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the advertiser\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"campaign_id\",\"required\":false,\"in\":\"query\",\"description\":\"Campaign ID\",\"schema\":{\"type\":\"string\"}},{\"name\":\"line_item_id\",\"required\":false,\"in\":\"query\",\"description\":\"Line Item ID\",\"schema\":{\"type\":\"string\"}},{\"name\":\"creative_id\",\"required\":false,\"in\":\"query\",\"description\":\"Creative ID\",\"schema\":{\"type\":\"string\"}},{\"name\":\"group_by_fields\",\"required\":true,\"in\":\"query\",\"description\":\"Fields to group by\",\"schema\":{\"type\":\"array\",\"items\":{\"type\":\"string\"}}}],\"responses\":{\"200\":{\"description\":\"\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"advertiser_id\":{\"type\":\"string\",\"format\":\"uuid\"},\"spend\":{\"type\":\"number\"},\"impressions\":{\"type\":\"number\"},\"reach_person\":{\"type\":\"number\"},\"reach_household\":{\"type\":\"number\"},\"conversions\":{\"type\":\"number\"},\"conversion_rate\":{\"type\":\"number\"},\"conversions_value\":{\"type\":\"number\"},\"cpa\":{\"type\":\"number\"},\"roas\":{\"type\":\"number\"},\"group_fields\":{\"type\":\"object\",\"additionalProperties\":{\"type\":\"string\"}}},\"required\":[\"advertiser_id\",\"spend\",\"impressions\",\"reach_person\",\"reach_household\",\"conversions\",\"conversion_rate\",\"conversions_value\",\"cpa\",\"roas\",\"group_fields\"]}}}}},\"404\":{\"description\":\"Advertiser not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get dashboard data for reporting purposes for an advertiser\",\"tags\":[\"Advertisers\"]}},\"/organizations/{organization_id}/campaigns\":{\"post\":{\"operationId\":\"CampaignsController_create\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"requestBody\":{\"required\":true,\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"name\":{\"description\":\"The name of the campaign\",\"type\":\"string\",\"maxLength\":191,\"minLength\":4},\"active\":{\"description\":\"Whether the campaign should be active\",\"type\":\"boolean\",\"default\":true},\"start_datetime\":{\"description\":\"Start date and time for the campaign\",\"type\":\"string\",\"format\":\"date-time\"},\"end_datetime\":{\"description\":\"End date and time for the campaign\",\"type\":\"string\",\"format\":\"date-time\",\"nullable\":true},\"description\":{\"description\":\"A description for the campaign\",\"type\":\"string\",\"nullable\":true},\"budget\":{\"description\":\"The overall budget for the campaign\",\"type\":\"number\",\"minimum\":0,\"exclusiveMinimum\":true},\"daily_budget\":{\"description\":\"The daily budget for the campaign\",\"type\":\"number\",\"nullable\":true},\"vendor_fees\":{\"description\":\"Vendor fees for the campaign\",\"type\":\"array\",\"maxItems\":3,\"items\":{\"type\":\"object\",\"properties\":{\"vendor_id\":{\"type\":\"string\",\"format\":\"uuid\"},\"name\":{\"type\":\"string\",\"minLength\":1,\"maxLength\":191},\"type\":{\"type\":\"string\",\"enum\":[\"DEFAULT\",\"CPM\",\"PERCENTAGE\"],\"default\":\"DEFAULT\"},\"amount\":{\"description\":\"Required for non-default vendor fees\",\"type\":\"number\",\"nullable\":true}},\"required\":[\"vendor_id\",\"name\"],\"nullable\":true},\"nullable\":true},\"frequency_caps\":{\"description\":\"Frequency caps for the campaign\",\"type\":\"object\",\"properties\":{\"type\":{\"type\":\"string\",\"enum\":[\"STANDARD\",\"IP_ADDRESS\",\"PERSON_ID\",\"HOUSE_HOLD_ID\"],\"default\":\"STANDARD\"},\"use_fallback\":{\"type\":\"boolean\",\"default\":true},\"items\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"impressions\":{\"type\":\"number\",\"minimum\":1,\"exclusiveMinimum\":false},\"interval\":{\"type\":\"number\",\"minimum\":1,\"exclusiveMinimum\":false},\"time_unit\":{\"type\":\"string\",\"enum\":[\"DAY\",\"HOUR\",\"MINUTE\",\"WEEK\"],\"default\":\"DAY\"}},\"required\":[\"impressions\",\"interval\"]}}},\"required\":[\"items\"]},\"advertiser_id\":{\"description\":\"The ID of the advertiser the campaign refers to\",\"type\":\"string\",\"format\":\"uuid\"}},\"required\":[\"name\",\"start_datetime\",\"budget\",\"frequency_caps\",\"advertiser_id\"]}}}},\"responses\":{\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":[{\"code\":\"invalid_type\",\"expected\":\"boolean\",\"received\":\"undefined\",\"path\":[\"active\"],\"message\":\"Required\"}],\"statusCode\":400}}}},\"403\":{\"description\":\"Forbidden - Write access required\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"Advertiser not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Create a new campaign\",\"tags\":[\"Campaigns\"]},\"get\":{\"operationId\":\"CampaignsController_findAll\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"page\",\"required\":false,\"in\":\"query\",\"description\":\"Which page of results to fetch\",\"schema\":{\"default\":1,\"example\":\"1\",\"type\":\"string\"}},{\"name\":\"pageSize\",\"required\":false,\"in\":\"query\",\"description\":\"The size of a page of results to fetch\",\"schema\":{\"default\":10,\"example\":\"10\",\"type\":\"string\"}},{\"name\":\"search\",\"required\":true,\"in\":\"query\",\"description\":\"Search campaigns by name\",\"schema\":{\"type\":\"string\"}},{\"name\":\"active\",\"required\":true,\"in\":\"query\",\"description\":\"Filter campaigns by active status\",\"schema\":{}},{\"name\":\"status\",\"required\":true,\"in\":\"query\",\"description\":\"Filter campaigns by active status\",\"schema\":{\"type\":\"string\"}},{\"name\":\"associatedLineItems\",\"required\":true,\"in\":\"query\",\"description\":\"Filter campaigns that have an associated line item\",\"schema\":{\"type\":\"boolean\"}},{\"name\":\"edited_today\",\"required\":true,\"in\":\"query\",\"description\":\"Filter campaigns that have been edited today\",\"schema\":{\"type\":\"boolean\"}},{\"name\":\"ending_this_week\",\"required\":true,\"in\":\"query\",\"description\":\"Filter campaigns that end this week\",\"schema\":{\"type\":\"boolean\"}},{\"name\":\"out_of_budget\",\"required\":true,\"in\":\"query\",\"description\":\"Filter campaigns that are out of budget\",\"schema\":{\"type\":\"boolean\"}},{\"name\":\"start_datetime\",\"required\":true,\"in\":\"query\",\"description\":\"Filter campaigns by start date and time\",\"schema\":{\"format\":\"date-time\",\"type\":\"string\"}},{\"name\":\"end_datetime\",\"required\":true,\"in\":\"query\",\"description\":\"Filter campaigns by start date and time\",\"schema\":{\"format\":\"date-time\",\"type\":\"string\"}}],\"responses\":{\"200\":{\"description\":\"Successfully received model list\",\"content\":{\"application/json\":{\"schema\":{\"allOf\":[{\"type\":\"object\",\"properties\":{\"data\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"frequency_caps\":{\"type\":\"object\",\"properties\":{\"type\":{\"type\":\"string\",\"enum\":[\"STANDARD\",\"IP_ADDRESS\",\"PERSON_ID\",\"HOUSE_HOLD_ID\"],\"default\":\"STANDARD\"},\"use_fallback\":{\"type\":\"boolean\",\"default\":true},\"items\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"impressions\":{\"type\":\"number\",\"minimum\":1,\"exclusiveMinimum\":false},\"interval\":{\"type\":\"number\",\"minimum\":1,\"exclusiveMinimum\":false},\"time_unit\":{\"type\":\"string\",\"enum\":[\"DAY\",\"HOUR\",\"MINUTE\",\"WEEK\"],\"default\":\"DAY\"}},\"required\":[\"impressions\",\"interval\"]}}},\"required\":[\"items\"]},\"start_datetime\":{\"format\":\"date-time\",\"type\":\"string\",\"example\":1732795153},\"end_datetime\":{\"type\":\"object\",\"example\":173279515},\"budget_type\":{\"type\":\"string\",\"enum\":[\"SPEND_WITH_VENDOR_FEES\",\"SPEND\",\"IMPRESSION\"],\"example\":\"SPEND_WITH_VENDOR_FEES\",\"description\":\"The type of budget. Will always be SPEND_WITH_VENDOR_FEES\"}},\"required\":[\"frequency_caps\",\"start_datetime\",\"end_datetime\",\"budget_type\"]}},\"meta\":{\"type\":\"object\",\"properties\":{\"count\":{\"type\":\"number\"},\"lastPage\":{\"type\":\"number\"},\"currentPage\":{\"type\":\"number\"},\"totalPerPage\":{\"type\":\"number\"},\"prevPage\":{\"type\":\"number\",\"nullable\":true,\"example\":1},\"nextPage\":{\"type\":\"number\",\"nullable\":true,\"example\":null}},\"required\":[\"count\",\"lastPage\",\"currentPage\",\"totalPerPage\",\"prevPage\",\"nextPage\"]}}},{\"properties\":{\"data\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"frequency_caps\":{\"type\":\"object\",\"properties\":{\"type\":{\"type\":\"string\",\"enum\":[\"STANDARD\",\"IP_ADDRESS\",\"PERSON_ID\",\"HOUSE_HOLD_ID\"],\"default\":\"STANDARD\"},\"use_fallback\":{\"type\":\"boolean\",\"default\":true},\"items\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"impressions\":{\"type\":\"number\",\"minimum\":1,\"exclusiveMinimum\":false},\"interval\":{\"type\":\"number\",\"minimum\":1,\"exclusiveMinimum\":false},\"time_unit\":{\"type\":\"string\",\"enum\":[\"DAY\",\"HOUR\",\"MINUTE\",\"WEEK\"],\"default\":\"DAY\"}},\"required\":[\"impressions\",\"interval\"]}}},\"required\":[\"items\"]},\"start_datetime\":{\"format\":\"date-time\",\"type\":\"string\",\"example\":1732795153},\"end_datetime\":{\"type\":\"object\",\"example\":173279515},\"budget_type\":{\"type\":\"string\",\"enum\":[\"SPEND_WITH_VENDOR_FEES\",\"SPEND\",\"IMPRESSION\"],\"example\":\"SPEND_WITH_VENDOR_FEES\",\"description\":\"The type of budget. Will always be SPEND_WITH_VENDOR_FEES\"}},\"required\":[\"frequency_caps\",\"start_datetime\",\"end_datetime\",\"budget_type\"]}}}}]}}}},\"404\":{\"description\":\"Organization not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"List all campaigns\",\"tags\":[\"Campaigns\"]}},\"/organizations/{organization_id}/campaigns/{id}\":{\"get\":{\"operationId\":\"CampaignsController_findOne\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the campaign\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"404\":{\"description\":\"Campaign not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get campaign by ID\",\"tags\":[\"Campaigns\"]},\"patch\":{\"operationId\":\"CampaignsController_update\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the campaign\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"requestBody\":{\"required\":true,\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"name\":{\"description\":\"The name of the campaign\",\"type\":\"string\",\"maxLength\":191,\"minLength\":4},\"active\":{\"description\":\"Whether the campaign should be active\",\"type\":\"boolean\",\"default\":true},\"start_datetime\":{\"description\":\"Start date and time for the campaign\",\"type\":\"string\",\"format\":\"date-time\"},\"end_datetime\":{\"description\":\"End date and time for the campaign\",\"type\":\"string\",\"format\":\"date-time\",\"nullable\":true},\"description\":{\"description\":\"A description for the campaign\",\"type\":\"string\",\"nullable\":true},\"budget\":{\"description\":\"The overall budget for the campaign\",\"type\":\"number\",\"minimum\":0,\"exclusiveMinimum\":true},\"daily_budget\":{\"description\":\"The daily budget for the campaign\",\"type\":\"number\",\"nullable\":true},\"vendor_fees\":{\"description\":\"Vendor fees for the campaign\",\"type\":\"array\",\"maxItems\":3,\"items\":{\"type\":\"object\",\"properties\":{\"vendor_id\":{\"type\":\"string\",\"format\":\"uuid\"},\"name\":{\"type\":\"string\",\"minLength\":1,\"maxLength\":191},\"type\":{\"type\":\"string\",\"enum\":[\"DEFAULT\",\"CPM\",\"PERCENTAGE\"],\"default\":\"DEFAULT\"},\"amount\":{\"description\":\"Required for non-default vendor fees\",\"type\":\"number\",\"nullable\":true}},\"required\":[\"vendor_id\",\"name\"],\"nullable\":true},\"nullable\":true},\"frequency_caps\":{\"description\":\"Frequency caps for the campaign\",\"type\":\"object\",\"properties\":{\"type\":{\"type\":\"string\",\"enum\":[\"STANDARD\",\"IP_ADDRESS\",\"PERSON_ID\",\"HOUSE_HOLD_ID\"],\"default\":\"STANDARD\"},\"use_fallback\":{\"type\":\"boolean\",\"default\":true},\"items\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"impressions\":{\"type\":\"number\",\"minimum\":1,\"exclusiveMinimum\":false},\"interval\":{\"type\":\"number\",\"minimum\":1,\"exclusiveMinimum\":false},\"time_unit\":{\"type\":\"string\",\"enum\":[\"DAY\",\"HOUR\",\"MINUTE\",\"WEEK\"],\"default\":\"DAY\"}},\"required\":[\"impressions\",\"interval\"]}}},\"required\":[\"items\"]}}}}}},\"responses\":{\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":[{\"code\":\"invalid_type\",\"expected\":\"boolean\",\"received\":\"string\",\"path\":[\"active\"],\"message\":\"Required\"}],\"statusCode\":400}}}},\"403\":{\"description\":\"Forbidden - Write access required\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"Campaign not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Update a campaign\",\"tags\":[\"Campaigns\"]},\"delete\":{\"operationId\":\"CampaignsController_remove\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the campaign\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"403\":{\"description\":\"Forbidden - Write access required\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"Campaign not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Delete a campaign\",\"tags\":[\"Campaigns\"]}},\"/organizations/{organization_id}/advertisers/{id}/payment-methods\":{\"get\":{\"operationId\":\"PaymentMethodsController_getPaymentMethods\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the advertiser\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"200\":{\"description\":\"Payment methods retrieved successfully\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"default\":{\"type\":\"string\",\"nullable\":true,\"description\":\"ID of the default payment method\",\"example\":\"pm_1234567890abcdef\"},\"methods\":{\"type\":\"array\",\"description\":\"Array of payment methods\",\"items\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\",\"description\":\"Unique identifier for the payment method\",\"example\":\"pm_1234567890abcdef\"},\"type\":{\"type\":\"string\",\"description\":\"The type of the payment method\",\"example\":\"card\"},\"card\":{\"type\":\"object\",\"nullable\":true,\"description\":\"Card details if payment method is a card\",\"properties\":{\"brand\":{\"type\":\"string\",\"description\":\"Card brand\",\"example\":\"visa\"},\"last4\":{\"type\":\"string\",\"description\":\"Last four digits of the card\",\"example\":\"4242\"},\"exp_month\":{\"type\":\"number\",\"description\":\"Expiration month\",\"example\":12},\"exp_year\":{\"type\":\"number\",\"description\":\"Expiration year\",\"example\":2025}}},\"created\":{\"type\":\"number\",\"description\":\"Time at which the payment method was created (Unix timestamp)\",\"example\":1640995200},\"customer\":{\"type\":\"string\",\"nullable\":true,\"description\":\"ID of the customer this payment method belongs to\",\"example\":\"cus_1234567890abcdef\"}}}}}}}}},\"404\":{\"description\":\"Advertiser not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get all payment methods for an advertiser\",\"tags\":[\"Payment Methods\"]}},\"/organizations/{organization_id}/advertisers/{id}/payment-methods/{payment_method_id}\":{\"delete\":{\"operationId\":\"PaymentMethodsController_delete\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the advertiser\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"payment_method_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the payment method to delete\",\"schema\":{\"example\":\"pm_1234567890\",\"type\":\"string\"}}],\"responses\":{\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":\"There are campaigns still active\",\"statusCode\":400}}}},\"403\":{\"description\":\"Forbidden - Admin access required\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"Payment method not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Delete a payment method\",\"tags\":[\"Payment Methods\"]}},\"/organizations/{organization_id}/advertisers/{id}/payment-methods/{payment_method_id}/default\":{\"post\":{\"operationId\":\"PaymentMethodsController_setDefault\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the advertiser\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"payment_method_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the payment method to set as default\",\"schema\":{\"example\":\"pm_1234567890\",\"type\":\"string\"}}],\"responses\":{\"403\":{\"description\":\"Forbidden - Admin access required\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"Payment method not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Set a payment method as default\",\"tags\":[\"Payment Methods\"]}},\"/organizations/{organization_id}/line-items\":{\"post\":{\"operationId\":\"LineItemsController_create\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"schema\":{\"type\":\"string\"}}],\"requestBody\":{\"required\":true,\"description\":\"Create a new line item\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"name\":{\"description\":\"The name of the line item\",\"type\":\"string\"},\"description\":{\"description\":\"A description for the line item\",\"type\":\"string\",\"nullable\":true},\"active\":{\"description\":\"Whether the line item should be active\",\"type\":\"boolean\",\"default\":false},\"start_datetime\":{\"description\":\"The start date and time of the line item\"},\"end_datetime\":{\"description\":\"The end date and time of the line item\"},\"type\":{\"description\":\"The type of line item\",\"type\":\"string\",\"enum\":[\"VIDEO\",\"BANNER\",\"CTV\"],\"x-enumNames\":[\"VIDEO\",\"BANNER\",\"CTV\"]},\"advertiser_id\":{\"description\":\"The ID of the advertiser the line item refers to\",\"type\":\"string\",\"format\":\"uuid\"},\"campaign_id\":{\"description\":\"The ID of the campaign the line item refers to\",\"type\":\"string\",\"format\":\"uuid\"},\"budget_carryover\":{\"description\":\"The budget carry over policy of the line item\",\"type\":\"string\",\"enum\":[\"NONE\",\"CARRY_OVER\",\"EVENLY_DISTRIBUTE\",\"PRORATED_DISTRIBUTE\"],\"x-enumNames\":[\"NONE\",\"CARRY_OVER\",\"EVENLY_DISTRIBUTE\",\"PRORATED_DISTRIBUTE\"],\"default\":\"NONE\"}},\"required\":[\"name\",\"start_datetime\",\"end_datetime\",\"type\",\"advertiser_id\",\"campaign_id\"]}}}},\"responses\":{\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":[{\"code\":\"invalid_type\",\"expected\":\"boolean\",\"received\":\"undefined\",\"path\":[\"active\"],\"message\":\"Required\"}],\"statusCode\":400}}}},\"403\":{\"description\":\"Forbidden - Write access required\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"Advertiser not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Create a new line item\",\"tags\":[\"Line Items\"]},\"get\":{\"operationId\":\"LineItemsController_findAll\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"page\",\"required\":false,\"in\":\"query\",\"description\":\"Which page of results to fetch\",\"schema\":{\"default\":1,\"example\":\"1\",\"type\":\"string\"}},{\"name\":\"pageSize\",\"required\":false,\"in\":\"query\",\"description\":\"The size of a page of results to fetch\",\"schema\":{\"default\":10,\"example\":\"10\",\"type\":\"string\"}},{\"name\":\"search\",\"required\":true,\"in\":\"query\",\"description\":\"Search by name\",\"schema\":{\"type\":\"string\"}},{\"name\":\"active\",\"required\":true,\"in\":\"query\",\"description\":\"Filter by active status\",\"schema\":{}},{\"name\":\"status\",\"required\":true,\"in\":\"query\",\"description\":\"Filter by active status\",\"schema\":{\"type\":\"string\",\"enum\":[\"inactive\",\"all\",\"active\"]}},{\"name\":\"start_datetime\",\"required\":true,\"in\":\"query\",\"description\":\"Filter by start date and time\",\"schema\":{\"format\":\"date-time\",\"type\":\"string\"}},{\"name\":\"end_datetime\",\"required\":true,\"in\":\"query\",\"description\":\"Filter by end date and time\",\"schema\":{\"format\":\"date-time\",\"type\":\"string\"}},{\"name\":\"advertiser_id\",\"required\":true,\"in\":\"query\",\"description\":\"Filter by advertiser ID\",\"schema\":{\"type\":\"string\"}},{\"name\":\"campaign_id\",\"required\":true,\"in\":\"query\",\"description\":\"Filter by campaign ID\",\"schema\":{\"type\":\"string\"}},{\"name\":\"creative_id\",\"required\":true,\"in\":\"query\",\"description\":\"Filter by creative ID\",\"schema\":{\"type\":\"string\"}}],\"responses\":{\"200\":{\"description\":\"Successfully received model list\",\"content\":{\"application/json\":{\"schema\":{\"allOf\":[{\"type\":\"object\",\"properties\":{\"data\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"effective_status\":{\"type\":\"string\",\"enum\":[\"DELIVERING\",\"DELIVERED\",\"STOPPED\",\"INACTIVE\",\"UNKNOWN\"]},\"type\":{\"type\":\"string\",\"enum\":[\"VIDEO\",\"BANNER\",\"CTV\"]},\"budget_carryover\":{\"type\":\"string\",\"enum\":[\"NONE\",\"CARRY_OVER\",\"EVENLY_DISTRIBUTE\",\"PRORATED_DISTRIBUTE\"]},\"bidding_strategy\":{\"type\":\"object\",\"properties\":{\"type\":{\"type\":\"string\",\"enum\":[\"FLAT_CPM\",\"CPC\",\"CPA\"],\"x-enumNames\":[\"FLAT_CPM\",\"CPC\",\"CPA\"],\"default\":\"FLAT_CPM\"},\"bid_shading_control\":{\"type\":\"string\",\"enum\":[\"NORMAL\",\"LESS_AGGRESSIVE\",\"MORE_AGGRESSIVE\"],\"x-enumNames\":[\"NORMAL\",\"LESS_AGGRESSIVE\",\"MORE_AGGRESSIVE\"]},\"cpm\":{\"type\":\"number\"}},\"required\":[\"bid_shading_control\",\"cpm\"]},\"pacing_strategy\":{\"type\":\"object\",\"properties\":{\"type\":{\"type\":\"string\",\"enum\":[\"DAILY\",\"LIFETIME\",\"FLIGHT\"],\"x-enumNames\":[\"Daily\",\"Lifetime\",\"Flight\"],\"default\":\"LIFETIME\"},\"pacing_behavior\":{\"type\":\"string\",\"enum\":[\"EVEN\",\"AHEAD\"],\"x-enumNames\":[\"Even\",\"Ahead\"],\"default\":\"EVEN\"},\"catchup_behavior\":{\"type\":\"string\",\"enum\":[\"EVEN\",\"IMMEDIATE\",\"SMOOTH\"],\"x-enumNames\":[\"Even\",\"Immediate\",\"Smooth\"],\"default\":\"EVEN\"},\"multiplier\":{\"type\":\"number\",\"nullable\":true,\"default\":1}}},\"frequency_caps\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"type\":{\"type\":\"string\",\"enum\":[\"STANDARD\",\"IP_ADDRESS\",\"PERSON_ID\",\"HOUSE_HOLD_ID\"],\"default\":\"STANDARD\"},\"use_fallback\":{\"type\":\"boolean\",\"default\":true},\"items\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"impressions\":{\"type\":\"number\",\"minimum\":1,\"exclusiveMinimum\":false},\"interval\":{\"type\":\"number\",\"minimum\":1,\"exclusiveMinimum\":false},\"time_unit\":{\"type\":\"string\",\"enum\":[\"DAY\",\"HOUR\",\"MINUTE\",\"WEEK\"],\"default\":\"DAY\"}},\"required\":[\"impressions\",\"interval\"]}}},\"required\":[\"items\"]}},\"budget_type\":{\"type\":\"string\",\"enum\":[\"SPEND_WITH_VENDOR_FEES\",\"SPEND\",\"IMPRESSION\"]}},\"required\":[\"effective_status\",\"type\",\"budget_carryover\",\"bidding_strategy\",\"pacing_strategy\",\"frequency_caps\",\"budget_type\"]}},\"meta\":{\"type\":\"object\",\"properties\":{\"count\":{\"type\":\"number\"},\"lastPage\":{\"type\":\"number\"},\"currentPage\":{\"type\":\"number\"},\"totalPerPage\":{\"type\":\"number\"},\"prevPage\":{\"type\":\"number\",\"nullable\":true,\"example\":1},\"nextPage\":{\"type\":\"number\",\"nullable\":true,\"example\":null}},\"required\":[\"count\",\"lastPage\",\"currentPage\",\"totalPerPage\",\"prevPage\",\"nextPage\"]}}},{\"properties\":{\"data\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"effective_status\":{\"type\":\"string\",\"enum\":[\"DELIVERING\",\"DELIVERED\",\"STOPPED\",\"INACTIVE\",\"UNKNOWN\"]},\"type\":{\"type\":\"string\",\"enum\":[\"VIDEO\",\"BANNER\",\"CTV\"]},\"budget_carryover\":{\"type\":\"string\",\"enum\":[\"NONE\",\"CARRY_OVER\",\"EVENLY_DISTRIBUTE\",\"PRORATED_DISTRIBUTE\"]},\"bidding_strategy\":{\"type\":\"object\",\"properties\":{\"type\":{\"type\":\"string\",\"enum\":[\"FLAT_CPM\",\"CPC\",\"CPA\"],\"x-enumNames\":[\"FLAT_CPM\",\"CPC\",\"CPA\"],\"default\":\"FLAT_CPM\"},\"bid_shading_control\":{\"type\":\"string\",\"enum\":[\"NORMAL\",\"LESS_AGGRESSIVE\",\"MORE_AGGRESSIVE\"],\"x-enumNames\":[\"NORMAL\",\"LESS_AGGRESSIVE\",\"MORE_AGGRESSIVE\"]},\"cpm\":{\"type\":\"number\"}},\"required\":[\"bid_shading_control\",\"cpm\"]},\"pacing_strategy\":{\"type\":\"object\",\"properties\":{\"type\":{\"type\":\"string\",\"enum\":[\"DAILY\",\"LIFETIME\",\"FLIGHT\"],\"x-enumNames\":[\"Daily\",\"Lifetime\",\"Flight\"],\"default\":\"LIFETIME\"},\"pacing_behavior\":{\"type\":\"string\",\"enum\":[\"EVEN\",\"AHEAD\"],\"x-enumNames\":[\"Even\",\"Ahead\"],\"default\":\"EVEN\"},\"catchup_behavior\":{\"type\":\"string\",\"enum\":[\"EVEN\",\"IMMEDIATE\",\"SMOOTH\"],\"x-enumNames\":[\"Even\",\"Immediate\",\"Smooth\"],\"default\":\"EVEN\"},\"multiplier\":{\"type\":\"number\",\"nullable\":true,\"default\":1}}},\"frequency_caps\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"type\":{\"type\":\"string\",\"enum\":[\"STANDARD\",\"IP_ADDRESS\",\"PERSON_ID\",\"HOUSE_HOLD_ID\"],\"default\":\"STANDARD\"},\"use_fallback\":{\"type\":\"boolean\",\"default\":true},\"items\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"impressions\":{\"type\":\"number\",\"minimum\":1,\"exclusiveMinimum\":false},\"interval\":{\"type\":\"number\",\"minimum\":1,\"exclusiveMinimum\":false},\"time_unit\":{\"type\":\"string\",\"enum\":[\"DAY\",\"HOUR\",\"MINUTE\",\"WEEK\"],\"default\":\"DAY\"}},\"required\":[\"impressions\",\"interval\"]}}},\"required\":[\"items\"]}},\"budget_type\":{\"type\":\"string\",\"enum\":[\"SPEND_WITH_VENDOR_FEES\",\"SPEND\",\"IMPRESSION\"]}},\"required\":[\"effective_status\",\"type\",\"budget_carryover\",\"bidding_strategy\",\"pacing_strategy\",\"frequency_caps\",\"budget_type\"]}}}}]}}}},\"404\":{\"description\":\"Organization not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"List all line items\",\"tags\":[\"Line Items\"]}},\"/organizations/{organization_id}/line-items/{id}\":{\"get\":{\"operationId\":\"LineItemsController_findOne\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the line item\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"404\":{\"description\":\"Line item not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get a line item by ID\",\"tags\":[\"Line Items\"]},\"patch\":{\"operationId\":\"LineItemsController_update\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the line item\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"requestBody\":{\"required\":true,\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"name\":{\"description\":\"The name of the line item\",\"type\":\"string\"},\"description\":{\"description\":\"A description for the line item\",\"type\":\"string\",\"nullable\":true},\"active\":{\"description\":\"Whether the line item should be active\",\"type\":\"boolean\",\"default\":false},\"start_datetime\":{\"description\":\"The start date and time of the line item\"},\"end_datetime\":{\"description\":\"The end date and time of the line item\"},\"type\":{\"description\":\"The type of line item\",\"type\":\"string\",\"enum\":[\"VIDEO\",\"BANNER\",\"CTV\"],\"x-enumNames\":[\"VIDEO\",\"BANNER\",\"CTV\"]},\"budget_carryover\":{\"description\":\"The budget carry over policy of the line item\",\"type\":\"string\",\"enum\":[\"NONE\",\"CARRY_OVER\",\"EVENLY_DISTRIBUTE\",\"PRORATED_DISTRIBUTE\"],\"x-enumNames\":[\"NONE\",\"CARRY_OVER\",\"EVENLY_DISTRIBUTE\",\"PRORATED_DISTRIBUTE\"],\"default\":\"NONE\"},\"budget_type\":{\"description\":\"The type of budget of the line item\",\"type\":\"string\",\"enum\":[\"SPEND_WITH_VENDOR_FEES\",\"SPEND\",\"IMPRESSION\"],\"x-enumNames\":[\"SPEND_WITH_VENDOR_FEES\",\"SPEND\",\"IMPRESSION\"],\"nullable\":true,\"default\":\"SPEND_WITH_VENDOR_FEES\"},\"overall_budget\":{\"description\":\"The overall budget of the line item\",\"type\":\"number\",\"minimum\":0,\"exclusiveMinimum\":true,\"nullable\":true},\"daily_budget\":{\"description\":\"The daily budget of the line item\",\"type\":\"number\",\"nullable\":true},\"bidding_strategy\":{\"description\":\"The bidding strategy of the line item\",\"type\":\"object\",\"properties\":{\"type\":{\"type\":\"string\",\"enum\":[\"FLAT_CPM\",\"CPC\",\"CPA\"],\"x-enumNames\":[\"FLAT_CPM\",\"CPC\",\"CPA\"],\"default\":\"FLAT_CPM\"},\"bid_shading_control\":{\"type\":\"string\",\"enum\":[\"NORMAL\",\"LESS_AGGRESSIVE\",\"MORE_AGGRESSIVE\"],\"x-enumNames\":[\"NORMAL\",\"LESS_AGGRESSIVE\",\"MORE_AGGRESSIVE\"]},\"cpm\":{\"type\":\"number\"}},\"required\":[\"bid_shading_control\",\"cpm\"]},\"pacing_strategy\":{\"description\":\"The pacing strategy of the line item\",\"type\":\"object\",\"properties\":{\"type\":{\"type\":\"string\",\"enum\":[\"DAILY\",\"LIFETIME\",\"FLIGHT\"],\"x-enumNames\":[\"Daily\",\"Lifetime\",\"Flight\"],\"default\":\"LIFETIME\"},\"pacing_behavior\":{\"type\":\"string\",\"enum\":[\"EVEN\",\"AHEAD\"],\"x-enumNames\":[\"Even\",\"Ahead\"],\"default\":\"EVEN\"},\"catchup_behavior\":{\"type\":\"string\",\"enum\":[\"EVEN\",\"IMMEDIATE\",\"SMOOTH\"],\"x-enumNames\":[\"Even\",\"Immediate\",\"Smooth\"],\"default\":\"EVEN\"},\"multiplier\":{\"type\":\"number\",\"nullable\":true,\"default\":1}}},\"vendor_fees\":{\"description\":\"The vendor fees of the line item\",\"type\":\"array\",\"maxItems\":3,\"items\":{\"type\":\"object\",\"properties\":{\"vendor_id\":{\"type\":\"string\",\"format\":\"uuid\"},\"name\":{\"type\":\"string\",\"minLength\":1,\"maxLength\":191},\"type\":{\"type\":\"string\",\"enum\":[\"DEFAULT\",\"CPM\",\"PERCENTAGE\"],\"default\":\"DEFAULT\"},\"amount\":{\"description\":\"Required for non-default vendor fees\",\"type\":\"number\",\"nullable\":true}},\"required\":[\"vendor_id\",\"name\"],\"nullable\":true}},\"frequency_caps\":{\"description\":\"The frequency caps of the line item\",\"type\":\"object\",\"properties\":{\"type\":{\"type\":\"string\",\"enum\":[\"STANDARD\",\"IP_ADDRESS\",\"PERSON_ID\",\"HOUSE_HOLD_ID\"],\"default\":\"STANDARD\"},\"use_fallback\":{\"type\":\"boolean\",\"default\":true},\"items\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"impressions\":{\"type\":\"number\",\"minimum\":1,\"exclusiveMinimum\":false},\"interval\":{\"type\":\"number\",\"minimum\":1,\"exclusiveMinimum\":false},\"time_unit\":{\"type\":\"string\",\"enum\":[\"DAY\",\"HOUR\",\"MINUTE\",\"WEEK\"],\"default\":\"DAY\"}},\"required\":[\"impressions\",\"interval\"]}}},\"required\":[\"items\"]}}}}}},\"responses\":{\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":[{\"code\":\"invalid_type\",\"expected\":\"boolean\",\"received\":\"undefined\",\"path\":[\"active\"],\"message\":\"Required\"}],\"statusCode\":400}}}},\"403\":{\"description\":\"Forbidden - Write access required\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"Line item not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Update a line item\",\"tags\":[\"Line Items\"]},\"delete\":{\"operationId\":\"LineItemsController_remove\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the line item\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":[{\"code\":\"invalid_type\",\"expected\":\"boolean\",\"received\":\"undefined\",\"path\":[\"active\"],\"message\":\"Required\"}],\"statusCode\":400}}}},\"403\":{\"description\":\"Forbidden - Write access required\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"Line item not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Delete a line item\",\"tags\":[\"Line Items\"]}},\"/organizations/{organization_id}/line-items/{id}/audience\":{\"patch\":{\"operationId\":\"LineItemsController_audience\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the line item\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"requestBody\":{\"required\":true,\"description\":\"Audience targeting data\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"prompt\":{\"type\":\"string\",\"nullable\":true},\"include\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\",\"format\":\"uuid\"},\"audience_schema_key_id\":{\"type\":\"string\",\"format\":\"uuid\"}},\"required\":[\"id\",\"audience_schema_key_id\"]}},\"exclude\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\",\"format\":\"uuid\"},\"audience_schema_key_id\":{\"type\":\"string\",\"format\":\"uuid\"}},\"required\":[\"id\",\"audience_schema_key_id\"]}}},\"required\":[\"include\",\"exclude\"]}}}},\"responses\":{\"403\":{\"description\":\"Forbidden - Write access required\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"Line item not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Update a line item audience targeting\",\"tags\":[\"Line Items\"]}},\"/organizations/{organization_id}/line-items/{id}/audience/stats\":{\"post\":{\"operationId\":\"LineItemsController_audience_stats\",\"parameters\":[{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the line item\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"requestBody\":{\"required\":true,\"description\":\"Audience stats query parameters\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"first_party_audience_filter\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\",\"format\":\"uuid\"},\"included\":{\"type\":\"boolean\"}},\"required\":[\"id\",\"included\"]}},\"audience_filter\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"name\":{\"type\":\"string\"},\"values\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\",\"format\":\"uuid\"},\"included\":{\"type\":\"boolean\"}},\"required\":[\"id\",\"included\"]}}},\"required\":[\"name\",\"values\"]}},\"days\":{\"type\":\"integer\",\"minimum\":1,\"exclusiveMinimum\":false}},\"required\":[\"first_party_audience_filter\",\"audience_filter\"]}}}},\"responses\":{\"404\":{\"description\":\"Line item not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get audience statistics for a line item\",\"tags\":[\"Line Items\"]}},\"/organizations/{organization_id}/line-items/{id}/inventory\":{\"patch\":{\"operationId\":\"LineItemsController_inventory\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the line item\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"requestBody\":{\"required\":true,\"description\":\"Inventory targeting data\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"include\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\",\"format\":\"uuid\"},\"inventory_schema_key_id\":{\"type\":\"string\",\"format\":\"uuid\"}},\"required\":[\"id\",\"inventory_schema_key_id\"]}},\"exclude\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\",\"format\":\"uuid\"},\"inventory_schema_key_id\":{\"type\":\"string\",\"format\":\"uuid\"}},\"required\":[\"id\",\"inventory_schema_key_id\"]}}},\"required\":[\"include\",\"exclude\"]}}}},\"responses\":{\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":[{\"code\":\"invalid_type\",\"expected\":\"boolean\",\"received\":\"undefined\",\"path\":[\"active\"],\"message\":\"Required\"}],\"statusCode\":400}}}},\"403\":{\"description\":\"Forbidden - Write access required\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"Line item not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Update a line item inventory targeting\",\"tags\":[\"Line Items\"]}},\"/organizations/{organization_id}/line-items/{id}/first_part_audience\":{\"patch\":{\"operationId\":\"LineItemsController_first_part_audience\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the line item\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"requestBody\":{\"required\":true,\"description\":\"First party audience targeting data\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"include\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\",\"format\":\"uuid\"},\"audience_custom_list_schema_key_id\":{\"type\":\"string\",\"format\":\"uuid\"}},\"required\":[\"id\",\"audience_custom_list_schema_key_id\"]}},\"exclude\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\",\"format\":\"uuid\"},\"audience_custom_list_schema_key_id\":{\"type\":\"string\",\"format\":\"uuid\"}},\"required\":[\"id\",\"audience_custom_list_schema_key_id\"]}}},\"required\":[\"include\",\"exclude\"]}}}},\"responses\":{\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":[{\"code\":\"invalid_type\",\"expected\":\"boolean\",\"received\":\"undefined\",\"path\":[\"active\"],\"message\":\"Required\"}],\"statusCode\":400}}}},\"403\":{\"description\":\"Forbidden - Write access required\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"Line item not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Update line item first party audience targeting\",\"tags\":[\"Line Items\"]}},\"/organizations/{organization_id}/line-items/{id}/creatives\":{\"get\":{\"operationId\":\"LineItemsController_creatives\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the line item\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"404\":{\"description\":\"Line item not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get creatives associated with a line item\",\"tags\":[\"Line Items\"]},\"post\":{\"operationId\":\"LineItemsController_connectCreatives\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the line item\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"requestBody\":{\"required\":true,\"description\":\"Creative IDs to connect\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"creative_id\":{\"type\":\"string\",\"format\":\"uuid\"},\"weight\":{\"type\":\"number\",\"nullable\":true},\"start_datetime\":{\"type\":\"string\",\"format\":\"date-time\",\"nullable\":true},\"end_datetime\":{\"type\":\"string\",\"format\":\"date-time\",\"nullable\":true}},\"required\":[\"creative_id\",\"weight\"]}}}}},\"responses\":{\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":[{\"code\":\"invalid_type\",\"expected\":\"boolean\",\"received\":\"undefined\",\"path\":[\"active\"],\"message\":\"Required\"}],\"statusCode\":400}}}},\"403\":{\"description\":\"Forbidden - Write access required\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"Line item not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Connect creatives to a line item\",\"tags\":[\"Line Items\"]}},\"/organizations/{organization_id}/line-items/{id}/flights\":{\"get\":{\"operationId\":\"LineItemsController_getFlights\",\"parameters\":[{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the line item\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"404\":{\"description\":\"Line item not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get the flights of a line item\",\"tags\":[\"Line Items\"]},\"put\":{\"operationId\":\"LineItemsController_updateFlights\",\"parameters\":[{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the line item\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"requestBody\":{\"required\":true,\"description\":\"Flights data\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"id\":{\"description\":\"The ID of the flight\",\"type\":\"string\",\"format\":\"uuid\"},\"name\":{\"description\":\"The name of the flight\",\"type\":\"string\"},\"start_datetime\":{\"description\":\"The start date and time of the flight\",\"type\":\"string\",\"format\":\"date-time\"},\"end_datetime\":{\"description\":\"The end date and tieme of the flight\",\"type\":\"string\",\"format\":\"date-time\"},\"budget\":{\"description\":\"The budget of the flight\",\"type\":\"number\"}},\"required\":[\"name\",\"start_datetime\",\"end_datetime\",\"budget\"]}}}}},\"responses\":{\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":[{\"code\":\"invalid_type\",\"expected\":\"boolean\",\"received\":\"undefined\",\"path\":[\"active\"],\"message\":\"Required\"}],\"statusCode\":400}}}},\"403\":{\"description\":\"Forbidden - Write access required\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"Line item not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Update the flights of a line item\",\"tags\":[\"Line Items\"]}},\"/organizations/{organization_id}/creatives\":{\"post\":{\"operationId\":\"CreativesController_create\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"requestBody\":{\"required\":true,\"description\":\"Data to create a creative\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"name\":{\"description\":\"The name of the creative\",\"type\":\"string\",\"maxLength\":191,\"minLength\":1},\"type\":{\"description\":\"The type of the creative\",\"type\":\"string\",\"enum\":[\"VIDEO\",\"BANNER\"],\"x-enumNames\":[\"VIDEO\",\"BANNER\"]},\"active\":{\"description\":\"Whether the creative is active\",\"type\":\"boolean\",\"default\":true},\"click_url\":{\"description\":\"The click url of the creative\",\"type\":\"string\",\"format\":\"uri\"},\"landing_page_url\":{\"description\":\"The landing page url of the creative\"},\"third_party_pixels\":{\"description\":\"Optional third party pixels to trigger for the creative\",\"type\":\"array\",\"maxItems\":5,\"items\":{\"type\":\"string\",\"format\":\"uri\"}},\"start_datetime\":{\"description\":\"The start date and time of the creative\",\"type\":\"string\",\"format\":\"date-time\",\"nullable\":true},\"end_datetime\":{\"description\":\"The end date and time of the creative\",\"type\":\"string\",\"format\":\"date-time\",\"nullable\":true},\"description\":{\"description\":\"The description of the creative\",\"type\":\"string\",\"nullable\":true},\"advertiser_id\":{\"description\":\"The ID of the advertiser the creative refers to\",\"type\":\"string\",\"format\":\"uuid\"}},\"required\":[\"name\",\"type\",\"click_url\",\"advertiser_id\"]}}}},\"responses\":{\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":[{\"code\":\"invalid_type\",\"expected\":\"string\",\"received\":\"undefined\",\"path\":[\"type\"],\"message\":\"Required\"}],\"statusCode\":400}}}},\"403\":{\"description\":\"Forbidden - Write access required\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404,\"description\":\"Advertiser not found\"}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Create a new creative\",\"tags\":[\"Creatives\"]},\"get\":{\"operationId\":\"CreativesController_findAll\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"page\",\"required\":false,\"in\":\"query\",\"description\":\"Which page of results to fetch\",\"schema\":{\"default\":1,\"example\":\"1\",\"type\":\"string\"}},{\"name\":\"pageSize\",\"required\":false,\"in\":\"query\",\"description\":\"The size of a page of results to fetch\",\"schema\":{\"default\":10,\"example\":\"10\",\"type\":\"string\"}},{\"name\":\"search\",\"required\":false,\"in\":\"query\",\"description\":\"Search term for filtering creatives\",\"schema\":{\"example\":\"holiday campaign\",\"type\":\"string\"}},{\"name\":\"active\",\"required\":false,\"in\":\"query\",\"description\":\"Filter by active status\",\"schema\":{\"example\":true,\"type\":\"boolean\"}},{\"name\":\"type\",\"required\":false,\"in\":\"query\",\"description\":\"Filter by media asset type\",\"schema\":{\"example\":\"BANNER\",\"type\":\"string\",\"enum\":[\"VIDEO\",\"BANNER\"]}},{\"name\":\"start_datetime\",\"required\":false,\"in\":\"query\",\"description\":\"Start date for filtering (ISO string)\",\"schema\":{\"example\":\"2024-01-01T00:00:00.000Z\",\"type\":\"string\"}},{\"name\":\"end_datetime\",\"required\":false,\"in\":\"query\",\"description\":\"End date for filtering (ISO string)\",\"schema\":{\"example\":\"2024-12-31T23:59:59.999Z\",\"type\":\"string\"}},{\"name\":\"advertiser_id\",\"required\":false,\"in\":\"query\",\"description\":\"Filter by advertiser ID\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"campaign_id\",\"required\":false,\"in\":\"query\",\"description\":\"Filter by campaign ID\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174001\",\"type\":\"string\"}},{\"name\":\"line_item_id\",\"required\":false,\"in\":\"query\",\"description\":\"Filter by line item ID\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174002\",\"type\":\"string\"}}],\"responses\":{\"200\":{\"description\":\"Successfully received model list\",\"content\":{\"application/json\":{\"schema\":{\"allOf\":[{\"type\":\"object\",\"properties\":{\"data\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"type\":{\"type\":\"string\",\"enum\":[\"VIDEO\",\"BANNER\"]},\"active\":{\"type\":\"boolean\",\"example\":false},\"ad_tag_creation_status\":{\"type\":\"string\",\"enum\":[\"IN_PROGRESS\",\"SUCCEEDED\",\"FAILED\",\"UNKNOWN\"]}},\"required\":[\"type\",\"active\",\"ad_tag_creation_status\"]}},\"meta\":{\"type\":\"object\",\"properties\":{\"count\":{\"type\":\"number\"},\"lastPage\":{\"type\":\"number\"},\"currentPage\":{\"type\":\"number\"},\"totalPerPage\":{\"type\":\"number\"},\"prevPage\":{\"type\":\"number\",\"nullable\":true,\"example\":1},\"nextPage\":{\"type\":\"number\",\"nullable\":true,\"example\":null}},\"required\":[\"count\",\"lastPage\",\"currentPage\",\"totalPerPage\",\"prevPage\",\"nextPage\"]}}},{\"properties\":{\"data\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"type\":{\"type\":\"string\",\"enum\":[\"VIDEO\",\"BANNER\"]},\"active\":{\"type\":\"boolean\",\"example\":false},\"ad_tag_creation_status\":{\"type\":\"string\",\"enum\":[\"IN_PROGRESS\",\"SUCCEEDED\",\"FAILED\",\"UNKNOWN\"]}},\"required\":[\"type\",\"active\",\"ad_tag_creation_status\"]}}}}]}}}},\"404\":{\"description\":\"\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404,\"description\":\"Organization not found\"}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"List all creatives\",\"tags\":[\"Creatives\"]}},\"/organizations/{organization_id}/creatives/{id}\":{\"get\":{\"operationId\":\"CreativesController_findOne\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the creative\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"404\":{\"description\":\"\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404,\"description\":\"Creative not found\"}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get a creative by ID\",\"tags\":[\"Creatives\"]},\"patch\":{\"operationId\":\"CreativesController_update\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the creative\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"requestBody\":{\"required\":true,\"description\":\"Update creative data\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"name\":{\"description\":\"The name of the creative\",\"type\":\"string\",\"maxLength\":191,\"minLength\":1},\"active\":{\"description\":\"Whether the creative is active\",\"type\":\"boolean\",\"default\":true},\"click_url\":{\"description\":\"The click url of the creative\",\"type\":\"string\",\"format\":\"uri\"},\"landing_page_url\":{\"description\":\"The landing page url of the creative\"},\"third_party_pixels\":{\"description\":\"Optional third party pixels to trigger for the creative\",\"type\":\"array\",\"maxItems\":5,\"items\":{\"type\":\"string\",\"format\":\"uri\"}},\"start_datetime\":{\"description\":\"The start date and time of the creative\",\"type\":\"string\",\"format\":\"date-time\",\"nullable\":true},\"end_datetime\":{\"description\":\"The end date and time of the creative\",\"type\":\"string\",\"format\":\"date-time\",\"nullable\":true},\"description\":{\"description\":\"The description of the creative\",\"type\":\"string\",\"nullable\":true}}}}}},\"responses\":{\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":[{\"code\":\"invalid_type\",\"expected\":\"string\",\"received\":\"undefined\",\"path\":[\"type\"],\"message\":\"Required\"}],\"statusCode\":400}}}},\"403\":{\"description\":\"Forbidden - Write access required\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404,\"description\":\"Creative not found\"}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Update a creative\",\"tags\":[\"Creatives\"]},\"delete\":{\"operationId\":\"CreativesController_remove\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the creative\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"403\":{\"description\":\"Forbidden - Write access required\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404,\"description\":\"Creative not found\"}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Delete creative\",\"tags\":[\"Creatives\"]}},\"/organizations/{organization_id}/creatives/{id}/approval\":{\"get\":{\"operationId\":\"CreativesController_getApproval\",\"parameters\":[{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the creative\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"404\":{\"description\":\"\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404,\"description\":\"Creative not found\"}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get the approval status of a creative\",\"tags\":[\"Creatives\"]}},\"/organizations/{organization_id}/creatives/{id}/upload\":{\"post\":{\"operationId\":\"CreativesController_upload\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the creative\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"requestBody\":{\"required\":true,\"description\":\"Creative asset file\",\"content\":{\"multipart/form-data\":{\"schema\":{\"type\":\"object\",\"properties\":{\"file\":{\"type\":\"string\",\"format\":\"binary\",\"description\":\"The creative asset file (image or video)\"}}}}}},\"responses\":{\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Invalid file provided\",\"statusCode\":400}}}},\"403\":{\"description\":\"Forbidden - Write access required\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404,\"description\":\"Creative not found\"}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Upload creative asset\",\"tags\":[\"Creatives\"]}},\"/organizations/{organization_id}/creatives/{id}/line-items\":{\"get\":{\"operationId\":\"CreativesController_lineItems\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the creative\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"404\":{\"description\":\"\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404,\"description\":\"Creative not found\"}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get line items associated with creative\",\"tags\":[\"Creatives\"]},\"post\":{\"operationId\":\"CreativesController_connectLineItems\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the creative\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"requestBody\":{\"required\":true,\"description\":\"Line item IDs to connect\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"line_item_id\":{\"type\":\"string\",\"format\":\"uuid\"},\"start_datetime\":{\"type\":\"string\",\"format\":\"date-time\",\"nullable\":true},\"end_datetime\":{\"type\":\"string\",\"format\":\"date-time\",\"nullable\":true},\"weight\":{\"type\":\"number\",\"maximum\":100,\"exclusiveMaximum\":false,\"minimum\":0,\"exclusiveMinimum\":false}},\"required\":[\"line_item_id\",\"weight\"]}}}}},\"responses\":{\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":[{\"code\":\"invalid_type\",\"expected\":\"string\",\"received\":\"undefined\",\"path\":[\"line_item_id\"],\"message\":\"Required\"}],\"statusCode\":400}}}},\"403\":{\"description\":\"Forbidden - Write access required\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404,\"description\":\"Creative not found\"}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Connect line items to creative\",\"tags\":[\"Creatives\"]}},\"/ref/advertiser_categories\":{\"get\":{\"description\":\"Retrieve all available advertiser categories for ad targeting\",\"operationId\":\"StaticsController_advertiser_categories\",\"parameters\":[],\"responses\":{\"200\":{\"description\":\"\"}},\"summary\":\"Get advertiser categories\",\"tags\":[\"Reference resources\"]}},\"/ref/audience/prompt\":{\"post\":{\"description\":\"Use AI to generate audience targeting filters based on a natural language prompt. Requires authentication.\",\"operationId\":\"StaticsController_audiencePrompt\",\"parameters\":[],\"requestBody\":{\"required\":true,\"description\":\"Natural language prompt to generate audience filter\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"prompt\":{\"type\":\"string\",\"example\":\"Target young adults aged 18-34 interested in technology and gaming\",\"description\":\"Natural language description of the desired audience\"}},\"required\":[\"prompt\"]}}}},\"responses\":{\"200\":{\"description\":\"\"}},\"summary\":\"Generate audience filter from AI prompt\",\"tags\":[\"Reference resources\"]}},\"/ref/audience_schema_keys\":{\"get\":{\"description\":\"Retrieve all available audience schema keys for targeting configuration\",\"operationId\":\"StaticsController_audience_schema_keys\",\"parameters\":[],\"responses\":{\"200\":{\"description\":\"\"}},\"summary\":\"Get audience schema keys\",\"tags\":[\"Reference resources\"]}},\"/ref/audience_schema_keys/{id}/values\":{\"get\":{\"description\":\"Retrieve all available values for a specific audience schema key\",\"operationId\":\"StaticsController_audience_schema_key_values\",\"parameters\":[{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"The audience schema key ID\",\"schema\":{\"example\":\"age_group\",\"type\":\"string\"}}],\"responses\":{\"200\":{\"description\":\"\"}},\"summary\":\"Get values for a specific audience schema key\",\"tags\":[\"Reference resources\"]}},\"/ref/inventory_schema_keys\":{\"get\":{\"description\":\"Retrieve all available inventory schema keys for ad placement configuration\",\"operationId\":\"StaticsController_inventory_schema_keys\",\"parameters\":[],\"responses\":{\"200\":{\"description\":\"\"}},\"summary\":\"Get inventory schema keys\",\"tags\":[\"Reference resources\"]}},\"/ref/inventory_schema_keys/{id}/values\":{\"get\":{\"description\":\"Retrieve all available values for a specific inventory schema key\",\"operationId\":\"StaticsController_inventory_schema_key_values\",\"parameters\":[{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"schema\":{\"type\":\"string\"}}],\"responses\":{\"200\":{\"description\":\"\"}},\"summary\":\"Get values for a specific inventory schema key\",\"tags\":[\"Reference resources\"]}},\"/ref/{id}/asset/banner\":{\"get\":{\"description\":\"Download the banner asset file for a specific creative\",\"operationId\":\"StaticsController_getBanner\",\"parameters\":[{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"The creative ID\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"200\":{\"headers\":{\"Content-Disposition\":{\"description\":\"Attachment filename\",\"schema\":{\"type\":\"string\",\"example\":\"attachment; filename=\\\"document.pdf\\\"\"}}},\"description\":\"\",\"content\":{\"application/octet-stream\":{\"schema\":{\"type\":\"string\",\"format\":\"binary\"}}}}},\"summary\":\"Get banner asset file\",\"tags\":[\"Reference resources\"]}},\"/organizations/{organization_id}/audience_custom_lists\":{\"post\":{\"description\":\"Creates a new custom audience list within the specified organization.\",\"operationId\":\"AudienceCustomListsController_create\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"requestBody\":{\"required\":true,\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"name\":{\"type\":\"string\",\"minLength\":1,\"maxLength\":191},\"column_map\":{\"type\":\"array\",\"items\":{\"type\":\"string\",\"enum\":[\"aidem_person_id\",\"aidem_household_id\",\"email\",\"phone_number\",\"first_name\",\"last_name\",\"address_line_1\",\"address_line_2\",\"state\",\"zip_code\",\"auto_vin\",\"linkedin_profile\",\"up_id\",\"lalvoter_id\"],\"x-enumNames\":[\"AIDEM_PERSON_ID\",\"AIDEM_HOUSEHOLD_ID\",\"EMAIL\",\"PHONE_NUMBER\",\"FIRST_NAME\",\"LAST_NAME\",\"ADDRESS_LINE_1\",\"ADDRESS_LINE_2\",\"STATE\",\"ZIP_CODE\",\"AUTO_VIN\",\"LINKEDIN_PROFILE\",\"UP_ID\",\"LALVOTER_ID\"],\"nullable\":true}},\"type\":{\"type\":\"string\",\"enum\":[\"EXACT\",\"LOOKALIKE\"],\"x-enumNames\":[\"EXACT\",\"LOOKALIKE\"]},\"advertiser_id\":{\"type\":\"string\",\"format\":\"uuid\"}},\"required\":[\"name\",\"column_map\",\"type\",\"advertiser_id\"]}}}},\"responses\":{\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":[{\"code\":\"invalid_type\",\"expected\":\"string\",\"received\":\"undefined\",\"path\":[\"advertiser_id\"],\"message\":\"Required\"}],\"statusCode\":400}}}},\"403\":{\"description\":\"Forbidden - Write access needed\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"Advertiser not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Create a new audience custom list\",\"tags\":[\"Audience custom lists\"]},\"get\":{\"operationId\":\"AudienceCustomListsController_findAll\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"page\",\"required\":false,\"in\":\"query\",\"description\":\"Which page of results to fetch\",\"schema\":{\"default\":1,\"example\":\"1\",\"type\":\"string\"}},{\"name\":\"pageSize\",\"required\":false,\"in\":\"query\",\"description\":\"The size of a page of results to fetch\",\"schema\":{\"default\":10,\"example\":\"10\",\"type\":\"string\"}},{\"name\":\"search\",\"required\":true,\"in\":\"query\",\"description\":\"Filter by name\",\"schema\":{\"type\":\"string\"}},{\"name\":\"type\",\"required\":true,\"in\":\"query\",\"description\":\"Filter by type\",\"schema\":{\"type\":\"string\"}},{\"name\":\"availability\",\"required\":true,\"in\":\"query\",\"description\":\"Filter by availability\",\"schema\":{\"type\":\"boolean\"}},{\"name\":\"estimated_size_min\",\"required\":true,\"in\":\"query\",\"description\":\"Filter by estimated size min\",\"schema\":{\"type\":\"number\"}},{\"name\":\"estimated_size_max\",\"required\":true,\"in\":\"query\",\"description\":\"Filter by estimated size max\",\"schema\":{\"type\":\"boolean\"}}],\"responses\":{\"200\":{\"description\":\"Successfully received model list\",\"content\":{\"application/json\":{\"schema\":{\"allOf\":[{\"type\":\"object\",\"properties\":{\"data\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{}}},\"meta\":{\"type\":\"object\",\"properties\":{\"count\":{\"type\":\"number\"},\"lastPage\":{\"type\":\"number\"},\"currentPage\":{\"type\":\"number\"},\"totalPerPage\":{\"type\":\"number\"},\"prevPage\":{\"type\":\"number\",\"nullable\":true,\"example\":1},\"nextPage\":{\"type\":\"number\",\"nullable\":true,\"example\":null}},\"required\":[\"count\",\"lastPage\",\"currentPage\",\"totalPerPage\",\"prevPage\",\"nextPage\"]}}},{\"properties\":{\"data\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{}}}}}]}}}},\"404\":{\"description\":\"Organization not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get all audience custom lists\",\"tags\":[\"Audience custom lists\"]}},\"/organizations/{organization_id}/audience_custom_lists/{id}\":{\"patch\":{\"description\":\"Updates an existing custom audience list with the provided data.\",\"operationId\":\"AudienceCustomListsController_update\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"The organization ID\",\"schema\":{\"format\":\"uuid\",\"type\":\"string\"}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"The audience custom list ID\",\"schema\":{\"format\":\"uuid\",\"type\":\"string\"}}],\"requestBody\":{\"required\":true,\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"name\":{\"type\":\"string\",\"minLength\":1,\"maxLength\":191},\"type\":{\"type\":\"string\",\"enum\":[\"EXACT\",\"LOOKALIKE\"],\"x-enumNames\":[\"EXACT\",\"LOOKALIKE\"]}}}}}},\"responses\":{\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":[{\"code\":\"invalid_type\",\"expected\":\"string\",\"received\":\"undefined\",\"path\":[\"advertiser_id\"],\"message\":\"Required\"}],\"statusCode\":400}}}},\"403\":{\"description\":\"Forbidden - Write access needed\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"Audience custom list not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Update an audience custom list\",\"tags\":[\"Audience custom lists\"]},\"delete\":{\"description\":\"Permanently deletes the specified custom audience list from the organization.\",\"operationId\":\"AudienceCustomListsController_remove\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"The organization ID\",\"schema\":{\"format\":\"uuid\",\"type\":\"string\"}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"The audience custom list ID\",\"schema\":{\"format\":\"uuid\",\"type\":\"string\"}}],\"responses\":{\"403\":{\"description\":\"Forbidden - Write access needed\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"Audience custom list not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Delete an audience custom list\",\"tags\":[\"Audience custom lists\"]}},\"/organizations/{organization_id}/audience_custom_lists/{id}/upload\":{\"post\":{\"description\":\"Uploads a CSV file containing audience data for the specified custom list.\",\"operationId\":\"AudienceCustomListsController_upload\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"The organization ID\",\"schema\":{\"format\":\"uuid\",\"type\":\"string\"}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"The audience custom list ID\",\"schema\":{\"format\":\"uuid\",\"type\":\"string\"}}],\"requestBody\":{\"required\":true,\"description\":\"CSV file upload\",\"content\":{\"multipart/form-data\":{\"schema\":{\"type\":\"object\",\"properties\":{\"file\":{\"type\":\"string\",\"format\":\"binary\",\"description\":\"CSV file containing audience data\"}}}}}},\"responses\":{\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":\"file is not text/CSV\",\"statusCode\":400}}}},\"403\":{\"description\":\"Forbidden - Write access needed\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"Audience custom list not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Upload a CSV file for an audience custom list\",\"tags\":[\"Audience custom lists\"]}},\"/organizations/{organization_id}/integrations\":{\"get\":{\"operationId\":\"IntegrationsController_getAll\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"page\",\"required\":false,\"in\":\"query\",\"description\":\"Which page of results to fetch\",\"schema\":{\"default\":1,\"example\":\"1\",\"type\":\"string\"}},{\"name\":\"pageSize\",\"required\":false,\"in\":\"query\",\"description\":\"The size of a page of results to fetch\",\"schema\":{\"default\":10,\"example\":\"10\",\"type\":\"string\"}},{\"name\":\"search\",\"required\":true,\"in\":\"query\",\"description\":\"Filter by name or ID\",\"schema\":{\"type\":\"string\"}},{\"name\":\"type\",\"required\":true,\"in\":\"query\",\"description\":\"Filter by type\",\"schema\":{\"type\":\"string\",\"enum\":[\"shopify\",\"web_stream_pixel\",\"conversion_api\"]}},{\"name\":\"name\",\"required\":true,\"in\":\"query\",\"description\":\"Filter by name\",\"schema\":{\"type\":\"string\"}},{\"name\":\"advertiser_id\",\"required\":true,\"in\":\"query\",\"description\":\"Filter by advertiser ID\",\"schema\":{\"type\":\"string\"}}],\"responses\":{\"200\":{\"description\":\"Successfully received model list\",\"content\":{\"application/json\":{\"schema\":{\"allOf\":[{\"type\":\"object\",\"properties\":{\"data\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{}}},\"meta\":{\"type\":\"object\",\"properties\":{\"count\":{\"type\":\"number\"},\"lastPage\":{\"type\":\"number\"},\"currentPage\":{\"type\":\"number\"},\"totalPerPage\":{\"type\":\"number\"},\"prevPage\":{\"type\":\"number\",\"nullable\":true,\"example\":1},\"nextPage\":{\"type\":\"number\",\"nullable\":true,\"example\":null}},\"required\":[\"count\",\"lastPage\",\"currentPage\",\"totalPerPage\",\"prevPage\",\"nextPage\"]}}},{\"properties\":{\"data\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{}}}}}]}}}},\"404\":{\"description\":\"\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404,\"description\":\"Organization not found\"}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"List all the integrations for an organization\",\"tags\":[\"Integrations\"]},\"post\":{\"operationId\":\"IntegrationsController_create\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"requestBody\":{\"required\":true,\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"type\":{\"description\":\"The type of the integration\",\"type\":\"string\",\"enum\":[\"shopify\",\"web_stream_pixel\",\"conversion_api\"],\"x-enumNames\":[\"Shopify\",\"WebStreamPixel\",\"ConversionApi\"]},\"name\":{\"description\":\"The name of the integration\",\"type\":\"string\",\"minLength\":1},\"advertiser_id\":{\"description\":\"The ID of the advertiser the integration refers to\",\"type\":\"string\",\"format\":\"uuid\"}},\"required\":[\"type\",\"name\",\"advertiser_id\"]}}}},\"responses\":{\"201\":{\"description\":\"\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{}}}}},\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":[{\"code\":\"invalid_type\",\"expected\":\"string\",\"received\":\"undefined\",\"path\":[\"advertiser_id\"],\"message\":\"Required\"}],\"statusCode\":400}}}},\"403\":{\"description\":\"Forbidden - Admin access required\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404,\"description\":\"Organization not found\"}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Create a new integration\",\"tags\":[\"Integrations\"]}},\"/organizations/{organization_id}/integrations/{integration_id}\":{\"get\":{\"operationId\":\"IntegrationsController_getApiKey\",\"parameters\":[{\"name\":\"integration_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the integration\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Integration has incorrect type\",\"statusCode\":400}}}},\"404\":{\"description\":\"\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404,\"description\":\"Integration not found\"}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get the API key of an integration\",\"tags\":[\"Integrations\"]}},\"/organizations/{organization_id}/events/stats\":{\"post\":{\"operationId\":\"EventsController_getStats\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"The organization ID\",\"schema\":{\"format\":\"uuid\",\"type\":\"string\"}}],\"requestBody\":{\"required\":true,\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"query\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"advertiser_id\":{\"description\":\"The ID of the advertiser the event refers to\",\"type\":\"string\"},\"event_name\":{\"description\":\"The name of the event\",\"type\":\"string\"},\"event_source\":{\"description\":\"The source of the event\",\"type\":\"string\",\"enum\":[\"shopify\",\"web_stream_pixel\",\"conversion_api\"],\"x-enumNames\":[\"Shopify\",\"WebStreamPixel\",\"ConversionApi\"]}},\"required\":[\"advertiser_id\",\"event_name\",\"event_source\"]}}},\"required\":[\"query\"]}}}},\"responses\":{\"201\":{\"description\":\"\"}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get statistics related to an event\",\"tags\":[\"Organizations\"]}},\"/organizations/{organization_id}/audience-retargets\":{\"get\":{\"description\":\"Retrieve a paginated list of audience retargets for the specified organization\",\"operationId\":\"AudienceRetargetsController_findAll\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"Organization ID\",\"schema\":{\"format\":\"uuid\",\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"200\":{\"description\":\"Successfully received model list\",\"content\":{\"application/json\":{\"schema\":{\"allOf\":[{\"type\":\"object\",\"properties\":{\"data\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"event_name\":{\"type\":\"string\",\"enum\":[\"AddPaymentInfo\",\"AddToCart\",\"AddToWishlist\",\"CompleteRegistration\",\"Contact\",\"CustomEvent\",\"CustomizeProduct\",\"ConfiguratorCompletion\",\"Donate\",\"DonateRecurring\",\"FindLocation\",\"InitiateCheckout\",\"Lead\",\"Purchase\",\"Schedule\",\"Search\",\"StartTrial\",\"SubmitApplication\",\"Subscribe\",\"ViewContent\",\"CoverageCheck\",\"CallMeBack\",\"ClickToCall\",\"DownloadBrochure\",\"TestDriveRequest\",\"DealerLookup\"]},\"lookback_window\":{\"type\":\"number\",\"minimum\":1,\"maximum\":30},\"type\":{\"type\":\"string\",\"enum\":[\"EXACT\",\"LOOKALIKE\"]}},\"required\":[\"event_name\",\"lookback_window\",\"type\"]}},\"meta\":{\"type\":\"object\",\"properties\":{\"count\":{\"type\":\"number\"},\"lastPage\":{\"type\":\"number\"},\"currentPage\":{\"type\":\"number\"},\"totalPerPage\":{\"type\":\"number\"},\"prevPage\":{\"type\":\"number\",\"nullable\":true,\"example\":1},\"nextPage\":{\"type\":\"number\",\"nullable\":true,\"example\":null}},\"required\":[\"count\",\"lastPage\",\"currentPage\",\"totalPerPage\",\"prevPage\",\"nextPage\"]}}},{\"properties\":{\"data\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"event_name\":{\"type\":\"string\",\"enum\":[\"AddPaymentInfo\",\"AddToCart\",\"AddToWishlist\",\"CompleteRegistration\",\"Contact\",\"CustomEvent\",\"CustomizeProduct\",\"ConfiguratorCompletion\",\"Donate\",\"DonateRecurring\",\"FindLocation\",\"InitiateCheckout\",\"Lead\",\"Purchase\",\"Schedule\",\"Search\",\"StartTrial\",\"SubmitApplication\",\"Subscribe\",\"ViewContent\",\"CoverageCheck\",\"CallMeBack\",\"ClickToCall\",\"DownloadBrochure\",\"TestDriveRequest\",\"DealerLookup\"]},\"lookback_window\":{\"type\":\"number\",\"minimum\":1,\"maximum\":30},\"type\":{\"type\":\"string\",\"enum\":[\"EXACT\",\"LOOKALIKE\"]}},\"required\":[\"event_name\",\"lookback_window\",\"type\"]}}}}]}}}},\"404\":{\"description\":\"Organization not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get all audience retargets\",\"tags\":[\"Audience retargets\"]},\"post\":{\"description\":\"Create a new audience retarget for the specified organization\",\"operationId\":\"AudienceRetargetsController_create\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"Organization ID\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"requestBody\":{\"required\":true,\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"name\":{\"type\":\"string\",\"minLength\":1},\"advertiser_id\":{\"type\":\"string\",\"format\":\"uuid\"},\"event_name\":{\"type\":\"string\",\"enum\":[\"AddPaymentInfo\",\"AddToCart\",\"AddToWishlist\",\"CompleteRegistration\",\"Contact\",\"CustomEvent\",\"CustomizeProduct\",\"ConfiguratorCompletion\",\"Donate\",\"DonateRecurring\",\"FindLocation\",\"InitiateCheckout\",\"Lead\",\"Purchase\",\"Schedule\",\"Search\",\"StartTrial\",\"SubmitApplication\",\"Subscribe\",\"ViewContent\",\"CoverageCheck\",\"CallMeBack\",\"ClickToCall\",\"DownloadBrochure\",\"TestDriveRequest\",\"DealerLookup\"],\"x-enumNames\":[\"AddPaymentInfo\",\"AddToCart\",\"AddToWishlist\",\"CompleteRegistration\",\"Contact\",\"CustomEvent\",\"CustomizeProduct\",\"ConfiguratorCompletion\",\"Donate\",\"DonateRecurring\",\"FindLocation\",\"InitiateCheckout\",\"Lead\",\"Purchase\",\"Schedule\",\"Search\",\"StartTrial\",\"SubmitApplication\",\"Subscribe\",\"ViewContent\",\"CoverageCheck\",\"CallMeBack\",\"ClickToCall\",\"DownloadBrochure\",\"TestDriveRequest\",\"DealerLookup\"]},\"type\":{\"type\":\"string\",\"enum\":[\"EXACT\",\"LOOKALIKE\"],\"x-enumNames\":[\"EXACT\",\"LOOKALIKE\"]},\"lookback_window\":{\"type\":\"integer\",\"minimum\":1,\"exclusiveMinimum\":false,\"maximum\":30,\"exclusiveMaximum\":false}},\"required\":[\"name\",\"advertiser_id\",\"event_name\",\"type\",\"lookback_window\"]}}}},\"responses\":{\"201\":{\"description\":\"\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"event_name\":{\"type\":\"string\",\"enum\":[\"AddPaymentInfo\",\"AddToCart\",\"AddToWishlist\",\"CompleteRegistration\",\"Contact\",\"CustomEvent\",\"CustomizeProduct\",\"ConfiguratorCompletion\",\"Donate\",\"DonateRecurring\",\"FindLocation\",\"InitiateCheckout\",\"Lead\",\"Purchase\",\"Schedule\",\"Search\",\"StartTrial\",\"SubmitApplication\",\"Subscribe\",\"ViewContent\",\"CoverageCheck\",\"CallMeBack\",\"ClickToCall\",\"DownloadBrochure\",\"TestDriveRequest\",\"DealerLookup\"]},\"lookback_window\":{\"type\":\"number\",\"minimum\":1,\"maximum\":30},\"type\":{\"type\":\"string\",\"enum\":[\"EXACT\",\"LOOKALIKE\"]}},\"required\":[\"event_name\",\"lookback_window\",\"type\"]}}}},\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":[{\"code\":\"invalid_type\",\"expected\":\"string\",\"received\":\"undefined\",\"path\":[\"advertiser_id\"],\"message\":\"Required\"}],\"statusCode\":400}}}},\"403\":{\"description\":\"Forbidden - Write access needed\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"Advertiser not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Create an audience retarget\",\"tags\":[\"Audience retargets\"]}},\"/organizations/{organization_id}/audience-retargets/{id}\":{\"delete\":{\"description\":\"Delete an existing audience retarget by ID\",\"operationId\":\"AudienceRetargetsController_delete\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"Organization ID\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"Audience retarget ID to delete\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174002\",\"type\":\"string\"}}],\"responses\":{\"403\":{\"description\":\"Forbidden - Write access needed\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Delete an audience retarget\",\"tags\":[\"Audience retargets\"]}},\"/organizations/{organization_id}/line-items/{line_item_id}/audience-retargets\":{\"get\":{\"operationId\":\"LineItemOnAudienceRetargetController_getAll\",\"parameters\":[{\"name\":\"line_item_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the line item\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"200\":{\"description\":\"Successfully received model list\",\"content\":{\"application/json\":{\"schema\":{\"allOf\":[{\"type\":\"object\",\"properties\":{\"data\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{}}},\"meta\":{\"type\":\"object\",\"properties\":{\"count\":{\"type\":\"number\"},\"lastPage\":{\"type\":\"number\"},\"currentPage\":{\"type\":\"number\"},\"totalPerPage\":{\"type\":\"number\"},\"prevPage\":{\"type\":\"number\",\"nullable\":true,\"example\":1},\"nextPage\":{\"type\":\"number\",\"nullable\":true,\"example\":null}},\"required\":[\"count\",\"lastPage\",\"currentPage\",\"totalPerPage\",\"prevPage\",\"nextPage\"]}}},{\"properties\":{\"data\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{}}}}}]}}}},\"404\":{\"description\":\"Line item not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"summary\":\"List all the audience retarget associations of a line item\",\"tags\":[\"Line Items\"]},\"put\":{\"operationId\":\"LineItemOnAudienceRetargetController_createUpdate\",\"parameters\":[{\"name\":\"line_item_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the line item\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"requestBody\":{\"required\":true,\"content\":{\"application/json\":{\"schema\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"active\":{\"description\":\"Whether the association should be active\",\"type\":\"boolean\"},\"audience_retarget_id\":{\"description\":\"The ID of the audience retarget\",\"type\":\"string\",\"format\":\"uuid\"}},\"required\":[\"active\",\"audience_retarget_id\"]}}}}},\"responses\":{\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":[{\"code\":\"invalid_type\",\"expected\":\"boolean\",\"received\":\"undefined\",\"path\":[\"active\"],\"message\":\"Required\"}],\"statusCode\":400}}}},\"403\":{\"description\":\"Forbidden - Write access required\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"Line Item not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"summary\":\"Create a new association between a line item and one or more audience retargets\",\"tags\":[\"Line Items\"]}},\"/users/{id}\":{\"patch\":{\"operationId\":\"UsersController_update\",\"parameters\":[{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the user\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"requestBody\":{\"required\":true,\"description\":\"Update user data\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"first_name\":{\"type\":\"string\"},\"last_name\":{\"type\":\"string\"}}}}}},\"responses\":{\"200\":{\"description\":\"\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\",\"example\":\"uuid\"},\"sub\":{\"type\":\"string\",\"example\":\"sub\"},\"email\":{\"type\":\"string\",\"example\":\"email@example.com\"},\"email_verified\":{\"type\":\"object\",\"example\":false},\"first_name\":{\"type\":\"object\",\"example\":\"John\"},\"last_name\":{\"type\":\"object\",\"example\":\"Doe\"}},\"required\":[\"id\",\"sub\",\"email\",\"email_verified\",\"first_name\"]}}}},\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":[{\"code\":\"invalid_type\",\"expected\":\"string\",\"received\":\"number\",\"path\":[\"first_name\"],\"message\":\"Required\"}],\"statusCode\":400}}}},\"403\":{\"description\":\"Forbidden - Ownership of user needed\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Update user profile\",\"tags\":[\"Users\"]}},\"/users/{id}/profile-picture\":{\"put\":{\"operationId\":\"UsersController_uploadProfilePicture\",\"parameters\":[{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the user\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"requestBody\":{\"required\":true,\"description\":\"Profile picture file\",\"content\":{\"multipart/form-data\":{\"schema\":{\"type\":\"object\",\"properties\":{\"file\":{\"type\":\"string\",\"format\":\"binary\",\"description\":\"Profile picture image file\"}}}}}},\"responses\":{\"200\":{\"description\":\"\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\",\"example\":\"uuid\"},\"sub\":{\"type\":\"string\",\"example\":\"sub\"},\"email\":{\"type\":\"string\",\"example\":\"email@example.com\"},\"email_verified\":{\"type\":\"object\",\"example\":false},\"first_name\":{\"type\":\"object\",\"example\":\"John\"},\"last_name\":{\"type\":\"object\",\"example\":\"Doe\"}},\"required\":[\"id\",\"sub\",\"email\",\"email_verified\",\"first_name\"]}}}},\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":\"File type not supported\",\"statusCode\":400}}}},\"403\":{\"description\":\"Forbidden - Ownership of user needed\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Upload user profile picture\",\"tags\":[\"Users\"]}},\"/organizations/{organization_id}/advertisers/{advertiser_id}/reporting/dashboard\":{\"get\":{\"operationId\":\"ReportingController_getDashboard\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"advertiser_id\",\"required\":true,\"in\":\"path\",\"schema\":{\"type\":\"string\"}},{\"name\":\"campaign_id\",\"required\":false,\"in\":\"query\",\"description\":\"Campaign ID\",\"schema\":{\"type\":\"string\"}},{\"name\":\"line_item_id\",\"required\":false,\"in\":\"query\",\"description\":\"Line Item ID\",\"schema\":{\"type\":\"string\"}},{\"name\":\"creative_id\",\"required\":false,\"in\":\"query\",\"description\":\"Creative ID\",\"schema\":{\"type\":\"string\"}},{\"name\":\"group_by_fields\",\"required\":true,\"in\":\"query\",\"description\":\"Fields to group by\",\"schema\":{\"type\":\"array\",\"items\":{\"type\":\"string\"}}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the advertiser\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"200\":{\"description\":\"\",\"content\":{\"application/json\":{\"schema\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"advertiser_id\":{\"type\":\"string\",\"format\":\"uuid\"},\"spend\":{\"type\":\"number\"},\"impressions\":{\"type\":\"number\"},\"reach_person\":{\"type\":\"number\"},\"reach_household\":{\"type\":\"number\"},\"conversions\":{\"type\":\"number\"},\"conversion_rate\":{\"type\":\"number\"},\"conversions_value\":{\"type\":\"number\"},\"cpa\":{\"type\":\"number\"},\"roas\":{\"type\":\"number\"},\"group_fields\":{\"type\":\"object\",\"additionalProperties\":{\"type\":\"string\"}}},\"required\":[\"advertiser_id\",\"spend\",\"impressions\",\"reach_person\",\"reach_household\",\"conversions\",\"conversion_rate\",\"conversions_value\",\"cpa\",\"roas\",\"group_fields\"]}}}}},\"404\":{\"description\":\"Advertiser not found\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Not found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get dashboard data for reporting purposes for an advertiser\",\"tags\":[\"Reporting\"]}},\"/organizations/{organization_id}/advertisers/{advertiser_id}/household-reporting/impressions\":{\"get\":{\"description\":\"Retrieves household-level aggregated impressions reporting for a given advertiser and time range. Output is returned as CSV.\",\"operationId\":\"ReportingController_getHouseholdReporting\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"advertiser_id\",\"required\":true,\"in\":\"path\",\"schema\":{\"type\":\"string\"}},{\"name\":\"start_datetime\",\"required\":true,\"in\":\"query\",\"description\":\"Start timestamp (ISO datetime)\",\"schema\":{\"example\":\"2025-01-01T00:00:00.000Z\",\"type\":\"string\"}},{\"name\":\"end_datetime\",\"required\":true,\"in\":\"query\",\"description\":\"End timestamp (ISO datetime)\",\"schema\":{\"example\":\"2025-01-31T23:59:59.999Z\",\"type\":\"string\"}},{\"name\":\"dimension\",\"required\":true,\"in\":\"query\",\"description\":\"Dimension to group by (currently only address is supported)\",\"schema\":{\"type\":\"string\",\"enum\":[\"address\"]}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the advertiser\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"200\":{\"description\":\"CSV stream of household-level impressions aggregation\",\"content\":{\"text/csv\":{\"schema\":{\"type\":\"string\",\"example\":\"aidem_household_id_hash,address_primary,address_secondary,house_number,pre_direction,street_name,street_suffix,post_direction,unit_designator,unit_designator_number,zip_code,zip_code_extension,city_name,state\\nabc123hash,123 Main St,,123,,Main,St,,Apt,4B,62704,,Springfield,IL\\ndef456hash,456 Oak Ave,,456,,Oak,Ave,,Unit,12,73301,,Austin,TX\\n\"}}}},\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":[{\"code\":\"invalid_type\",\"expected\":\"string\",\"received\":\"undefined\",\"path\":[\"dimension\"],\"message\":\"Required\"}],\"error\":\"Bad Request\",\"statusCode\":400}}}},\"401\":{\"description\":\"Invalid login request\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Bearer token not provided\",\"error\":\"Unauthorized\",\"statusCode\":401}}}},\"403\":{\"description\":\"Forbidden - Read access required\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Resource not found\",\"error\":\"Not Found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get household-level impressions reporting data\",\"tags\":[\"Reporting\"]}},\"/organizations/{organization_id}/advertisers/{advertiser_id}/person-reporting/impressions\":{\"get\":{\"description\":\"Retrieves person-level aggregated impressions reporting for a given advertiser and time range. Output is returned as CSV.\",\"operationId\":\"ReportingController_getPersonReporting\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"advertiser_id\",\"required\":true,\"in\":\"path\",\"schema\":{\"type\":\"string\"}},{\"name\":\"start_datetime\",\"required\":true,\"in\":\"query\",\"description\":\"Start timestamp (ISO datetime)\",\"schema\":{\"example\":\"2025-01-01T00:00:00.000Z\",\"type\":\"string\"}},{\"name\":\"end_datetime\",\"required\":true,\"in\":\"query\",\"description\":\"End timestamp (ISO datetime)\",\"schema\":{\"example\":\"2025-01-31T23:59:59.999Z\",\"type\":\"string\"}},{\"name\":\"dimension\",\"required\":true,\"in\":\"query\",\"description\":\"Dimension to group by (currently only linkedin_url is supported)\",\"schema\":{\"type\":\"string\",\"enum\":[\"linkedin_url\"]}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the advertiser\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"200\":{\"description\":\"CSV stream of person-level impressions aggregation\",\"content\":{\"text/csv\":{\"schema\":{\"type\":\"string\",\"example\":\"aidem_person_id_hash,linkedin_url\\na1b2c3hash,https://www.linkedin.com/in/janedoe\\nz9y8x7hash,https://www.linkedin.com/in/johnsmith\\n\"}}}},\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":[{\"code\":\"invalid_type\",\"expected\":\"string\",\"received\":\"undefined\",\"path\":[\"dimension\"],\"message\":\"Required\"}],\"error\":\"Bad Request\",\"statusCode\":400}}}},\"401\":{\"description\":\"Invalid login request\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Bearer token not provided\",\"error\":\"Unauthorized\",\"statusCode\":401}}}},\"403\":{\"description\":\"Forbidden - Read access required\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Resource not found\",\"error\":\"Not Found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get person-level impressions reporting data\",\"tags\":[\"Reporting\"]}},\"/organizations/{organization_id}/advertisers/{advertiser_id}/reporting/impressions\":{\"get\":{\"description\":\"Retrieves aggregated reporting data from the impressions table within a specified time range\",\"operationId\":\"ReportingController_getReportingImpressions\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"advertiser_id\",\"required\":true,\"in\":\"path\",\"schema\":{\"type\":\"string\"}},{\"name\":\"start_datetime\",\"required\":true,\"in\":\"query\",\"description\":\"Start timestamp (ISO datetime)\",\"schema\":{\"example\":\"2025-01-01T00:00:00.000Z\",\"type\":\"string\"}},{\"name\":\"end_datetime\",\"required\":true,\"in\":\"query\",\"description\":\"End timestamp (ISO datetime)\",\"schema\":{\"example\":\"2025-01-31T23:59:59.999Z\",\"type\":\"string\"}},{\"name\":\"campaign_id\",\"required\":true,\"in\":\"query\",\"description\":\"Filter by specific campaign\",\"schema\":{\"type\":\"string\"}},{\"name\":\"line_item_id\",\"required\":true,\"in\":\"query\",\"description\":\"Filter by specific line item\",\"schema\":{\"type\":\"string\"}},{\"name\":\"creative_id\",\"required\":true,\"in\":\"query\",\"description\":\"Filter by specific creative\",\"schema\":{\"type\":\"string\"}},{\"name\":\"dimensions\",\"required\":true,\"in\":\"query\",\"description\":\"Comma-separated list of dimensions to group by (minimum 1)\",\"schema\":{\"type\":\"string\",\"enum\":[\"date\",\"hour\",\"account_id\",\"account_name\",\"advertiser_id\",\"advertiser_name\",\"campaign_id\",\"campaign_name\",\"line_item_id\",\"line_item_name\",\"creative_id\",\"creative_name\",\"app_bundle\",\"app_id\",\"app_name\",\"domain\",\"page_url_full\",\"site_id\",\"site_name\",\"site_referrer\",\"content_cat\",\"content_channel_name\",\"content_episode\",\"content_genre\",\"content_id\",\"content_language\",\"content_length\",\"content_livestream\",\"content_network_id\",\"content_network_name\",\"content_rating\",\"content_season\",\"content_series\",\"content_title\",\"connection_type\",\"device_browser\",\"device_browser_version\",\"device_carrier\",\"device_hardware_version\",\"device_make\",\"device_model\",\"device_os\",\"device_os_version\",\"device_type\",\"country_name\",\"metro_name\",\"city_name\",\"state_name\",\"zip_code\",\"geolocation_source\",\"placement\",\"placement_type\",\"environment_type\",\"inventory_source\",\"publisher_id\",\"publisher_name\",\"seller_id\",\"deal_id\",\"rewarded\",\"video_placement\",\"video_playback_method\",\"video_player_size\",\"gender\",\"age\",\"marital_status\",\"ethnicity\",\"education\",\"income\",\"net_worth\",\"religion\",\"language\",\"credit_score\",\"mccmnc\",\"presence_of_cc\",\"presence_of_gold_plat_cc\",\"presence_of_premium_cc\",\"presence_of_upscale_retail_cc\",\"presence_of_bankcard\",\"gas_dept_retail_cc\",\"american_express_cc\",\"american_express_gold_plat\",\"discover_gold_premium\",\"discover_regular\",\"gas_retail_cc_gold_premium\",\"mastercard_gold_premium\",\"mastercard_regular\",\"visa_gold_premium\",\"visa_regular\",\"travel_entertainment_cc\",\"district_congressional\",\"district_state_senate\",\"district_state_house\",\"district_legislative\",\"political_contributor\",\"registered_to_vote\",\"department\",\"seniority_level\",\"company_name\",\"company_domain\",\"company_sic\",\"company_naics\",\"company_revenue\",\"company_employee_count\",\"company_primary_industry\",\"number_of_persons_in_hh\",\"number_of_adults_in_hh\",\"number_of_children_in_hh\",\"veteran_in_hh\",\"children_in_hh_age_00_02\",\"children_in_hh_age_03_05\",\"children_in_hh_age_06_10\",\"children_in_hh_age_11_15\",\"children_in_hh_age_16_17\",\"males_in_hh_18_24\",\"females_in_hh_18_24\",\"males_in_hh_25_34\",\"females_in_hh_25_34\",\"males_in_hh_35_44\",\"females_in_hh_35_44\",\"males_in_hh_45_54\",\"females_in_hh_45_54\",\"males_in_hh_55_64\",\"females_in_hh_55_64\",\"males_in_hh_65_74\",\"females_in_hh_65_74\",\"males_in_hh_75_plus\",\"females_in_hh_75_plus\",\"dwelling_type\",\"home_ownership\",\"length_of_residence\",\"property_home_square_footage\",\"property_land_square_footage\",\"parking_space\",\"home_swimming_pool\",\"home_air_conditioning\",\"home_heating_system\",\"home_purchase_price\",\"home_purchase_year\",\"home_year_built\",\"home_current_value\",\"home_mortgage_amount\",\"home_mortgage_rate\",\"home_mortgage_type\",\"home_mortgage_lender_name_standardized\",\"apparel_children\",\"apparel_infant_toddlers\",\"apparel_men_big_tall\",\"apparel_men\",\"apparel_petite\",\"apparel_women\",\"apparel_women_plus_size\",\"apparel_young_men\",\"apparel_young_women\",\"high_end_appliances\",\"music_home_stereo\",\"arts_and_antiques\",\"arts_art\",\"arts_int\",\"theater_performing_arts\",\"auto_work\",\"automotive_buff\",\"autoparts_accessories\",\"aviation_int\",\"books_magazines\",\"book_buyer\",\"book_reader\",\"books_music_books\",\"books_music_audio\",\"reading_general\",\"reading_mags\",\"reading_audio_books\",\"reading_sci_fi\",\"pets_cats\",\"pets_dogs\",\"pets_multi\",\"children_babycare\",\"children_learning_toys\",\"children_back_to_school\",\"membership_club\",\"gunowner\",\"collectibles_antiques\",\"collectibles_arts\",\"collector_avid\",\"collectibles_coins\",\"collectibles_general\",\"military_memorabilia_weapons\",\"collectibles_sports_memorabilia\",\"collectibles_stamps\",\"computer_owner\",\"consumer_electronics\",\"computer_home_office\",\"electronics_computers\",\"electronics_movies_int\",\"cooking_enthusiast\",\"cooking_general\",\"foods_natural\",\"food_wines\",\"cosmetics_beauty\",\"crafts_hobbies_buyer\",\"craft_int\",\"do_it_yourselfers_typical_choice\",\"dvd_videos\",\"education_online\",\"exercise_enthusiast\",\"exercise_aerobic\",\"exercise_running_jogging\",\"exercise_walking\",\"female_merch_buyer\",\"news_financial\",\"gaming_int\",\"games_board_puzzles\",\"games_pc_games\",\"games_video\",\"gaming_casino\",\"gardening\",\"gardening_farming_buyer\",\"golf_enthusiast\",\"collect_special_foods_buyer\",\"health_and_beauty\",\"dieting_weightloss\",\"health_medical\",\"self_improvement\",\"career_improvement\",\"equestrian_int\",\"house_plants\",\"investments_foreign\",\"investments_realestate\",\"invest_stock_securities\",\"investments\",\"invest_active\",\"jewelry_buyer\",\"common_living\",\"cultural_arts_living\",\"sporty_living\",\"lifestyle_passion_collectibles\",\"movie_collector\",\"home_and_garden\",\"photography_video_equip\",\"photography_int\",\"home_furnishings_decor\",\"home_improvement\",\"sports_leisure\",\"luggage_buyer\",\"history_military\",\"music_avid_listener\",\"music_collector\",\"musical_instruments\",\"music_player_device\",\"current_affairs_politics\",\"religious_inspiration\",\"religious_mags\",\"religious_contributor\",\"science_space\",\"sewing_knitting_needlework\",\"smoking\",\"sports_auto_motorcycle_racing\",\"sports_baseball\",\"sports_basketball\",\"sports_football\",\"sports_hockey\",\"sports_soccer\",\"boating_sailing\",\"camping_hiking\",\"fisher\",\"hunter\",\"active_motorcycle\",\"active_nascar\",\"active_snow_skiing\",\"active_tennis\",\"scuba_diving\",\"hunting_shooting\",\"sweepstakes_int\",\"travel_cruises\",\"travel_domestic\",\"travel_intl\",\"donor_animal_welfare\",\"donor_arts_cultural\",\"donor_charitable_causes\",\"donor_children_causes\",\"donor_environmental\",\"donor_health_institution\",\"donor_international_aid\",\"donor_veterans\",\"auto_year_1\",\"auto_make_1\",\"auto_model_1\",\"auto_series_1\",\"auto_bodyclass_1\",\"auto_vehicle_type_1\",\"auto_estimated_purchase_date_1\",\"auto_fuel_type_1\",\"auto_year_2\",\"auto_make_2\",\"auto_model_2\",\"auto_series_2\",\"auto_bodyclass_2\",\"auto_vehicle_type_2\",\"auto_estimated_purchase_date_2\",\"auto_fuel_type_2\",\"auto_year_3\",\"auto_make_3\",\"auto_model_3\",\"auto_series_3\",\"auto_bodyclass_3\",\"auto_vehicle_type_3\",\"auto_estimated_purchase_date_3\",\"auto_fuel_type_3\"]}},{\"name\":\"metrics\",\"required\":true,\"in\":\"query\",\"description\":\"Comma-separated list of metrics to aggregate (minimum 1)\",\"schema\":{\"type\":\"string\",\"enum\":[\"bid_price\",\"impression_cost_usd\",\"media_spend_usd\",\"third_party_vendor_cost_usd\",\"third_party_vendor_cpm_fee_value\",\"third_party_vendor_percentage_fee_value\",\"vendor_fee_usd\",\"impressions\",\"reach_person\",\"reach_household\",\"reach_person_target_universe\",\"reach_household_target_universe\",\"reach_person_penetration_rate\",\"reach_household_penetration_rate\",\"reach_person_frequency\",\"reach_household_frequency\",\"conversion_rate\",\"cpa\",\"roas\",\"cpm\",\"click\",\"video_start\",\"video_q1\",\"video_midpoint\",\"video_q3\",\"video_complete\",\"video_close\",\"video_fullscreen\",\"video_mutes\",\"video_pauses\",\"video_resumes\",\"video_skip\",\"video_unmutes\",\"add_payment_info_count\",\"add_payment_info_value\",\"add_to_cart_count\",\"add_to_cart_value\",\"add_to_wishlist_count\",\"add_to_wishlist_value\",\"call_me_back_count\",\"call_me_back_value\",\"click_to_call_count\",\"click_to_call_value\",\"complete_registration_count\",\"complete_registration_value\",\"configurator_completion_count\",\"configurator_completion_value\",\"contact_count\",\"contact_value\",\"coverage_check_count\",\"coverage_check_value\",\"custom_event_count\",\"custom_event_value\",\"customize_product_count\",\"customize_product_value\",\"dealer_lookup_count\",\"dealer_lookup_value\",\"donate_count\",\"donate_value\",\"donate_recurring_count\",\"donate_recurring_value\",\"download_brochure_count\",\"download_brochure_value\",\"find_location_count\",\"find_location_value\",\"initiate_checkout_count\",\"initiate_checkout_value\",\"lead_count\",\"lead_value\",\"page_view_count\",\"page_view_value\",\"purchase_count\",\"purchase_value\",\"schedule_count\",\"schedule_value\",\"search_count\",\"search_value\",\"start_trial_count\",\"start_trial_value\",\"submit_application_count\",\"submit_application_value\",\"subscribe_count\",\"subscribe_value\",\"testdrive_request_count\",\"testdrive_request_value\",\"view_content_count\",\"view_content_value\"]}},{\"name\":\"format\",\"required\":true,\"in\":\"query\",\"description\":\"Output format: json (default) or csv\",\"schema\":{\"type\":\"string\",\"enum\":[\"json\",\"csv\"]}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the advertiser\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"200\":{\"description\":\"Reporting data returned successfully\",\"content\":{\"application/json\":{\"schema\":{\"example\":{\"status\":\"success\",\"metadata\":{\"table\":\"impressions\",\"start_ts\":\"2025-08-26T00:00:00Z\",\"end_ts\":\"2025-09-02T00:00:00Z\",\"advertiser_id\":\"f60b7dba-ac89-4d21-bdbc-98770b5faf1e\",\"campaign_id\":null,\"lineitem_id\":null,\"creative_id\":null,\"dimensions\":[\"age\",\"gender\"],\"metrics\":[\"cpm\",\"click\"],\"row_count\":2,\"generated_at\":\"2025-09-17T09:42:06.820332+00:00\"},\"data\":[{\"age\":\"55-64\",\"click\":0,\"gender\":\"F\",\"cpm\":null},{\"age\":\"25-34\",\"click\":0,\"gender\":\"M\",\"cpm\":null}]}}},\"text/csv\":{\"schema\":{\"type\":\"string\",\"example\":\"age,gender,cpm,click\\n55-64,F,,0\\n25-34,M,,0\\n\"}}}},\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":[{\"code\":\"invalid_type\",\"expected\":\"array\",\"received\":\"undefined\",\"path\":[\"metrics\"],\"message\":\"Required\"}],\"error\":\"Bad Request\",\"statusCode\":400}}}},\"401\":{\"description\":\"Invalid login request\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Bearer token not provided\",\"error\":\"Unauthorized\",\"statusCode\":401}}}},\"403\":{\"description\":\"Forbidden - Read access required\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Resource not found\",\"error\":\"Not Found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get aggregated impressions reporting data\",\"tags\":[\"Reporting\"]}},\"/organizations/{organization_id}/advertisers/{advertiser_id}/reporting/events\":{\"get\":{\"description\":\"Retrieves aggregated reporting data from the events table within a specified time range\",\"operationId\":\"ReportingController_getReportingEvents\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"advertiser_id\",\"required\":true,\"in\":\"path\",\"schema\":{\"type\":\"string\"}},{\"name\":\"start_datetime\",\"required\":true,\"in\":\"query\",\"description\":\"Start timestamp (ISO datetime)\",\"schema\":{\"example\":\"2025-01-01T00:00:00.000Z\",\"type\":\"string\"}},{\"name\":\"end_datetime\",\"required\":true,\"in\":\"query\",\"description\":\"End timestamp (ISO datetime)\",\"schema\":{\"example\":\"2025-01-31T23:59:59.999Z\",\"type\":\"string\"}},{\"name\":\"campaign_id\",\"required\":true,\"in\":\"query\",\"description\":\"Filter by specific campaign\",\"schema\":{\"type\":\"string\"}},{\"name\":\"line_item_id\",\"required\":true,\"in\":\"query\",\"description\":\"Filter by specific line item\",\"schema\":{\"type\":\"string\"}},{\"name\":\"creative_id\",\"required\":true,\"in\":\"query\",\"description\":\"Filter by specific creative\",\"schema\":{\"type\":\"string\"}},{\"name\":\"dimensions\",\"required\":true,\"in\":\"query\",\"description\":\"Comma-separated list of dimensions to group by (minimum 1)\",\"schema\":{\"type\":\"string\",\"enum\":[\"date\",\"hour\",\"event_type\",\"event_source\",\"advertiser_id\",\"custom_parameter_1\",\"custom_parameter_2\",\"custom_parameter_3\",\"custom_parameter_4\",\"custom_parameter_5\"]}},{\"name\":\"metrics\",\"required\":true,\"in\":\"query\",\"description\":\"Comma-separated list of metrics to aggregate (minimum 1)\",\"schema\":{\"type\":\"string\",\"enum\":[\"events\",\"event_value\",\"avg_event_value\",\"event_units\",\"avg_event_units\"]}},{\"name\":\"format\",\"required\":true,\"in\":\"query\",\"description\":\"Output format: json (default) or csv\",\"schema\":{\"type\":\"string\",\"enum\":[\"json\",\"csv\"]}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the advertiser\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"200\":{\"description\":\"Reporting data returned successfully\",\"content\":{\"application/json\":{\"schema\":{\"example\":{\"status\":\"success\",\"metadata\":{\"table\":\"events\",\"start_ts\":\"2025-08-26T00:00:00Z\",\"end_ts\":\"2025-09-02T00:00:00Z\",\"advertiser_id\":\"f60b7dba-ac89-4d21-bdbc-98770b5faf1e\",\"campaign_id\":null,\"lineitem_id\":null,\"creative_id\":null,\"dimensions\":[\"date\",\"event_type\"],\"metrics\":[\"events\",\"event_value\"],\"row_count\":3,\"generated_at\":\"2025-01-15T10:30:00Z\"},\"data\":[{\"date\":\"2025-01-14\",\"event_type\":\"add_to_cart\",\"events\":125,\"event_value\":5500.25}]}}},\"text/csv\":{\"schema\":{\"type\":\"string\",\"example\":\"date,event_type,events,event_value\\n2025-01-14,add_to_cart,125,5500.25\\n\"}}}},\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":[{\"code\":\"invalid_type\",\"expected\":\"array\",\"received\":\"undefined\",\"path\":[\"metrics\"],\"message\":\"Required\"}],\"error\":\"Bad Request\",\"statusCode\":400}}}},\"401\":{\"description\":\"Invalid login request\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Bearer token not provided\",\"error\":\"Unauthorized\",\"statusCode\":401}}}},\"403\":{\"description\":\"Forbidden - Read access required\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Resource not found\",\"error\":\"Not Found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get aggregated events reporting data\",\"tags\":[\"Reporting\"]}},\"/organizations/{organization_id}/advertisers/{advertiser_id}/reporting/conversions\":{\"get\":{\"description\":\"Retrieves aggregated reporting data from the conversions table within a specified time range\",\"operationId\":\"ReportingController_getReportingConversions\",\"parameters\":[{\"name\":\"organization_id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the organization\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}},{\"name\":\"advertiser_id\",\"required\":true,\"in\":\"path\",\"schema\":{\"type\":\"string\"}},{\"name\":\"start_datetime\",\"required\":true,\"in\":\"query\",\"description\":\"Start timestamp (ISO datetime)\",\"schema\":{\"example\":\"2025-01-01T00:00:00.000Z\",\"type\":\"string\"}},{\"name\":\"end_datetime\",\"required\":true,\"in\":\"query\",\"description\":\"End timestamp (ISO datetime)\",\"schema\":{\"example\":\"2025-01-31T23:59:59.999Z\",\"type\":\"string\"}},{\"name\":\"campaign_id\",\"required\":true,\"in\":\"query\",\"description\":\"Filter by specific campaign\",\"schema\":{\"type\":\"string\"}},{\"name\":\"line_item_id\",\"required\":true,\"in\":\"query\",\"description\":\"Filter by specific line item\",\"schema\":{\"type\":\"string\"}},{\"name\":\"creative_id\",\"required\":true,\"in\":\"query\",\"description\":\"Filter by specific creative\",\"schema\":{\"type\":\"string\"}},{\"name\":\"dimensions\",\"required\":true,\"in\":\"query\",\"description\":\"Comma-separated list of dimensions to group by (minimum 1)\",\"schema\":{\"type\":\"string\",\"enum\":[\"date\",\"hour\",\"conversion_type\",\"conversion_source\",\"advertiser_id\",\"campaign_id\",\"lineitem_id\",\"creative_id\",\"advertiser_name\",\"campaign_name\",\"lineitem_name\",\"creative_name\",\"custom_parameter_1\",\"custom_parameter_2\",\"custom_parameter_3\",\"custom_parameter_4\",\"custom_parameter_5\",\"attribution_mode\",\"conversion_window\"]}},{\"name\":\"metrics\",\"required\":true,\"in\":\"query\",\"description\":\"Comma-separated list of metrics to aggregate (minimum 1)\",\"schema\":{\"type\":\"string\",\"enum\":[\"conversions\",\"conversion_value\",\"avg_conversion_value\",\"conversion_units\",\"avg_conversion_units\"]}},{\"name\":\"format\",\"required\":true,\"in\":\"query\",\"description\":\"Output format: json (default) or csv\",\"schema\":{\"type\":\"string\",\"enum\":[\"json\",\"csv\"]}},{\"name\":\"id\",\"required\":true,\"in\":\"path\",\"description\":\"ID of the advertiser\",\"schema\":{\"example\":\"123e4567-e89b-12d3-a456-426614174000\",\"type\":\"string\"}}],\"responses\":{\"200\":{\"description\":\"Reporting data returned successfully\",\"content\":{\"application/json\":{\"schema\":{\"example\":{\"status\":\"success\",\"metadata\":{\"table\":\"conversions\",\"start_ts\":\"2025-08-26T00:00:00Z\",\"end_ts\":\"2025-09-02T00:00:00Z\",\"advertiser_id\":\"f60b7dba-ac89-4d21-bdbc-98770b5faf1e\",\"campaign_id\":null,\"lineitem_id\":null,\"creative_id\":null,\"dimensions\":[\"date\",\"conversion_type\"],\"metrics\":[\"conversions\",\"conversion_value\"],\"row_count\":3,\"generated_at\":\"2025-01-15T10:30:00Z\"},\"data\":[{\"date\":\"2025-01-14\",\"conversion_type\":\"purchase\",\"conversions\":42,\"conversion_value\":2500.75}]}}},\"text/csv\":{\"schema\":{\"type\":\"string\",\"example\":\"date,conversion_type,conversions,conversion_value\\n2025-01-14,purchase,42,2500.75\\n\"}}}},\"400\":{\"description\":\"Validation error\",\"content\":{\"application/json\":{\"example\":{\"message\":[{\"code\":\"invalid_type\",\"expected\":\"array\",\"received\":\"undefined\",\"path\":[\"metrics\"],\"message\":\"Required\"}],\"error\":\"Bad Request\",\"statusCode\":400}}}},\"401\":{\"description\":\"Invalid login request\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Bearer token not provided\",\"error\":\"Unauthorized\",\"statusCode\":401}}}},\"403\":{\"description\":\"Forbidden - Read access required\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Forbidden\",\"statusCode\":403}}}},\"404\":{\"description\":\"\",\"content\":{\"application/json\":{\"example\":{\"message\":\"Resource not found\",\"error\":\"Not Found\",\"statusCode\":404}}}}},\"security\":[{\"bearer\":[]}],\"summary\":\"Get aggregated conversions reporting data\",\"tags\":[\"Reporting\"]}}},\"info\":{\"title\":\"Aidem Ads API\",\"description\":\"\",\"version\":\"1.0\",\"contact\":{}},\"tags\":[],\"servers\":[],\"components\":{\"securitySchemes\":{\"bearer\":{\"scheme\":\"bearer\",\"bearerFormat\":\"JWT\",\"type\":\"http\"}},\"schemas\":{\"User\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\",\"example\":\"uuid\"},\"sub\":{\"type\":\"string\",\"example\":\"sub\"},\"email\":{\"type\":\"string\",\"example\":\"email@example.com\"},\"email_verified\":{\"type\":\"object\",\"example\":false},\"first_name\":{\"type\":\"object\",\"example\":\"John\"},\"last_name\":{\"type\":\"object\",\"example\":\"Doe\"}},\"required\":[\"id\",\"sub\",\"email\",\"email_verified\",\"first_name\"]},\"CreateOrganization\":{\"type\":\"object\",\"properties\":{\"name\":{\"description\":\"Organization name\",\"type\":\"string\",\"maxLength\":191,\"minLength\":1},\"active\":{\"description\":\"Whether the organization is active\",\"type\":\"boolean\",\"default\":true},\"invoice_address\":{\"description\":\"The address to reference in invoices for the Organization\",\"type\":\"object\",\"properties\":{\"line1\":{\"type\":\"string\"},\"line2\":{\"type\":\"string\"},\"city\":{\"type\":\"string\"},\"state\":{\"type\":\"string\"},\"zip_code\":{\"type\":\"string\"},\"country\":{\"description\":\"Two letters country code\",\"type\":\"string\"}},\"required\":[\"line1\",\"city\",\"state\",\"zip_code\",\"country\"]},\"invoice_email\":{\"description\":\"The email to send invoices to for the Organization\",\"type\":\"string\",\"format\":\"email\"},\"invoice_name\":{\"description\":\"The name that should appear in invoices for the Organization\",\"type\":\"string\",\"minLength\":1}},\"required\":[\"name\",\"invoice_address\",\"invoice_email\",\"invoice_name\"]},\"Meta\":{\"type\":\"object\",\"properties\":{\"count\":{\"type\":\"number\"},\"lastPage\":{\"type\":\"number\"},\"currentPage\":{\"type\":\"number\"},\"totalPerPage\":{\"type\":\"number\"},\"prevPage\":{\"type\":\"number\",\"nullable\":true,\"example\":1},\"nextPage\":{\"type\":\"number\",\"nullable\":true,\"example\":null}},\"required\":[\"count\",\"lastPage\",\"currentPage\",\"totalPerPage\",\"prevPage\",\"nextPage\"]},\"OrganizationOutDto\":{\"type\":\"object\",\"properties\":{\"name\":{\"type\":\"string\",\"example\":\"Account 1\"},\"id\":{\"type\":\"string\",\"example\":\"0fa33117-4026-43ad-94fe-2a6189ef582c\"},\"active\":{\"type\":\"boolean\",\"example\":false},\"created_at\":{\"format\":\"date-time\",\"type\":\"string\",\"example\":\"2011-10-05T14:48:00.000Z\"},\"updated_at\":{\"format\":\"date-time\",\"type\":\"string\",\"example\":\"2011-10-05T14:48:00.000Z\"}},\"required\":[\"name\",\"id\",\"active\",\"created_at\",\"updated_at\"]},\"PatchOrganization\":{\"type\":\"object\",\"properties\":{\"name\":{\"description\":\"Organization name\",\"type\":\"string\",\"maxLength\":191,\"minLength\":1},\"active\":{\"description\":\"Whether the organization is active\",\"type\":\"boolean\",\"default\":true},\"invoice_address\":{\"description\":\"The address to reference in invoices for the Organization\",\"type\":\"object\",\"properties\":{\"line1\":{\"type\":\"string\"},\"line2\":{\"type\":\"string\"},\"city\":{\"type\":\"string\"},\"state\":{\"type\":\"string\"},\"zip_code\":{\"type\":\"string\"},\"country\":{\"description\":\"Two letters country code\",\"type\":\"string\"}},\"required\":[\"line1\",\"city\",\"state\",\"zip_code\",\"country\"]},\"invoice_email\":{\"description\":\"The email to send invoices to for the Organization\",\"type\":\"string\",\"format\":\"email\"},\"invoice_name\":{\"description\":\"The name that should appear in invoices for the Organization\",\"type\":\"string\",\"minLength\":1}}},\"ConnectOrganizationDto\":{\"type\":\"object\",\"properties\":{\"role\":{\"description\":\"The role of the user with respect to the organization\",\"type\":\"string\",\"enum\":[\"admin\",\"write\",\"read\",\"restricted\"],\"x-enumNames\":[\"admin\",\"write\",\"read\",\"restricted\"]},\"email\":{\"description\":\"The email of the user\",\"type\":\"string\",\"format\":\"email\"},\"advertisers\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"id\":{\"description\":\"The id of the advertiser\",\"type\":\"string\",\"format\":\"uuid\"},\"role\":{\"description\":\"The role of the users with respect to the advertiser\",\"type\":\"string\",\"enum\":[\"admin\",\"write\",\"read\"],\"x-enumNames\":[\"admin\",\"write\",\"read\"]}},\"required\":[\"id\",\"role\"]}}},\"required\":[\"role\",\"email\"]},\"ImpressionsStatsDto\":{\"type\":\"object\",\"properties\":{\"advertisers\":{\"description\":\"Advertiser IDs\",\"type\":\"array\",\"items\":{\"type\":\"string\",\"format\":\"uuid\"}},\"campaigns\":{\"description\":\"Campaign IDs\",\"type\":\"array\",\"items\":{\"type\":\"string\",\"format\":\"uuid\"}},\"line_items\":{\"description\":\"Line item IDs\",\"type\":\"array\",\"items\":{\"type\":\"string\",\"format\":\"uuid\"}},\"creatives\":{\"description\":\"Creative IDs\",\"type\":\"array\",\"items\":{\"type\":\"string\",\"format\":\"uuid\"}}}},\"CreateAdvertiser\":{\"type\":\"object\",\"properties\":{\"name\":{\"description\":\"The name of the advertiser\",\"type\":\"string\",\"minLength\":1,\"maxLength\":191},\"description\":{\"description\":\"A description to attach to the advertiser\",\"type\":\"string\",\"maxLength\":191},\"domain\":{\"description\":\"The domain the advertiser refers to\",\"type\":\"string\",\"format\":\"uri\"},\"category_key\":{\"description\":\"The category the advertiser refers to\",\"type\":\"string\",\"maxLength\":191},\"app_bundle\":{\"description\":\"The app bundle for the advertiser\",\"type\":\"string\",\"maxLength\":191},\"active\":{\"description\":\"Whether the advertiser should be active\",\"type\":\"boolean\",\"default\":true},\"default_continent\":{\"description\":\"The continent the advertiser should operate into\",\"type\":\"string\",\"enum\":[\"EMEA\",\"NAM\",\"APAC\"],\"x-enumNames\":[\"EMEA\",\"NAM\",\"APAC\"]}},\"required\":[\"name\",\"domain\",\"category_key\"]},\"AdvertiserWithDetails\":{\"type\":\"object\",\"properties\":{\"name\":{\"type\":\"string\",\"example\":\"Advertiser 1\"},\"id\":{\"type\":\"string\",\"example\":\"0fa33117-4026-43ad-94fe-2a6189ef582c\"},\"active\":{\"type\":\"boolean\",\"example\":false},\"dsp_id\":{\"type\":\"object\",\"example\":null},\"dsp_context_status\":{\"type\":\"string\",\"enum\":[\"PENDING\",\"FAILED\",\"SYNCED\"]},\"domain\":{\"type\":\"string\",\"example\":\"https://example.com\"},\"app_bundle\":{\"type\":\"object\",\"example\":\"com.example\"},\"alternative_id\":{\"type\":\"object\",\"example\":\"123\"},\"category_key\":{\"type\":\"string\",\"example\":\"IAB19\"},\"created_at\":{\"format\":\"date-time\",\"type\":\"string\",\"example\":\"2011-10-05T14:48:00.000Z\"},\"updated_at\":{\"format\":\"date-time\",\"type\":\"string\",\"example\":\"2011-10-05T14:48:00.000Z\"},\"description\":{\"type\":\"object\",\"example\":\"Advertiser Description\"},\"currency_key\":{\"type\":\"string\",\"example\":\"USD\"},\"default_continent\":{\"type\":\"string\",\"enum\":[\"EMEA\",\"NAM\",\"APAC\"],\"example\":\"NAM\"},\"organization_id\":{\"type\":\"string\",\"example\":\"0fa33117-4026-43ad-94fe-2a6189ef582d\"}},\"required\":[\"name\",\"id\",\"active\",\"dsp_id\",\"dsp_context_status\",\"domain\",\"app_bundle\",\"alternative_id\",\"category_key\",\"created_at\",\"updated_at\",\"description\",\"currency_key\",\"default_continent\",\"organization_id\"]},\"PatchAdvertiser\":{\"type\":\"object\",\"properties\":{\"name\":{\"description\":\"The name of the advertiser\",\"type\":\"string\",\"minLength\":1,\"maxLength\":191},\"description\":{\"description\":\"A description to attach to the advertiser\",\"type\":\"string\",\"maxLength\":191},\"domain\":{\"description\":\"The domain the advertiser refers to\",\"type\":\"string\",\"format\":\"uri\"},\"category_key\":{\"description\":\"The category the advertiser refers to\",\"type\":\"string\",\"maxLength\":191},\"app_bundle\":{\"description\":\"The app bundle for the advertiser\",\"type\":\"string\",\"maxLength\":191},\"active\":{\"description\":\"Whether the advertiser should be active\",\"type\":\"boolean\",\"default\":true},\"default_continent\":{\"description\":\"The continent the advertiser should operate into\",\"type\":\"string\",\"enum\":[\"EMEA\",\"NAM\",\"APAC\"],\"x-enumNames\":[\"EMEA\",\"NAM\",\"APAC\"]}}},\"ReportingDashboard\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"advertiser_id\":{\"type\":\"string\",\"format\":\"uuid\"},\"spend\":{\"type\":\"number\"},\"impressions\":{\"type\":\"number\"},\"reach_person\":{\"type\":\"number\"},\"reach_household\":{\"type\":\"number\"},\"conversions\":{\"type\":\"number\"},\"conversion_rate\":{\"type\":\"number\"},\"conversions_value\":{\"type\":\"number\"},\"cpa\":{\"type\":\"number\"},\"roas\":{\"type\":\"number\"},\"group_fields\":{\"type\":\"object\",\"additionalProperties\":{\"type\":\"string\"}}},\"required\":[\"advertiser_id\",\"spend\",\"impressions\",\"reach_person\",\"reach_household\",\"conversions\",\"conversion_rate\",\"conversions_value\",\"cpa\",\"roas\",\"group_fields\"]}},\"CreateCampaignDto\":{\"type\":\"object\",\"properties\":{\"name\":{\"description\":\"The name of the campaign\",\"type\":\"string\",\"maxLength\":191,\"minLength\":4},\"active\":{\"description\":\"Whether the campaign should be active\",\"type\":\"boolean\",\"default\":true},\"start_datetime\":{\"description\":\"Start date and time for the campaign\",\"type\":\"string\",\"format\":\"date-time\"},\"end_datetime\":{\"description\":\"End date and time for the campaign\",\"type\":\"string\",\"format\":\"date-time\",\"nullable\":true},\"description\":{\"description\":\"A description for the campaign\",\"type\":\"string\",\"nullable\":true},\"budget\":{\"description\":\"The overall budget for the campaign\",\"type\":\"number\",\"minimum\":0,\"exclusiveMinimum\":true},\"daily_budget\":{\"description\":\"The daily budget for the campaign\",\"type\":\"number\",\"nullable\":true},\"vendor_fees\":{\"description\":\"Vendor fees for the campaign\",\"type\":\"array\",\"maxItems\":3,\"items\":{\"type\":\"object\",\"properties\":{\"vendor_id\":{\"type\":\"string\",\"format\":\"uuid\"},\"name\":{\"type\":\"string\",\"minLength\":1,\"maxLength\":191},\"type\":{\"type\":\"string\",\"enum\":[\"DEFAULT\",\"CPM\",\"PERCENTAGE\"],\"default\":\"DEFAULT\"},\"amount\":{\"description\":\"Required for non-default vendor fees\",\"type\":\"number\",\"nullable\":true}},\"required\":[\"vendor_id\",\"name\"],\"nullable\":true},\"nullable\":true},\"frequency_caps\":{\"description\":\"Frequency caps for the campaign\",\"type\":\"object\",\"properties\":{\"type\":{\"type\":\"string\",\"enum\":[\"STANDARD\",\"IP_ADDRESS\",\"PERSON_ID\",\"HOUSE_HOLD_ID\"],\"default\":\"STANDARD\"},\"use_fallback\":{\"type\":\"boolean\",\"default\":true},\"items\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"impressions\":{\"type\":\"number\",\"minimum\":1,\"exclusiveMinimum\":false},\"interval\":{\"type\":\"number\",\"minimum\":1,\"exclusiveMinimum\":false},\"time_unit\":{\"type\":\"string\",\"enum\":[\"DAY\",\"HOUR\",\"MINUTE\",\"WEEK\"],\"default\":\"DAY\"}},\"required\":[\"impressions\",\"interval\"]}}},\"required\":[\"items\"]},\"advertiser_id\":{\"description\":\"The ID of the advertiser the campaign refers to\",\"type\":\"string\",\"format\":\"uuid\"}},\"required\":[\"name\",\"start_datetime\",\"budget\",\"frequency_caps\",\"advertiser_id\"]},\"FrequencyCap\":{\"type\":\"object\",\"properties\":{\"type\":{\"type\":\"string\",\"enum\":[\"STANDARD\",\"IP_ADDRESS\",\"PERSON_ID\",\"HOUSE_HOLD_ID\"],\"default\":\"STANDARD\"},\"use_fallback\":{\"type\":\"boolean\",\"default\":true},\"items\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"impressions\":{\"type\":\"number\",\"minimum\":1,\"exclusiveMinimum\":false},\"interval\":{\"type\":\"number\",\"minimum\":1,\"exclusiveMinimum\":false},\"time_unit\":{\"type\":\"string\",\"enum\":[\"DAY\",\"HOUR\",\"MINUTE\",\"WEEK\"],\"default\":\"DAY\"}},\"required\":[\"impressions\",\"interval\"]}}},\"required\":[\"items\"]},\"CampaignWithCount\":{\"type\":\"object\",\"properties\":{\"frequency_caps\":{\"type\":\"object\",\"properties\":{\"type\":{\"type\":\"string\",\"enum\":[\"STANDARD\",\"IP_ADDRESS\",\"PERSON_ID\",\"HOUSE_HOLD_ID\"],\"default\":\"STANDARD\"},\"use_fallback\":{\"type\":\"boolean\",\"default\":true},\"items\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"impressions\":{\"type\":\"number\",\"minimum\":1,\"exclusiveMinimum\":false},\"interval\":{\"type\":\"number\",\"minimum\":1,\"exclusiveMinimum\":false},\"time_unit\":{\"type\":\"string\",\"enum\":[\"DAY\",\"HOUR\",\"MINUTE\",\"WEEK\"],\"default\":\"DAY\"}},\"required\":[\"impressions\",\"interval\"]}}},\"required\":[\"items\"]},\"start_datetime\":{\"format\":\"date-time\",\"type\":\"string\",\"example\":1732795153},\"end_datetime\":{\"type\":\"object\",\"example\":173279515},\"budget_type\":{\"type\":\"string\",\"enum\":[\"SPEND_WITH_VENDOR_FEES\",\"SPEND\",\"IMPRESSION\"],\"example\":\"SPEND_WITH_VENDOR_FEES\",\"description\":\"The type of budget. Will always be SPEND_WITH_VENDOR_FEES\"}},\"required\":[\"frequency_caps\",\"start_datetime\",\"end_datetime\",\"budget_type\"]},\"PatchCampaignDto\":{\"type\":\"object\",\"properties\":{\"name\":{\"description\":\"The name of the campaign\",\"type\":\"string\",\"maxLength\":191,\"minLength\":4},\"active\":{\"description\":\"Whether the campaign should be active\",\"type\":\"boolean\",\"default\":true},\"start_datetime\":{\"description\":\"Start date and time for the campaign\",\"type\":\"string\",\"format\":\"date-time\"},\"end_datetime\":{\"description\":\"End date and time for the campaign\",\"type\":\"string\",\"format\":\"date-time\",\"nullable\":true},\"description\":{\"description\":\"A description for the campaign\",\"type\":\"string\",\"nullable\":true},\"budget\":{\"description\":\"The overall budget for the campaign\",\"type\":\"number\",\"minimum\":0,\"exclusiveMinimum\":true},\"daily_budget\":{\"description\":\"The daily budget for the campaign\",\"type\":\"number\",\"nullable\":true},\"vendor_fees\":{\"description\":\"Vendor fees for the campaign\",\"type\":\"array\",\"maxItems\":3,\"items\":{\"type\":\"object\",\"properties\":{\"vendor_id\":{\"type\":\"string\",\"format\":\"uuid\"},\"name\":{\"type\":\"string\",\"minLength\":1,\"maxLength\":191},\"type\":{\"type\":\"string\",\"enum\":[\"DEFAULT\",\"CPM\",\"PERCENTAGE\"],\"default\":\"DEFAULT\"},\"amount\":{\"description\":\"Required for non-default vendor fees\",\"type\":\"number\",\"nullable\":true}},\"required\":[\"vendor_id\",\"name\"],\"nullable\":true},\"nullable\":true},\"frequency_caps\":{\"description\":\"Frequency caps for the campaign\",\"type\":\"object\",\"properties\":{\"type\":{\"type\":\"string\",\"enum\":[\"STANDARD\",\"IP_ADDRESS\",\"PERSON_ID\",\"HOUSE_HOLD_ID\"],\"default\":\"STANDARD\"},\"use_fallback\":{\"type\":\"boolean\",\"default\":true},\"items\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"impressions\":{\"type\":\"number\",\"minimum\":1,\"exclusiveMinimum\":false},\"interval\":{\"type\":\"number\",\"minimum\":1,\"exclusiveMinimum\":false},\"time_unit\":{\"type\":\"string\",\"enum\":[\"DAY\",\"HOUR\",\"MINUTE\",\"WEEK\"],\"default\":\"DAY\"}},\"required\":[\"impressions\",\"interval\"]}}},\"required\":[\"items\"]}}},\"CreateLineItemDto\":{\"type\":\"object\",\"properties\":{\"name\":{\"description\":\"The name of the line item\",\"type\":\"string\"},\"description\":{\"description\":\"A description for the line item\",\"type\":\"string\",\"nullable\":true},\"active\":{\"description\":\"Whether the line item should be active\",\"type\":\"boolean\",\"default\":false},\"start_datetime\":{\"description\":\"The start date and time of the line item\"},\"end_datetime\":{\"description\":\"The end date and time of the line item\"},\"type\":{\"description\":\"The type of line item\",\"type\":\"string\",\"enum\":[\"VIDEO\",\"BANNER\",\"CTV\"],\"x-enumNames\":[\"VIDEO\",\"BANNER\",\"CTV\"]},\"advertiser_id\":{\"description\":\"The ID of the advertiser the line item refers to\",\"type\":\"string\",\"format\":\"uuid\"},\"campaign_id\":{\"description\":\"The ID of the campaign the line item refers to\",\"type\":\"string\",\"format\":\"uuid\"},\"budget_carryover\":{\"description\":\"The budget carry over policy of the line item\",\"type\":\"string\",\"enum\":[\"NONE\",\"CARRY_OVER\",\"EVENLY_DISTRIBUTE\",\"PRORATED_DISTRIBUTE\"],\"x-enumNames\":[\"NONE\",\"CARRY_OVER\",\"EVENLY_DISTRIBUTE\",\"PRORATED_DISTRIBUTE\"],\"default\":\"NONE\"}},\"required\":[\"name\",\"start_datetime\",\"end_datetime\",\"type\",\"advertiser_id\",\"campaign_id\"]},\"BiddingDto\":{\"type\":\"object\",\"properties\":{\"type\":{\"type\":\"string\",\"enum\":[\"FLAT_CPM\",\"CPC\",\"CPA\"],\"x-enumNames\":[\"FLAT_CPM\",\"CPC\",\"CPA\"],\"default\":\"FLAT_CPM\"},\"bid_shading_control\":{\"type\":\"string\",\"enum\":[\"NORMAL\",\"LESS_AGGRESSIVE\",\"MORE_AGGRESSIVE\"],\"x-enumNames\":[\"NORMAL\",\"LESS_AGGRESSIVE\",\"MORE_AGGRESSIVE\"]},\"cpm\":{\"type\":\"number\"}},\"required\":[\"bid_shading_control\",\"cpm\"]},\"CreatePacingStrategyDto\":{\"type\":\"object\",\"properties\":{\"type\":{\"type\":\"string\",\"enum\":[\"DAILY\",\"LIFETIME\",\"FLIGHT\"],\"x-enumNames\":[\"Daily\",\"Lifetime\",\"Flight\"],\"default\":\"LIFETIME\"},\"pacing_behavior\":{\"type\":\"string\",\"enum\":[\"EVEN\",\"AHEAD\"],\"x-enumNames\":[\"Even\",\"Ahead\"],\"default\":\"EVEN\"},\"catchup_behavior\":{\"type\":\"string\",\"enum\":[\"EVEN\",\"IMMEDIATE\",\"SMOOTH\"],\"x-enumNames\":[\"Even\",\"Immediate\",\"Smooth\"],\"default\":\"EVEN\"},\"multiplier\":{\"type\":\"number\",\"nullable\":true,\"default\":1}}},\"LineItem\":{\"type\":\"object\",\"properties\":{\"effective_status\":{\"type\":\"string\",\"enum\":[\"DELIVERING\",\"DELIVERED\",\"STOPPED\",\"INACTIVE\",\"UNKNOWN\"]},\"type\":{\"type\":\"string\",\"enum\":[\"VIDEO\",\"BANNER\",\"CTV\"]},\"budget_carryover\":{\"type\":\"string\",\"enum\":[\"NONE\",\"CARRY_OVER\",\"EVENLY_DISTRIBUTE\",\"PRORATED_DISTRIBUTE\"]},\"bidding_strategy\":{\"type\":\"object\",\"properties\":{\"type\":{\"type\":\"string\",\"enum\":[\"FLAT_CPM\",\"CPC\",\"CPA\"],\"x-enumNames\":[\"FLAT_CPM\",\"CPC\",\"CPA\"],\"default\":\"FLAT_CPM\"},\"bid_shading_control\":{\"type\":\"string\",\"enum\":[\"NORMAL\",\"LESS_AGGRESSIVE\",\"MORE_AGGRESSIVE\"],\"x-enumNames\":[\"NORMAL\",\"LESS_AGGRESSIVE\",\"MORE_AGGRESSIVE\"]},\"cpm\":{\"type\":\"number\"}},\"required\":[\"bid_shading_control\",\"cpm\"]},\"pacing_strategy\":{\"type\":\"object\",\"properties\":{\"type\":{\"type\":\"string\",\"enum\":[\"DAILY\",\"LIFETIME\",\"FLIGHT\"],\"x-enumNames\":[\"Daily\",\"Lifetime\",\"Flight\"],\"default\":\"LIFETIME\"},\"pacing_behavior\":{\"type\":\"string\",\"enum\":[\"EVEN\",\"AHEAD\"],\"x-enumNames\":[\"Even\",\"Ahead\"],\"default\":\"EVEN\"},\"catchup_behavior\":{\"type\":\"string\",\"enum\":[\"EVEN\",\"IMMEDIATE\",\"SMOOTH\"],\"x-enumNames\":[\"Even\",\"Immediate\",\"Smooth\"],\"default\":\"EVEN\"},\"multiplier\":{\"type\":\"number\",\"nullable\":true,\"default\":1}}},\"frequency_caps\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"type\":{\"type\":\"string\",\"enum\":[\"STANDARD\",\"IP_ADDRESS\",\"PERSON_ID\",\"HOUSE_HOLD_ID\"],\"default\":\"STANDARD\"},\"use_fallback\":{\"type\":\"boolean\",\"default\":true},\"items\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"impressions\":{\"type\":\"number\",\"minimum\":1,\"exclusiveMinimum\":false},\"interval\":{\"type\":\"number\",\"minimum\":1,\"exclusiveMinimum\":false},\"time_unit\":{\"type\":\"string\",\"enum\":[\"DAY\",\"HOUR\",\"MINUTE\",\"WEEK\"],\"default\":\"DAY\"}},\"required\":[\"impressions\",\"interval\"]}}},\"required\":[\"items\"]}},\"budget_type\":{\"type\":\"string\",\"enum\":[\"SPEND_WITH_VENDOR_FEES\",\"SPEND\",\"IMPRESSION\"]}},\"required\":[\"effective_status\",\"type\",\"budget_carryover\",\"bidding_strategy\",\"pacing_strategy\",\"frequency_caps\",\"budget_type\"]},\"PatchLineItemDto\":{\"type\":\"object\",\"properties\":{\"name\":{\"description\":\"The name of the line item\",\"type\":\"string\"},\"description\":{\"description\":\"A description for the line item\",\"type\":\"string\",\"nullable\":true},\"active\":{\"description\":\"Whether the line item should be active\",\"type\":\"boolean\",\"default\":false},\"start_datetime\":{\"description\":\"The start date and time of the line item\"},\"end_datetime\":{\"description\":\"The end date and time of the line item\"},\"type\":{\"description\":\"The type of line item\",\"type\":\"string\",\"enum\":[\"VIDEO\",\"BANNER\",\"CTV\"],\"x-enumNames\":[\"VIDEO\",\"BANNER\",\"CTV\"]},\"budget_carryover\":{\"description\":\"The budget carry over policy of the line item\",\"type\":\"string\",\"enum\":[\"NONE\",\"CARRY_OVER\",\"EVENLY_DISTRIBUTE\",\"PRORATED_DISTRIBUTE\"],\"x-enumNames\":[\"NONE\",\"CARRY_OVER\",\"EVENLY_DISTRIBUTE\",\"PRORATED_DISTRIBUTE\"],\"default\":\"NONE\"},\"budget_type\":{\"description\":\"The type of budget of the line item\",\"type\":\"string\",\"enum\":[\"SPEND_WITH_VENDOR_FEES\",\"SPEND\",\"IMPRESSION\"],\"x-enumNames\":[\"SPEND_WITH_VENDOR_FEES\",\"SPEND\",\"IMPRESSION\"],\"nullable\":true,\"default\":\"SPEND_WITH_VENDOR_FEES\"},\"overall_budget\":{\"description\":\"The overall budget of the line item\",\"type\":\"number\",\"minimum\":0,\"exclusiveMinimum\":true,\"nullable\":true},\"daily_budget\":{\"description\":\"The daily budget of the line item\",\"type\":\"number\",\"nullable\":true},\"bidding_strategy\":{\"description\":\"The bidding strategy of the line item\",\"type\":\"object\",\"properties\":{\"type\":{\"type\":\"string\",\"enum\":[\"FLAT_CPM\",\"CPC\",\"CPA\"],\"x-enumNames\":[\"FLAT_CPM\",\"CPC\",\"CPA\"],\"default\":\"FLAT_CPM\"},\"bid_shading_control\":{\"type\":\"string\",\"enum\":[\"NORMAL\",\"LESS_AGGRESSIVE\",\"MORE_AGGRESSIVE\"],\"x-enumNames\":[\"NORMAL\",\"LESS_AGGRESSIVE\",\"MORE_AGGRESSIVE\"]},\"cpm\":{\"type\":\"number\"}},\"required\":[\"bid_shading_control\",\"cpm\"]},\"pacing_strategy\":{\"description\":\"The pacing strategy of the line item\",\"type\":\"object\",\"properties\":{\"type\":{\"type\":\"string\",\"enum\":[\"DAILY\",\"LIFETIME\",\"FLIGHT\"],\"x-enumNames\":[\"Daily\",\"Lifetime\",\"Flight\"],\"default\":\"LIFETIME\"},\"pacing_behavior\":{\"type\":\"string\",\"enum\":[\"EVEN\",\"AHEAD\"],\"x-enumNames\":[\"Even\",\"Ahead\"],\"default\":\"EVEN\"},\"catchup_behavior\":{\"type\":\"string\",\"enum\":[\"EVEN\",\"IMMEDIATE\",\"SMOOTH\"],\"x-enumNames\":[\"Even\",\"Immediate\",\"Smooth\"],\"default\":\"EVEN\"},\"multiplier\":{\"type\":\"number\",\"nullable\":true,\"default\":1}}},\"vendor_fees\":{\"description\":\"The vendor fees of the line item\",\"type\":\"array\",\"maxItems\":3,\"items\":{\"type\":\"object\",\"properties\":{\"vendor_id\":{\"type\":\"string\",\"format\":\"uuid\"},\"name\":{\"type\":\"string\",\"minLength\":1,\"maxLength\":191},\"type\":{\"type\":\"string\",\"enum\":[\"DEFAULT\",\"CPM\",\"PERCENTAGE\"],\"default\":\"DEFAULT\"},\"amount\":{\"description\":\"Required for non-default vendor fees\",\"type\":\"number\",\"nullable\":true}},\"required\":[\"vendor_id\",\"name\"],\"nullable\":true}},\"frequency_caps\":{\"description\":\"The frequency caps of the line item\",\"type\":\"object\",\"properties\":{\"type\":{\"type\":\"string\",\"enum\":[\"STANDARD\",\"IP_ADDRESS\",\"PERSON_ID\",\"HOUSE_HOLD_ID\"],\"default\":\"STANDARD\"},\"use_fallback\":{\"type\":\"boolean\",\"default\":true},\"items\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"impressions\":{\"type\":\"number\",\"minimum\":1,\"exclusiveMinimum\":false},\"interval\":{\"type\":\"number\",\"minimum\":1,\"exclusiveMinimum\":false},\"time_unit\":{\"type\":\"string\",\"enum\":[\"DAY\",\"HOUR\",\"MINUTE\",\"WEEK\"],\"default\":\"DAY\"}},\"required\":[\"impressions\",\"interval\"]}}},\"required\":[\"items\"]}}},\"PatchAudienceDto\":{\"type\":\"object\",\"properties\":{\"prompt\":{\"type\":\"string\",\"nullable\":true},\"include\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\",\"format\":\"uuid\"},\"audience_schema_key_id\":{\"type\":\"string\",\"format\":\"uuid\"}},\"required\":[\"id\",\"audience_schema_key_id\"]}},\"exclude\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\",\"format\":\"uuid\"},\"audience_schema_key_id\":{\"type\":\"string\",\"format\":\"uuid\"}},\"required\":[\"id\",\"audience_schema_key_id\"]}}},\"required\":[\"include\",\"exclude\"]},\"AudienceStatsDto\":{\"type\":\"object\",\"properties\":{\"first_party_audience_filter\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\",\"format\":\"uuid\"},\"included\":{\"type\":\"boolean\"}},\"required\":[\"id\",\"included\"]}},\"audience_filter\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"name\":{\"type\":\"string\"},\"values\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\",\"format\":\"uuid\"},\"included\":{\"type\":\"boolean\"}},\"required\":[\"id\",\"included\"]}}},\"required\":[\"name\",\"values\"]}},\"days\":{\"type\":\"integer\",\"minimum\":1,\"exclusiveMinimum\":false}},\"required\":[\"first_party_audience_filter\",\"audience_filter\"]},\"PatchInventoryDto\":{\"type\":\"object\",\"properties\":{\"include\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\",\"format\":\"uuid\"},\"inventory_schema_key_id\":{\"type\":\"string\",\"format\":\"uuid\"}},\"required\":[\"id\",\"inventory_schema_key_id\"]}},\"exclude\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\",\"format\":\"uuid\"},\"inventory_schema_key_id\":{\"type\":\"string\",\"format\":\"uuid\"}},\"required\":[\"id\",\"inventory_schema_key_id\"]}}},\"required\":[\"include\",\"exclude\"]},\"PatchFirstPartyAudienceDto\":{\"type\":\"object\",\"properties\":{\"include\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\",\"format\":\"uuid\"},\"audience_custom_list_schema_key_id\":{\"type\":\"string\",\"format\":\"uuid\"}},\"required\":[\"id\",\"audience_custom_list_schema_key_id\"]}},\"exclude\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"id\":{\"type\":\"string\",\"format\":\"uuid\"},\"audience_custom_list_schema_key_id\":{\"type\":\"string\",\"format\":\"uuid\"}},\"required\":[\"id\",\"audience_custom_list_schema_key_id\"]}}},\"required\":[\"include\",\"exclude\"]},\"ConnectCreativesDto\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"creative_id\":{\"type\":\"string\",\"format\":\"uuid\"},\"weight\":{\"type\":\"number\",\"nullable\":true},\"start_datetime\":{\"type\":\"string\",\"format\":\"date-time\",\"nullable\":true},\"end_datetime\":{\"type\":\"string\",\"format\":\"date-time\",\"nullable\":true}},\"required\":[\"creative_id\",\"weight\"]}},\"FlightsDto\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"id\":{\"description\":\"The ID of the flight\",\"type\":\"string\",\"format\":\"uuid\"},\"name\":{\"description\":\"The name of the flight\",\"type\":\"string\"},\"start_datetime\":{\"description\":\"The start date and time of the flight\",\"type\":\"string\",\"format\":\"date-time\"},\"end_datetime\":{\"description\":\"The end date and tieme of the flight\",\"type\":\"string\",\"format\":\"date-time\"},\"budget\":{\"description\":\"The budget of the flight\",\"type\":\"number\"}},\"required\":[\"name\",\"start_datetime\",\"end_datetime\",\"budget\"]}},\"CreateCreativeDto\":{\"type\":\"object\",\"properties\":{\"name\":{\"description\":\"The name of the creative\",\"type\":\"string\",\"maxLength\":191,\"minLength\":1},\"type\":{\"description\":\"The type of the creative\",\"type\":\"string\",\"enum\":[\"VIDEO\",\"BANNER\"],\"x-enumNames\":[\"VIDEO\",\"BANNER\"]},\"active\":{\"description\":\"Whether the creative is active\",\"type\":\"boolean\",\"default\":true},\"click_url\":{\"description\":\"The click url of the creative\",\"type\":\"string\",\"format\":\"uri\"},\"landing_page_url\":{\"description\":\"The landing page url of the creative\"},\"third_party_pixels\":{\"description\":\"Optional third party pixels to trigger for the creative\",\"type\":\"array\",\"maxItems\":5,\"items\":{\"type\":\"string\",\"format\":\"uri\"}},\"start_datetime\":{\"description\":\"The start date and time of the creative\",\"type\":\"string\",\"format\":\"date-time\",\"nullable\":true},\"end_datetime\":{\"description\":\"The end date and time of the creative\",\"type\":\"string\",\"format\":\"date-time\",\"nullable\":true},\"description\":{\"description\":\"The description of the creative\",\"type\":\"string\",\"nullable\":true},\"advertiser_id\":{\"description\":\"The ID of the advertiser the creative refers to\",\"type\":\"string\",\"format\":\"uuid\"}},\"required\":[\"name\",\"type\",\"click_url\",\"advertiser_id\"]},\"CreativeWithCounts\":{\"type\":\"object\",\"properties\":{\"type\":{\"type\":\"string\",\"enum\":[\"VIDEO\",\"BANNER\"]},\"active\":{\"type\":\"boolean\",\"example\":false},\"ad_tag_creation_status\":{\"type\":\"string\",\"enum\":[\"IN_PROGRESS\",\"SUCCEEDED\",\"FAILED\",\"UNKNOWN\"]}},\"required\":[\"type\",\"active\",\"ad_tag_creation_status\"]},\"PatchCreativeDto\":{\"type\":\"object\",\"properties\":{\"name\":{\"description\":\"The name of the creative\",\"type\":\"string\",\"maxLength\":191,\"minLength\":1},\"active\":{\"description\":\"Whether the creative is active\",\"type\":\"boolean\",\"default\":true},\"click_url\":{\"description\":\"The click url of the creative\",\"type\":\"string\",\"format\":\"uri\"},\"landing_page_url\":{\"description\":\"The landing page url of the creative\"},\"third_party_pixels\":{\"description\":\"Optional third party pixels to trigger for the creative\",\"type\":\"array\",\"maxItems\":5,\"items\":{\"type\":\"string\",\"format\":\"uri\"}},\"start_datetime\":{\"description\":\"The start date and time of the creative\",\"type\":\"string\",\"format\":\"date-time\",\"nullable\":true},\"end_datetime\":{\"description\":\"The end date and time of the creative\",\"type\":\"string\",\"format\":\"date-time\",\"nullable\":true},\"description\":{\"description\":\"The description of the creative\",\"type\":\"string\",\"nullable\":true}}},\"ConnectLineItemsDto\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"line_item_id\":{\"type\":\"string\",\"format\":\"uuid\"},\"start_datetime\":{\"type\":\"string\",\"format\":\"date-time\",\"nullable\":true},\"end_datetime\":{\"type\":\"string\",\"format\":\"date-time\",\"nullable\":true},\"weight\":{\"type\":\"number\",\"maximum\":100,\"exclusiveMaximum\":false,\"minimum\":0,\"exclusiveMinimum\":false}},\"required\":[\"line_item_id\",\"weight\"]}},\"CreateAudienceCustomListDto\":{\"type\":\"object\",\"properties\":{\"name\":{\"type\":\"string\",\"minLength\":1,\"maxLength\":191},\"column_map\":{\"type\":\"array\",\"items\":{\"type\":\"string\",\"enum\":[\"aidem_person_id\",\"aidem_household_id\",\"email\",\"phone_number\",\"first_name\",\"last_name\",\"address_line_1\",\"address_line_2\",\"state\",\"zip_code\",\"auto_vin\",\"linkedin_profile\",\"up_id\",\"lalvoter_id\"],\"x-enumNames\":[\"AIDEM_PERSON_ID\",\"AIDEM_HOUSEHOLD_ID\",\"EMAIL\",\"PHONE_NUMBER\",\"FIRST_NAME\",\"LAST_NAME\",\"ADDRESS_LINE_1\",\"ADDRESS_LINE_2\",\"STATE\",\"ZIP_CODE\",\"AUTO_VIN\",\"LINKEDIN_PROFILE\",\"UP_ID\",\"LALVOTER_ID\"],\"nullable\":true}},\"type\":{\"type\":\"string\",\"enum\":[\"EXACT\",\"LOOKALIKE\"],\"x-enumNames\":[\"EXACT\",\"LOOKALIKE\"]},\"advertiser_id\":{\"type\":\"string\",\"format\":\"uuid\"}},\"required\":[\"name\",\"column_map\",\"type\",\"advertiser_id\"]},\"AudienceCustomList\":{\"type\":\"object\",\"properties\":{}},\"PatchAudienceCustomListDto\":{\"type\":\"object\",\"properties\":{\"name\":{\"type\":\"string\",\"minLength\":1,\"maxLength\":191},\"type\":{\"type\":\"string\",\"enum\":[\"EXACT\",\"LOOKALIKE\"],\"x-enumNames\":[\"EXACT\",\"LOOKALIKE\"]}}},\"Integration\":{\"type\":\"object\",\"properties\":{}},\"CreateIntegration\":{\"type\":\"object\",\"properties\":{\"type\":{\"description\":\"The type of the integration\",\"type\":\"string\",\"enum\":[\"shopify\",\"web_stream_pixel\",\"conversion_api\"],\"x-enumNames\":[\"Shopify\",\"WebStreamPixel\",\"ConversionApi\"]},\"name\":{\"description\":\"The name of the integration\",\"type\":\"string\",\"minLength\":1},\"advertiser_id\":{\"description\":\"The ID of the advertiser the integration refers to\",\"type\":\"string\",\"format\":\"uuid\"}},\"required\":[\"type\",\"name\",\"advertiser_id\"]},\"GetStatsDto\":{\"type\":\"object\",\"properties\":{\"query\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"advertiser_id\":{\"description\":\"The ID of the advertiser the event refers to\",\"type\":\"string\"},\"event_name\":{\"description\":\"The name of the event\",\"type\":\"string\"},\"event_source\":{\"description\":\"The source of the event\",\"type\":\"string\",\"enum\":[\"shopify\",\"web_stream_pixel\",\"conversion_api\"],\"x-enumNames\":[\"Shopify\",\"WebStreamPixel\",\"ConversionApi\"]}},\"required\":[\"advertiser_id\",\"event_name\",\"event_source\"]}}},\"required\":[\"query\"]},\"AudienceRetargetEntity\":{\"type\":\"object\",\"properties\":{\"event_name\":{\"type\":\"string\",\"enum\":[\"AddPaymentInfo\",\"AddToCart\",\"AddToWishlist\",\"CompleteRegistration\",\"Contact\",\"CustomEvent\",\"CustomizeProduct\",\"ConfiguratorCompletion\",\"Donate\",\"DonateRecurring\",\"FindLocation\",\"InitiateCheckout\",\"Lead\",\"Purchase\",\"Schedule\",\"Search\",\"StartTrial\",\"SubmitApplication\",\"Subscribe\",\"ViewContent\",\"CoverageCheck\",\"CallMeBack\",\"ClickToCall\",\"DownloadBrochure\",\"TestDriveRequest\",\"DealerLookup\"]},\"lookback_window\":{\"type\":\"number\",\"minimum\":1,\"maximum\":30},\"type\":{\"type\":\"string\",\"enum\":[\"EXACT\",\"LOOKALIKE\"]}},\"required\":[\"event_name\",\"lookback_window\",\"type\"]},\"AudienceRetargetCreateDto\":{\"type\":\"object\",\"properties\":{\"name\":{\"type\":\"string\",\"minLength\":1},\"advertiser_id\":{\"type\":\"string\",\"format\":\"uuid\"},\"event_name\":{\"type\":\"string\",\"enum\":[\"AddPaymentInfo\",\"AddToCart\",\"AddToWishlist\",\"CompleteRegistration\",\"Contact\",\"CustomEvent\",\"CustomizeProduct\",\"ConfiguratorCompletion\",\"Donate\",\"DonateRecurring\",\"FindLocation\",\"InitiateCheckout\",\"Lead\",\"Purchase\",\"Schedule\",\"Search\",\"StartTrial\",\"SubmitApplication\",\"Subscribe\",\"ViewContent\",\"CoverageCheck\",\"CallMeBack\",\"ClickToCall\",\"DownloadBrochure\",\"TestDriveRequest\",\"DealerLookup\"],\"x-enumNames\":[\"AddPaymentInfo\",\"AddToCart\",\"AddToWishlist\",\"CompleteRegistration\",\"Contact\",\"CustomEvent\",\"CustomizeProduct\",\"ConfiguratorCompletion\",\"Donate\",\"DonateRecurring\",\"FindLocation\",\"InitiateCheckout\",\"Lead\",\"Purchase\",\"Schedule\",\"Search\",\"StartTrial\",\"SubmitApplication\",\"Subscribe\",\"ViewContent\",\"CoverageCheck\",\"CallMeBack\",\"ClickToCall\",\"DownloadBrochure\",\"TestDriveRequest\",\"DealerLookup\"]},\"type\":{\"type\":\"string\",\"enum\":[\"EXACT\",\"LOOKALIKE\"],\"x-enumNames\":[\"EXACT\",\"LOOKALIKE\"]},\"lookback_window\":{\"type\":\"integer\",\"minimum\":1,\"exclusiveMinimum\":false,\"maximum\":30,\"exclusiveMaximum\":false}},\"required\":[\"name\",\"advertiser_id\",\"event_name\",\"type\",\"lookback_window\"]},\"LineItemOnAudienceRetargetEntity\":{\"type\":\"object\",\"properties\":{}},\"LineItemOnAudienceRetargetUpdateCreateDto\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"properties\":{\"active\":{\"description\":\"Whether the association should be active\",\"type\":\"boolean\"},\"audience_retarget_id\":{\"description\":\"The ID of the audience retarget\",\"type\":\"string\",\"format\":\"uuid\"}},\"required\":[\"active\",\"audience_retarget_id\"]}},\"PatchUserDto\":{\"type\":\"object\",\"properties\":{\"first_name\":{\"type\":\"string\"},\"last_name\":{\"type\":\"string\"}}}}}}",
  parsed:{ openapi:"3.1.1",
    paths:{ "/auth/me":{ get:{ description:"Retrieves the authenticated user's profile information including personal details and roles",
          operationId:"AuthenticationController_signIn",
          parameters:[  ],
          responses:{ 201:{ description:"",
              content:{ "application/json":{ schema:{ type:"object",
                    properties:{ id:{ type:"string",
                        example:"uuid" },
                      sub:{ type:"string",
                        example:"sub" },
                      email:{ type:"string",
                        example:"email@example.com" },
                      email_verified:{ type:"object",
                        example:false },
                      first_name:{ type:"object",
                        example:"John" },
                      last_name:{ type:"object",
                        example:"Doe" } },
                    required:[ "id",
                      "sub",
                      "email",
                      "email_verified",
                      "first_name" ] } } } },
            401:{ description:"Invalid login request",
              content:{ "application/json":{ example:{ message:"Bearer token not provided",
                    error:"Unauthorized",
                    statusCode:401 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Get information about the current user",
          tags:[ "Auth" ] } },
      "/organizations":{ post:{ operationId:"OrganizationsController_create",
          parameters:[  ],
          requestBody:{ required:true,
            content:{ "application/json":{ schema:{ type:"object",
                  properties:{ name:{ description:"Organization name",
                      type:"string",
                      maxLength:191,
                      minLength:1 },
                    active:{ description:"Whether the organization is active",
                      type:"boolean",
                      "default":true },
                    invoice_address:{ description:"The address to reference in invoices for the Organization",
                      type:"object",
                      properties:{ line1:{ type:"string" },
                        line2:{ type:"string" },
                        city:{ type:"string" },
                        state:{ type:"string" },
                        zip_code:{ type:"string" },
                        country:{ description:"Two letters country code",
                          type:"string" } },
                      required:[ "line1",
                        "city",
                        "state",
                        "zip_code",
                        "country" ] },
                    invoice_email:{ description:"The email to send invoices to for the Organization",
                      type:"string",
                      format:"email" },
                    invoice_name:{ description:"The name that should appear in invoices for the Organization",
                      type:"string",
                      minLength:1 } },
                  required:[ "name",
                    "invoice_address",
                    "invoice_email",
                    "invoice_name" ] } } } },
          responses:{ 400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:[ { code:"invalid_type",
                        expected:"boolean",
                        received:"undefined",
                        path:[ "active" ],
                        message:"Required" } ],
                    statusCode:400 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Create a new organization",
          tags:[ "Organizations" ] },
        get:{ operationId:"OrganizationsController_findAll",
          parameters:[ { name:"page",
              required:false,
              "in":"query",
              description:"Which page of results to fetch",
              schema:{ "default":1,
                example:"1",
                type:"string" } },
            { name:"pageSize",
              required:false,
              "in":"query",
              description:"The size of a page of results to fetch",
              schema:{ "default":10,
                example:"10",
                type:"string" } },
            { name:"search",
              required:true,
              "in":"query",
              description:"Filter organizations by name",
              schema:{ type:"string" } },
            { name:"active",
              required:true,
              "in":"query",
              description:"Filter organizations by active status",
              schema:{ type:"boolean" } } ],
          responses:{ 200:{ description:"Successfully received model list",
              content:{ "application/json":{ schema:{ allOf:[ { type:"object",
                        properties:{ data:{ type:"array",
                            items:{ type:"object",
                              properties:{ name:{ type:"string",
                                  example:"Account 1" },
                                id:{ type:"string",
                                  example:"0fa33117-4026-43ad-94fe-2a6189ef582c" },
                                active:{ type:"boolean",
                                  example:false },
                                created_at:{ format:"date-time",
                                  type:"string",
                                  example:"2011-10-05T14:48:00.000Z" },
                                updated_at:{ format:"date-time",
                                  type:"string",
                                  example:"2011-10-05T14:48:00.000Z" } },
                              required:[ "name",
                                "id",
                                "active",
                                "created_at",
                                "updated_at" ] } },
                          meta:{ type:"object",
                            properties:{ count:{ type:"number" },
                              lastPage:{ type:"number" },
                              currentPage:{ type:"number" },
                              totalPerPage:{ type:"number" },
                              prevPage:{ type:"number",
                                nullable:true,
                                example:1 },
                              nextPage:{ type:"number",
                                nullable:true,
                                example:null } },
                            required:[ "count",
                              "lastPage",
                              "currentPage",
                              "totalPerPage",
                              "prevPage",
                              "nextPage" ] } } },
                      { properties:{ data:{ type:"array",
                            items:{ type:"object",
                              properties:{ name:{ type:"string",
                                  example:"Account 1" },
                                id:{ type:"string",
                                  example:"0fa33117-4026-43ad-94fe-2a6189ef582c" },
                                active:{ type:"boolean",
                                  example:false },
                                created_at:{ format:"date-time",
                                  type:"string",
                                  example:"2011-10-05T14:48:00.000Z" },
                                updated_at:{ format:"date-time",
                                  type:"string",
                                  example:"2011-10-05T14:48:00.000Z" } },
                              required:[ "name",
                                "id",
                                "active",
                                "created_at",
                                "updated_at" ] } } } } ] } } } } },
          security:[ { bearer:[  ] } ],
          summary:"List all organizations",
          tags:[ "Organizations" ] } },
      "/organizations/name-conflicts":{ get:{ operationId:"OrganizationsController_nameConflicts",
          parameters:[ { name:"name",
              required:true,
              "in":"query",
              description:"Organization name to check",
              schema:{ type:"string" } },
            { name:"exclude_id",
              required:true,
              "in":"query",
              description:"Organization ID to exclude from conflict check",
              schema:{ type:"string" } } ],
          responses:{ 200:{ description:"" } },
          security:[ { bearer:[  ] } ],
          summary:"Check if an organization name conflicts with others",
          tags:[ "Organizations" ] } },
      "/organizations/{id}":{ get:{ operationId:"OrganizationsController_findOne",
          parameters:[ { name:"id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 404:{ description:"Organization not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Get an organization by ID",
          tags:[ "Organizations" ] },
        patch:{ operationId:"OrganizationsController_update",
          parameters:[ { name:"id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          requestBody:{ required:true,
            content:{ "application/json":{ schema:{ type:"object",
                  properties:{ name:{ description:"Organization name",
                      type:"string",
                      maxLength:191,
                      minLength:1 },
                    active:{ description:"Whether the organization is active",
                      type:"boolean",
                      "default":true },
                    invoice_address:{ description:"The address to reference in invoices for the Organization",
                      type:"object",
                      properties:{ line1:{ type:"string" },
                        line2:{ type:"string" },
                        city:{ type:"string" },
                        state:{ type:"string" },
                        zip_code:{ type:"string" },
                        country:{ description:"Two letters country code",
                          type:"string" } },
                      required:[ "line1",
                        "city",
                        "state",
                        "zip_code",
                        "country" ] },
                    invoice_email:{ description:"The email to send invoices to for the Organization",
                      type:"string",
                      format:"email" },
                    invoice_name:{ description:"The name that should appear in invoices for the Organization",
                      type:"string",
                      minLength:1 } } } } } },
          responses:{ 400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:[ { code:"invalid_type",
                        expected:"boolean",
                        received:"undefined",
                        path:[ "active" ],
                        message:"Required" } ],
                    statusCode:400 } } } },
            403:{ description:"Forbidden - Write access required" },
            404:{ description:"Organization not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Update an organization",
          tags:[ "Organizations" ] },
        "delete":{ operationId:"OrganizationsController_remove",
          parameters:[ { name:"id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 400:{ description:"Cannot delete organization - has dependent entities" },
            403:{ description:"Forbidden - Write access required" },
            404:{ description:"Organization not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Delete an organization",
          tags:[ "Organizations" ] } },
      "/organizations/{id}/invitations":{ post:{ operationId:"OrganizationsController_createOrganizationsOnUsers",
          parameters:[ { name:"id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          requestBody:{ required:true,
            content:{ "application/json":{ schema:{ type:"object",
                  properties:{ role:{ description:"The role of the user with respect to the organization",
                      type:"string",
                      "enum":[ "admin",
                        "write",
                        "read",
                        "restricted" ],
                      "x-enumNames":[ "admin",
                        "write",
                        "read",
                        "restricted" ] },
                    email:{ description:"The email of the user",
                      type:"string",
                      format:"email" },
                    advertisers:{ type:"array",
                      items:{ type:"object",
                        properties:{ id:{ description:"The id of the advertiser",
                            type:"string",
                            format:"uuid" },
                          role:{ description:"The role of the users with respect to the advertiser",
                            type:"string",
                            "enum":[ "admin",
                              "write",
                              "read" ],
                            "x-enumNames":[ "admin",
                              "write",
                              "read" ] } },
                        required:[ "id",
                          "role" ] } } },
                  required:[ "role",
                    "email" ] } } } },
          responses:{ 400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:[ { code:"invalid_type",
                        expected:"string",
                        received:"undefined",
                        path:[ "role" ],
                        message:"Required" } ],
                    statusCode:400 } } } },
            403:{ description:"Forbidden - Admin access required" } },
          security:[ { bearer:[  ] } ],
          summary:"Invite users to an organization",
          tags:[ "Organizations" ] } },
      "/organizations/{id}/users":{ get:{ operationId:"OrganizationsController_organizationsOnUsers",
          parameters:[ { name:"id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"page",
              required:false,
              "in":"query",
              description:"Which page of results to fetch",
              schema:{ "default":1,
                example:"1",
                type:"string" } },
            { name:"pageSize",
              required:false,
              "in":"query",
              description:"The size of a page of results to fetch",
              schema:{ "default":10,
                example:"10",
                type:"string" } } ],
          responses:{ 403:{ description:"Forbidden - Admin access required" },
            404:{ description:"Organization not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Get the users in an organization",
          tags:[ "Organizations" ] } },
      "/organizations/{id}/users/{user_id}":{ get:{ operationId:"OrganizationsController_organizationsOnUser",
          parameters:[ { name:"id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"user_id",
              required:true,
              "in":"path",
              description:"ID of the user",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 403:{ description:"Forbidden - Admin access required" },
            404:{ description:"User not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Get a user in an organization",
          tags:[ "Organizations" ] },
        "delete":{ operationId:"OrganizationsController_removeOrganizationOnUser",
          parameters:[ { name:"id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"user_id",
              required:true,
              "in":"path",
              description:"ID of the user",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 403:{ description:"Forbidden - Admin access required" },
            404:{ description:"User not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Remove a user from an organization",
          tags:[ "Organizations" ] } },
      "/organizations/{id}/roles":{ get:{ operationId:"OrganizationsController_getRoles",
          parameters:[ { name:"id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 404:{ description:"Organization not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Get the roles of the user in an organization",
          tags:[ "Organizations" ] } },
      "/organizations/{id}/invoice-data":{ get:{ operationId:"OrganizationsController_getInvoiceData",
          parameters:[ { name:"id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 404:{ description:"Organization not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Get the invoice data of an organization",
          tags:[ "Organizations" ] } },
      "/organizations/{id}/impressions-stats":{ post:{ operationId:"OrganizationsController_generateImpressionStats",
          parameters:[ { name:"id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          requestBody:{ required:true,
            content:{ "application/json":{ schema:{ type:"object",
                  properties:{ advertisers:{ description:"Advertiser IDs",
                      type:"array",
                      items:{ type:"string",
                        format:"uuid" } },
                    campaigns:{ description:"Campaign IDs",
                      type:"array",
                      items:{ type:"string",
                        format:"uuid" } },
                    line_items:{ description:"Line item IDs",
                      type:"array",
                      items:{ type:"string",
                        format:"uuid" } },
                    creatives:{ description:"Creative IDs",
                      type:"array",
                      items:{ type:"string",
                        format:"uuid" } } } } } } },
          responses:{ 403:{ description:"Forbidden - Read access required",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"Organization not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Get impression statistics related to entities of an organization",
          tags:[ "Organizations" ] } },
      "/organizations/{id}/conversion-events":{ get:{ operationId:"OrganizationsController_getAvailableEvents",
          parameters:[ { name:"id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"advertiser_id",
              required:true,
              "in":"query",
              description:"Filter by advertiser id",
              schema:{ type:"array",
                items:{ type:"string" } } },
            { name:"event_name",
              required:true,
              "in":"query",
              description:"Filter by event name",
              schema:{ type:"string" } },
            { name:"event_source",
              required:true,
              "in":"query",
              description:"Filter by event source",
              schema:{ type:"string" } },
            { name:"page_size",
              required:true,
              "in":"query",
              description:"The size of a page of results to fetch",
              schema:{ type:"number" } },
            { name:"page",
              required:true,
              "in":"query",
              description:"The page of results to fetch",
              schema:{ type:"number" } } ],
          responses:{ 404:{ description:"Advertiser not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Get conversion events related to entities of an organization",
          tags:[ "Organizations" ] } },
      "/organizations/{organization_id}/advertisers":{ post:{ operationId:"AdvertisersController_create",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          requestBody:{ required:true,
            content:{ "application/json":{ schema:{ type:"object",
                  properties:{ name:{ description:"The name of the advertiser",
                      type:"string",
                      minLength:1,
                      maxLength:191 },
                    description:{ description:"A description to attach to the advertiser",
                      type:"string",
                      maxLength:191 },
                    domain:{ description:"The domain the advertiser refers to",
                      type:"string",
                      format:"uri" },
                    category_key:{ description:"The category the advertiser refers to",
                      type:"string",
                      maxLength:191 },
                    app_bundle:{ description:"The app bundle for the advertiser",
                      type:"string",
                      maxLength:191 },
                    active:{ description:"Whether the advertiser should be active",
                      type:"boolean",
                      "default":true },
                    default_continent:{ description:"The continent the advertiser should operate into",
                      type:"string",
                      "enum":[ "EMEA",
                        "NAM",
                        "APAC" ],
                      "x-enumNames":[ "EMEA",
                        "NAM",
                        "APAC" ] } },
                  required:[ "name",
                    "domain",
                    "category_key" ] } } } },
          responses:{ 400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:[ { code:"invalid_type",
                        expected:"boolean",
                        received:"undefined",
                        path:[ "active" ],
                        message:"Required" } ],
                    error:"Bad Request",
                    statusCode:400 } } } },
            403:{ description:"Forbidden - Admin access required",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Create a new advertiser",
          tags:[ "Advertisers" ] },
        get:{ operationId:"AdvertisersController_findAll",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"page",
              required:false,
              "in":"query",
              description:"Which page of results to fetch",
              schema:{ "default":1,
                example:"1",
                type:"string" } },
            { name:"pageSize",
              required:false,
              "in":"query",
              description:"The size of a page of results to fetch",
              schema:{ "default":10,
                example:"10",
                type:"string" } },
            { name:"search",
              required:true,
              "in":"query",
              description:"Search advertisers by name",
              schema:{ type:"string" } },
            { name:"status",
              required:true,
              "in":"query",
              description:"Filter advertisers by status",
              schema:{ type:"string",
                "enum":[ "active",
                  "inactive",
                  "all" ] } } ],
          responses:{ 200:{ description:"Successfully received model list",
              content:{ "application/json":{ schema:{ allOf:[ { type:"object",
                        properties:{ data:{ type:"array",
                            items:{ type:"object",
                              properties:{ name:{ type:"string",
                                  example:"Advertiser 1" },
                                id:{ type:"string",
                                  example:"0fa33117-4026-43ad-94fe-2a6189ef582c" },
                                active:{ type:"boolean",
                                  example:false },
                                dsp_id:{ type:"object",
                                  example:null },
                                dsp_context_status:{ type:"string",
                                  "enum":[ "PENDING",
                                    "FAILED",
                                    "SYNCED" ] },
                                domain:{ type:"string",
                                  example:"https://example.com" },
                                app_bundle:{ type:"object",
                                  example:"com.example" },
                                alternative_id:{ type:"object",
                                  example:"123" },
                                category_key:{ type:"string",
                                  example:"IAB19" },
                                created_at:{ format:"date-time",
                                  type:"string",
                                  example:"2011-10-05T14:48:00.000Z" },
                                updated_at:{ format:"date-time",
                                  type:"string",
                                  example:"2011-10-05T14:48:00.000Z" },
                                description:{ type:"object",
                                  example:"Advertiser Description" },
                                currency_key:{ type:"string",
                                  example:"USD" },
                                default_continent:{ type:"string",
                                  "enum":[ "EMEA",
                                    "NAM",
                                    "APAC" ],
                                  example:"NAM" },
                                organization_id:{ type:"string",
                                  example:"0fa33117-4026-43ad-94fe-2a6189ef582d" } },
                              required:[ "name",
                                "id",
                                "active",
                                "dsp_id",
                                "dsp_context_status",
                                "domain",
                                "app_bundle",
                                "alternative_id",
                                "category_key",
                                "created_at",
                                "updated_at",
                                "description",
                                "currency_key",
                                "default_continent",
                                "organization_id" ] } },
                          meta:{ type:"object",
                            properties:{ count:{ type:"number" },
                              lastPage:{ type:"number" },
                              currentPage:{ type:"number" },
                              totalPerPage:{ type:"number" },
                              prevPage:{ type:"number",
                                nullable:true,
                                example:1 },
                              nextPage:{ type:"number",
                                nullable:true,
                                example:null } },
                            required:[ "count",
                              "lastPage",
                              "currentPage",
                              "totalPerPage",
                              "prevPage",
                              "nextPage" ] } } },
                      { properties:{ data:{ type:"array",
                            items:{ type:"object",
                              properties:{ name:{ type:"string",
                                  example:"Advertiser 1" },
                                id:{ type:"string",
                                  example:"0fa33117-4026-43ad-94fe-2a6189ef582c" },
                                active:{ type:"boolean",
                                  example:false },
                                dsp_id:{ type:"object",
                                  example:null },
                                dsp_context_status:{ type:"string",
                                  "enum":[ "PENDING",
                                    "FAILED",
                                    "SYNCED" ] },
                                domain:{ type:"string",
                                  example:"https://example.com" },
                                app_bundle:{ type:"object",
                                  example:"com.example" },
                                alternative_id:{ type:"object",
                                  example:"123" },
                                category_key:{ type:"string",
                                  example:"IAB19" },
                                created_at:{ format:"date-time",
                                  type:"string",
                                  example:"2011-10-05T14:48:00.000Z" },
                                updated_at:{ format:"date-time",
                                  type:"string",
                                  example:"2011-10-05T14:48:00.000Z" },
                                description:{ type:"object",
                                  example:"Advertiser Description" },
                                currency_key:{ type:"string",
                                  example:"USD" },
                                default_continent:{ type:"string",
                                  "enum":[ "EMEA",
                                    "NAM",
                                    "APAC" ],
                                  example:"NAM" },
                                organization_id:{ type:"string",
                                  example:"0fa33117-4026-43ad-94fe-2a6189ef582d" } },
                              required:[ "name",
                                "id",
                                "active",
                                "dsp_id",
                                "dsp_context_status",
                                "domain",
                                "app_bundle",
                                "alternative_id",
                                "category_key",
                                "created_at",
                                "updated_at",
                                "description",
                                "currency_key",
                                "default_continent",
                                "organization_id" ] } } } } ] } } } } },
          security:[ { bearer:[  ] } ],
          summary:"List all advertisers for the organization",
          tags:[ "Advertisers" ] } },
      "/organizations/{organization_id}/advertisers/{id}":{ get:{ operationId:"AdvertisersController_findOne",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the advertiser",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 404:{ description:"Advertiser not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Get an advertiser by ID",
          tags:[ "Advertisers" ] },
        patch:{ operationId:"AdvertisersController_update",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the advertiser",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          requestBody:{ required:true,
            content:{ "application/json":{ schema:{ type:"object",
                  properties:{ name:{ description:"The name of the advertiser",
                      type:"string",
                      minLength:1,
                      maxLength:191 },
                    description:{ description:"A description to attach to the advertiser",
                      type:"string",
                      maxLength:191 },
                    domain:{ description:"The domain the advertiser refers to",
                      type:"string",
                      format:"uri" },
                    category_key:{ description:"The category the advertiser refers to",
                      type:"string",
                      maxLength:191 },
                    app_bundle:{ description:"The app bundle for the advertiser",
                      type:"string",
                      maxLength:191 },
                    active:{ description:"Whether the advertiser should be active",
                      type:"boolean",
                      "default":true },
                    default_continent:{ description:"The continent the advertiser should operate into",
                      type:"string",
                      "enum":[ "EMEA",
                        "NAM",
                        "APAC" ],
                      "x-enumNames":[ "EMEA",
                        "NAM",
                        "APAC" ] } } } } } },
          responses:{ 400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:[ { code:"invalid_type",
                        expected:"boolean",
                        received:"undefined",
                        path:[ "active" ],
                        message:"Required" } ],
                    error:"Bad Request",
                    statusCode:400 } } } },
            403:{ description:"Forbidden - Write access needed",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"Advertiser not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Update an advertiser",
          tags:[ "Advertisers" ] },
        "delete":{ operationId:"AdvertisersController_remove",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the advertiser",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:"Advertiser cannot be deleted because it has campaigns",
                    statusCode:400 } } } },
            403:{ description:"Forbidden - Write access needed",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"Advertiser not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Delete an advertiser",
          tags:[ "Advertisers" ] } },
      "/organizations/{organization_id}/advertisers/{id}/users":{ get:{ operationId:"AdvertisersController_advertisersOnUsers",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the advertiser",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 403:{ description:"Forbidden - Admin access needed",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"Advertiser not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Get all users associated with an advertiser",
          tags:[ "Advertisers" ] } },
      "/organizations/{organization_id}/advertisers/{id}/users/{user_id}":{ get:{ operationId:"AdvertisersController_advertisersOnUser",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the advertiser",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"user_id",
              required:true,
              "in":"path",
              description:"ID of the user",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 403:{ description:"Forbidden - Admin access needed",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"Advertiser not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Get a specific user association with an advertiser",
          tags:[ "Advertisers" ] } },
      "/organizations/{organization_id}/advertisers/{id}/reporting/dashboard":{ get:{ operationId:"AdvertisersController_getDashboard",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the advertiser",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"campaign_id",
              required:false,
              "in":"query",
              description:"Campaign ID",
              schema:{ type:"string" } },
            { name:"line_item_id",
              required:false,
              "in":"query",
              description:"Line Item ID",
              schema:{ type:"string" } },
            { name:"creative_id",
              required:false,
              "in":"query",
              description:"Creative ID",
              schema:{ type:"string" } },
            { name:"group_by_fields",
              required:true,
              "in":"query",
              description:"Fields to group by",
              schema:{ type:"array",
                items:{ type:"string" } } } ],
          responses:{ 200:{ description:"",
              content:{ "application/json":{ schema:{ type:"array",
                    items:{ type:"object",
                      properties:{ advertiser_id:{ type:"string",
                          format:"uuid" },
                        spend:{ type:"number" },
                        impressions:{ type:"number" },
                        reach_person:{ type:"number" },
                        reach_household:{ type:"number" },
                        conversions:{ type:"number" },
                        conversion_rate:{ type:"number" },
                        conversions_value:{ type:"number" },
                        cpa:{ type:"number" },
                        roas:{ type:"number" },
                        group_fields:{ type:"object",
                          additionalProperties:{ type:"string" } } },
                      required:[ "advertiser_id",
                        "spend",
                        "impressions",
                        "reach_person",
                        "reach_household",
                        "conversions",
                        "conversion_rate",
                        "conversions_value",
                        "cpa",
                        "roas",
                        "group_fields" ] } } } } },
            404:{ description:"Advertiser not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Get dashboard data for reporting purposes for an advertiser",
          tags:[ "Advertisers" ] } },
      "/organizations/{organization_id}/campaigns":{ post:{ operationId:"CampaignsController_create",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          requestBody:{ required:true,
            content:{ "application/json":{ schema:{ type:"object",
                  properties:{ name:{ description:"The name of the campaign",
                      type:"string",
                      maxLength:191,
                      minLength:4 },
                    active:{ description:"Whether the campaign should be active",
                      type:"boolean",
                      "default":true },
                    start_datetime:{ description:"Start date and time for the campaign",
                      type:"string",
                      format:"date-time" },
                    end_datetime:{ description:"End date and time for the campaign",
                      type:"string",
                      format:"date-time",
                      nullable:true },
                    description:{ description:"A description for the campaign",
                      type:"string",
                      nullable:true },
                    budget:{ description:"The overall budget for the campaign",
                      type:"number",
                      minimum:0,
                      exclusiveMinimum:true },
                    daily_budget:{ description:"The daily budget for the campaign",
                      type:"number",
                      nullable:true },
                    vendor_fees:{ description:"Vendor fees for the campaign",
                      type:"array",
                      maxItems:3,
                      items:{ type:"object",
                        properties:{ vendor_id:{ type:"string",
                            format:"uuid" },
                          name:{ type:"string",
                            minLength:1,
                            maxLength:191 },
                          type:{ type:"string",
                            "enum":[ "DEFAULT",
                              "CPM",
                              "PERCENTAGE" ],
                            "default":"DEFAULT" },
                          amount:{ description:"Required for non-default vendor fees",
                            type:"number",
                            nullable:true } },
                        required:[ "vendor_id",
                          "name" ],
                        nullable:true },
                      nullable:true },
                    frequency_caps:{ description:"Frequency caps for the campaign",
                      type:"object",
                      properties:{ type:{ type:"string",
                          "enum":[ "STANDARD",
                            "IP_ADDRESS",
                            "PERSON_ID",
                            "HOUSE_HOLD_ID" ],
                          "default":"STANDARD" },
                        use_fallback:{ type:"boolean",
                          "default":true },
                        items:{ type:"array",
                          items:{ type:"object",
                            properties:{ impressions:{ type:"number",
                                minimum:1,
                                exclusiveMinimum:false },
                              interval:{ type:"number",
                                minimum:1,
                                exclusiveMinimum:false },
                              time_unit:{ type:"string",
                                "enum":[ "DAY",
                                  "HOUR",
                                  "MINUTE",
                                  "WEEK" ],
                                "default":"DAY" } },
                            required:[ "impressions",
                              "interval" ] } } },
                      required:[ "items" ] },
                    advertiser_id:{ description:"The ID of the advertiser the campaign refers to",
                      type:"string",
                      format:"uuid" } },
                  required:[ "name",
                    "start_datetime",
                    "budget",
                    "frequency_caps",
                    "advertiser_id" ] } } } },
          responses:{ 400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:[ { code:"invalid_type",
                        expected:"boolean",
                        received:"undefined",
                        path:[ "active" ],
                        message:"Required" } ],
                    statusCode:400 } } } },
            403:{ description:"Forbidden - Write access required",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"Advertiser not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Create a new campaign",
          tags:[ "Campaigns" ] },
        get:{ operationId:"CampaignsController_findAll",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"page",
              required:false,
              "in":"query",
              description:"Which page of results to fetch",
              schema:{ "default":1,
                example:"1",
                type:"string" } },
            { name:"pageSize",
              required:false,
              "in":"query",
              description:"The size of a page of results to fetch",
              schema:{ "default":10,
                example:"10",
                type:"string" } },
            { name:"search",
              required:true,
              "in":"query",
              description:"Search campaigns by name",
              schema:{ type:"string" } },
            { name:"active",
              required:true,
              "in":"query",
              description:"Filter campaigns by active status",
              schema:{} },
            { name:"status",
              required:true,
              "in":"query",
              description:"Filter campaigns by active status",
              schema:{ type:"string" } },
            { name:"associatedLineItems",
              required:true,
              "in":"query",
              description:"Filter campaigns that have an associated line item",
              schema:{ type:"boolean" } },
            { name:"edited_today",
              required:true,
              "in":"query",
              description:"Filter campaigns that have been edited today",
              schema:{ type:"boolean" } },
            { name:"ending_this_week",
              required:true,
              "in":"query",
              description:"Filter campaigns that end this week",
              schema:{ type:"boolean" } },
            { name:"out_of_budget",
              required:true,
              "in":"query",
              description:"Filter campaigns that are out of budget",
              schema:{ type:"boolean" } },
            { name:"start_datetime",
              required:true,
              "in":"query",
              description:"Filter campaigns by start date and time",
              schema:{ format:"date-time",
                type:"string" } },
            { name:"end_datetime",
              required:true,
              "in":"query",
              description:"Filter campaigns by start date and time",
              schema:{ format:"date-time",
                type:"string" } } ],
          responses:{ 200:{ description:"Successfully received model list",
              content:{ "application/json":{ schema:{ allOf:[ { type:"object",
                        properties:{ data:{ type:"array",
                            items:{ type:"object",
                              properties:{ frequency_caps:{ type:"object",
                                  properties:{ type:{ type:"string",
                                      "enum":[ "STANDARD",
                                        "IP_ADDRESS",
                                        "PERSON_ID",
                                        "HOUSE_HOLD_ID" ],
                                      "default":"STANDARD" },
                                    use_fallback:{ type:"boolean",
                                      "default":true },
                                    items:{ type:"array",
                                      items:{ type:"object",
                                        properties:{ impressions:{ type:"number",
                                            minimum:1,
                                            exclusiveMinimum:false },
                                          interval:{ type:"number",
                                            minimum:1,
                                            exclusiveMinimum:false },
                                          time_unit:{ type:"string",
                                            "enum":[ "DAY",
                                              "HOUR",
                                              "MINUTE",
                                              "WEEK" ],
                                            "default":"DAY" } },
                                        required:[ "impressions",
                                          "interval" ] } } },
                                  required:[ "items" ] },
                                start_datetime:{ format:"date-time",
                                  type:"string",
                                  example:1732795153 },
                                end_datetime:{ type:"object",
                                  example:173279515 },
                                budget_type:{ type:"string",
                                  "enum":[ "SPEND_WITH_VENDOR_FEES",
                                    "SPEND",
                                    "IMPRESSION" ],
                                  example:"SPEND_WITH_VENDOR_FEES",
                                  description:"The type of budget. Will always be SPEND_WITH_VENDOR_FEES" } },
                              required:[ "frequency_caps",
                                "start_datetime",
                                "end_datetime",
                                "budget_type" ] } },
                          meta:{ type:"object",
                            properties:{ count:{ type:"number" },
                              lastPage:{ type:"number" },
                              currentPage:{ type:"number" },
                              totalPerPage:{ type:"number" },
                              prevPage:{ type:"number",
                                nullable:true,
                                example:1 },
                              nextPage:{ type:"number",
                                nullable:true,
                                example:null } },
                            required:[ "count",
                              "lastPage",
                              "currentPage",
                              "totalPerPage",
                              "prevPage",
                              "nextPage" ] } } },
                      { properties:{ data:{ type:"array",
                            items:{ type:"object",
                              properties:{ frequency_caps:{ type:"object",
                                  properties:{ type:{ type:"string",
                                      "enum":[ "STANDARD",
                                        "IP_ADDRESS",
                                        "PERSON_ID",
                                        "HOUSE_HOLD_ID" ],
                                      "default":"STANDARD" },
                                    use_fallback:{ type:"boolean",
                                      "default":true },
                                    items:{ type:"array",
                                      items:{ type:"object",
                                        properties:{ impressions:{ type:"number",
                                            minimum:1,
                                            exclusiveMinimum:false },
                                          interval:{ type:"number",
                                            minimum:1,
                                            exclusiveMinimum:false },
                                          time_unit:{ type:"string",
                                            "enum":[ "DAY",
                                              "HOUR",
                                              "MINUTE",
                                              "WEEK" ],
                                            "default":"DAY" } },
                                        required:[ "impressions",
                                          "interval" ] } } },
                                  required:[ "items" ] },
                                start_datetime:{ format:"date-time",
                                  type:"string",
                                  example:1732795153 },
                                end_datetime:{ type:"object",
                                  example:173279515 },
                                budget_type:{ type:"string",
                                  "enum":[ "SPEND_WITH_VENDOR_FEES",
                                    "SPEND",
                                    "IMPRESSION" ],
                                  example:"SPEND_WITH_VENDOR_FEES",
                                  description:"The type of budget. Will always be SPEND_WITH_VENDOR_FEES" } },
                              required:[ "frequency_caps",
                                "start_datetime",
                                "end_datetime",
                                "budget_type" ] } } } } ] } } } },
            404:{ description:"Organization not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"List all campaigns",
          tags:[ "Campaigns" ] } },
      "/organizations/{organization_id}/campaigns/{id}":{ get:{ operationId:"CampaignsController_findOne",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the campaign",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 404:{ description:"Campaign not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Get campaign by ID",
          tags:[ "Campaigns" ] },
        patch:{ operationId:"CampaignsController_update",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the campaign",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          requestBody:{ required:true,
            content:{ "application/json":{ schema:{ type:"object",
                  properties:{ name:{ description:"The name of the campaign",
                      type:"string",
                      maxLength:191,
                      minLength:4 },
                    active:{ description:"Whether the campaign should be active",
                      type:"boolean",
                      "default":true },
                    start_datetime:{ description:"Start date and time for the campaign",
                      type:"string",
                      format:"date-time" },
                    end_datetime:{ description:"End date and time for the campaign",
                      type:"string",
                      format:"date-time",
                      nullable:true },
                    description:{ description:"A description for the campaign",
                      type:"string",
                      nullable:true },
                    budget:{ description:"The overall budget for the campaign",
                      type:"number",
                      minimum:0,
                      exclusiveMinimum:true },
                    daily_budget:{ description:"The daily budget for the campaign",
                      type:"number",
                      nullable:true },
                    vendor_fees:{ description:"Vendor fees for the campaign",
                      type:"array",
                      maxItems:3,
                      items:{ type:"object",
                        properties:{ vendor_id:{ type:"string",
                            format:"uuid" },
                          name:{ type:"string",
                            minLength:1,
                            maxLength:191 },
                          type:{ type:"string",
                            "enum":[ "DEFAULT",
                              "CPM",
                              "PERCENTAGE" ],
                            "default":"DEFAULT" },
                          amount:{ description:"Required for non-default vendor fees",
                            type:"number",
                            nullable:true } },
                        required:[ "vendor_id",
                          "name" ],
                        nullable:true },
                      nullable:true },
                    frequency_caps:{ description:"Frequency caps for the campaign",
                      type:"object",
                      properties:{ type:{ type:"string",
                          "enum":[ "STANDARD",
                            "IP_ADDRESS",
                            "PERSON_ID",
                            "HOUSE_HOLD_ID" ],
                          "default":"STANDARD" },
                        use_fallback:{ type:"boolean",
                          "default":true },
                        items:{ type:"array",
                          items:{ type:"object",
                            properties:{ impressions:{ type:"number",
                                minimum:1,
                                exclusiveMinimum:false },
                              interval:{ type:"number",
                                minimum:1,
                                exclusiveMinimum:false },
                              time_unit:{ type:"string",
                                "enum":[ "DAY",
                                  "HOUR",
                                  "MINUTE",
                                  "WEEK" ],
                                "default":"DAY" } },
                            required:[ "impressions",
                              "interval" ] } } },
                      required:[ "items" ] } } } } } },
          responses:{ 400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:[ { code:"invalid_type",
                        expected:"boolean",
                        received:"string",
                        path:[ "active" ],
                        message:"Required" } ],
                    statusCode:400 } } } },
            403:{ description:"Forbidden - Write access required",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"Campaign not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Update a campaign",
          tags:[ "Campaigns" ] },
        "delete":{ operationId:"CampaignsController_remove",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the campaign",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 403:{ description:"Forbidden - Write access required",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"Campaign not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Delete a campaign",
          tags:[ "Campaigns" ] } },
      "/organizations/{organization_id}/advertisers/{id}/payment-methods":{ get:{ operationId:"PaymentMethodsController_getPaymentMethods",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the advertiser",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 200:{ description:"Payment methods retrieved successfully",
              content:{ "application/json":{ schema:{ type:"object",
                    properties:{ "default":{ type:"string",
                        nullable:true,
                        description:"ID of the default payment method",
                        example:"pm_1234567890abcdef" },
                      methods:{ type:"array",
                        description:"Array of payment methods",
                        items:{ type:"object",
                          properties:{ id:{ type:"string",
                              description:"Unique identifier for the payment method",
                              example:"pm_1234567890abcdef" },
                            type:{ type:"string",
                              description:"The type of the payment method",
                              example:"card" },
                            card:{ type:"object",
                              nullable:true,
                              description:"Card details if payment method is a card",
                              properties:{ brand:{ type:"string",
                                  description:"Card brand",
                                  example:"visa" },
                                last4:{ type:"string",
                                  description:"Last four digits of the card",
                                  example:"4242" },
                                exp_month:{ type:"number",
                                  description:"Expiration month",
                                  example:12 },
                                exp_year:{ type:"number",
                                  description:"Expiration year",
                                  example:2025 } } },
                            created:{ type:"number",
                              description:"Time at which the payment method was created (Unix timestamp)",
                              example:1640995200 },
                            customer:{ type:"string",
                              nullable:true,
                              description:"ID of the customer this payment method belongs to",
                              example:"cus_1234567890abcdef" } } } } } } } } },
            404:{ description:"Advertiser not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Get all payment methods for an advertiser",
          tags:[ "Payment Methods" ] } },
      "/organizations/{organization_id}/advertisers/{id}/payment-methods/{payment_method_id}":{ "delete":{ operationId:"PaymentMethodsController_delete",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the advertiser",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"payment_method_id",
              required:true,
              "in":"path",
              description:"ID of the payment method to delete",
              schema:{ example:"pm_1234567890",
                type:"string" } } ],
          responses:{ 400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:"There are campaigns still active",
                    statusCode:400 } } } },
            403:{ description:"Forbidden - Admin access required",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"Payment method not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Delete a payment method",
          tags:[ "Payment Methods" ] } },
      "/organizations/{organization_id}/advertisers/{id}/payment-methods/{payment_method_id}/default":{ post:{ operationId:"PaymentMethodsController_setDefault",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the advertiser",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"payment_method_id",
              required:true,
              "in":"path",
              description:"ID of the payment method to set as default",
              schema:{ example:"pm_1234567890",
                type:"string" } } ],
          responses:{ 403:{ description:"Forbidden - Admin access required",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"Payment method not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Set a payment method as default",
          tags:[ "Payment Methods" ] } },
      "/organizations/{organization_id}/line-items":{ post:{ operationId:"LineItemsController_create",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              schema:{ type:"string" } } ],
          requestBody:{ required:true,
            description:"Create a new line item",
            content:{ "application/json":{ schema:{ type:"object",
                  properties:{ name:{ description:"The name of the line item",
                      type:"string" },
                    description:{ description:"A description for the line item",
                      type:"string",
                      nullable:true },
                    active:{ description:"Whether the line item should be active",
                      type:"boolean",
                      "default":false },
                    start_datetime:{ description:"The start date and time of the line item" },
                    end_datetime:{ description:"The end date and time of the line item" },
                    type:{ description:"The type of line item",
                      type:"string",
                      "enum":[ "VIDEO",
                        "BANNER",
                        "CTV" ],
                      "x-enumNames":[ "VIDEO",
                        "BANNER",
                        "CTV" ] },
                    advertiser_id:{ description:"The ID of the advertiser the line item refers to",
                      type:"string",
                      format:"uuid" },
                    campaign_id:{ description:"The ID of the campaign the line item refers to",
                      type:"string",
                      format:"uuid" },
                    budget_carryover:{ description:"The budget carry over policy of the line item",
                      type:"string",
                      "enum":[ "NONE",
                        "CARRY_OVER",
                        "EVENLY_DISTRIBUTE",
                        "PRORATED_DISTRIBUTE" ],
                      "x-enumNames":[ "NONE",
                        "CARRY_OVER",
                        "EVENLY_DISTRIBUTE",
                        "PRORATED_DISTRIBUTE" ],
                      "default":"NONE" } },
                  required:[ "name",
                    "start_datetime",
                    "end_datetime",
                    "type",
                    "advertiser_id",
                    "campaign_id" ] } } } },
          responses:{ 400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:[ { code:"invalid_type",
                        expected:"boolean",
                        received:"undefined",
                        path:[ "active" ],
                        message:"Required" } ],
                    statusCode:400 } } } },
            403:{ description:"Forbidden - Write access required",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"Advertiser not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Create a new line item",
          tags:[ "Line Items" ] },
        get:{ operationId:"LineItemsController_findAll",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"page",
              required:false,
              "in":"query",
              description:"Which page of results to fetch",
              schema:{ "default":1,
                example:"1",
                type:"string" } },
            { name:"pageSize",
              required:false,
              "in":"query",
              description:"The size of a page of results to fetch",
              schema:{ "default":10,
                example:"10",
                type:"string" } },
            { name:"search",
              required:true,
              "in":"query",
              description:"Search by name",
              schema:{ type:"string" } },
            { name:"active",
              required:true,
              "in":"query",
              description:"Filter by active status",
              schema:{} },
            { name:"status",
              required:true,
              "in":"query",
              description:"Filter by active status",
              schema:{ type:"string",
                "enum":[ "inactive",
                  "all",
                  "active" ] } },
            { name:"start_datetime",
              required:true,
              "in":"query",
              description:"Filter by start date and time",
              schema:{ format:"date-time",
                type:"string" } },
            { name:"end_datetime",
              required:true,
              "in":"query",
              description:"Filter by end date and time",
              schema:{ format:"date-time",
                type:"string" } },
            { name:"advertiser_id",
              required:true,
              "in":"query",
              description:"Filter by advertiser ID",
              schema:{ type:"string" } },
            { name:"campaign_id",
              required:true,
              "in":"query",
              description:"Filter by campaign ID",
              schema:{ type:"string" } },
            { name:"creative_id",
              required:true,
              "in":"query",
              description:"Filter by creative ID",
              schema:{ type:"string" } } ],
          responses:{ 200:{ description:"Successfully received model list",
              content:{ "application/json":{ schema:{ allOf:[ { type:"object",
                        properties:{ data:{ type:"array",
                            items:{ type:"object",
                              properties:{ effective_status:{ type:"string",
                                  "enum":[ "DELIVERING",
                                    "DELIVERED",
                                    "STOPPED",
                                    "INACTIVE",
                                    "UNKNOWN" ] },
                                type:{ type:"string",
                                  "enum":[ "VIDEO",
                                    "BANNER",
                                    "CTV" ] },
                                budget_carryover:{ type:"string",
                                  "enum":[ "NONE",
                                    "CARRY_OVER",
                                    "EVENLY_DISTRIBUTE",
                                    "PRORATED_DISTRIBUTE" ] },
                                bidding_strategy:{ type:"object",
                                  properties:{ type:{ type:"string",
                                      "enum":[ "FLAT_CPM",
                                        "CPC",
                                        "CPA" ],
                                      "x-enumNames":[ "FLAT_CPM",
                                        "CPC",
                                        "CPA" ],
                                      "default":"FLAT_CPM" },
                                    bid_shading_control:{ type:"string",
                                      "enum":[ "NORMAL",
                                        "LESS_AGGRESSIVE",
                                        "MORE_AGGRESSIVE" ],
                                      "x-enumNames":[ "NORMAL",
                                        "LESS_AGGRESSIVE",
                                        "MORE_AGGRESSIVE" ] },
                                    cpm:{ type:"number" } },
                                  required:[ "bid_shading_control",
                                    "cpm" ] },
                                pacing_strategy:{ type:"object",
                                  properties:{ type:{ type:"string",
                                      "enum":[ "DAILY",
                                        "LIFETIME",
                                        "FLIGHT" ],
                                      "x-enumNames":[ "Daily",
                                        "Lifetime",
                                        "Flight" ],
                                      "default":"LIFETIME" },
                                    pacing_behavior:{ type:"string",
                                      "enum":[ "EVEN",
                                        "AHEAD" ],
                                      "x-enumNames":[ "Even",
                                        "Ahead" ],
                                      "default":"EVEN" },
                                    catchup_behavior:{ type:"string",
                                      "enum":[ "EVEN",
                                        "IMMEDIATE",
                                        "SMOOTH" ],
                                      "x-enumNames":[ "Even",
                                        "Immediate",
                                        "Smooth" ],
                                      "default":"EVEN" },
                                    multiplier:{ type:"number",
                                      nullable:true,
                                      "default":1 } } },
                                frequency_caps:{ type:"array",
                                  items:{ type:"object",
                                    properties:{ type:{ type:"string",
                                        "enum":[ "STANDARD",
                                          "IP_ADDRESS",
                                          "PERSON_ID",
                                          "HOUSE_HOLD_ID" ],
                                        "default":"STANDARD" },
                                      use_fallback:{ type:"boolean",
                                        "default":true },
                                      items:{ type:"array",
                                        items:{ type:"object",
                                          properties:{ impressions:{ type:"number",
                                              minimum:1,
                                              exclusiveMinimum:false },
                                            interval:{ type:"number",
                                              minimum:1,
                                              exclusiveMinimum:false },
                                            time_unit:{ type:"string",
                                              "enum":[ "DAY",
                                                "HOUR",
                                                "MINUTE",
                                                "WEEK" ],
                                              "default":"DAY" } },
                                          required:[ "impressions",
                                            "interval" ] } } },
                                    required:[ "items" ] } },
                                budget_type:{ type:"string",
                                  "enum":[ "SPEND_WITH_VENDOR_FEES",
                                    "SPEND",
                                    "IMPRESSION" ] } },
                              required:[ "effective_status",
                                "type",
                                "budget_carryover",
                                "bidding_strategy",
                                "pacing_strategy",
                                "frequency_caps",
                                "budget_type" ] } },
                          meta:{ type:"object",
                            properties:{ count:{ type:"number" },
                              lastPage:{ type:"number" },
                              currentPage:{ type:"number" },
                              totalPerPage:{ type:"number" },
                              prevPage:{ type:"number",
                                nullable:true,
                                example:1 },
                              nextPage:{ type:"number",
                                nullable:true,
                                example:null } },
                            required:[ "count",
                              "lastPage",
                              "currentPage",
                              "totalPerPage",
                              "prevPage",
                              "nextPage" ] } } },
                      { properties:{ data:{ type:"array",
                            items:{ type:"object",
                              properties:{ effective_status:{ type:"string",
                                  "enum":[ "DELIVERING",
                                    "DELIVERED",
                                    "STOPPED",
                                    "INACTIVE",
                                    "UNKNOWN" ] },
                                type:{ type:"string",
                                  "enum":[ "VIDEO",
                                    "BANNER",
                                    "CTV" ] },
                                budget_carryover:{ type:"string",
                                  "enum":[ "NONE",
                                    "CARRY_OVER",
                                    "EVENLY_DISTRIBUTE",
                                    "PRORATED_DISTRIBUTE" ] },
                                bidding_strategy:{ type:"object",
                                  properties:{ type:{ type:"string",
                                      "enum":[ "FLAT_CPM",
                                        "CPC",
                                        "CPA" ],
                                      "x-enumNames":[ "FLAT_CPM",
                                        "CPC",
                                        "CPA" ],
                                      "default":"FLAT_CPM" },
                                    bid_shading_control:{ type:"string",
                                      "enum":[ "NORMAL",
                                        "LESS_AGGRESSIVE",
                                        "MORE_AGGRESSIVE" ],
                                      "x-enumNames":[ "NORMAL",
                                        "LESS_AGGRESSIVE",
                                        "MORE_AGGRESSIVE" ] },
                                    cpm:{ type:"number" } },
                                  required:[ "bid_shading_control",
                                    "cpm" ] },
                                pacing_strategy:{ type:"object",
                                  properties:{ type:{ type:"string",
                                      "enum":[ "DAILY",
                                        "LIFETIME",
                                        "FLIGHT" ],
                                      "x-enumNames":[ "Daily",
                                        "Lifetime",
                                        "Flight" ],
                                      "default":"LIFETIME" },
                                    pacing_behavior:{ type:"string",
                                      "enum":[ "EVEN",
                                        "AHEAD" ],
                                      "x-enumNames":[ "Even",
                                        "Ahead" ],
                                      "default":"EVEN" },
                                    catchup_behavior:{ type:"string",
                                      "enum":[ "EVEN",
                                        "IMMEDIATE",
                                        "SMOOTH" ],
                                      "x-enumNames":[ "Even",
                                        "Immediate",
                                        "Smooth" ],
                                      "default":"EVEN" },
                                    multiplier:{ type:"number",
                                      nullable:true,
                                      "default":1 } } },
                                frequency_caps:{ type:"array",
                                  items:{ type:"object",
                                    properties:{ type:{ type:"string",
                                        "enum":[ "STANDARD",
                                          "IP_ADDRESS",
                                          "PERSON_ID",
                                          "HOUSE_HOLD_ID" ],
                                        "default":"STANDARD" },
                                      use_fallback:{ type:"boolean",
                                        "default":true },
                                      items:{ type:"array",
                                        items:{ type:"object",
                                          properties:{ impressions:{ type:"number",
                                              minimum:1,
                                              exclusiveMinimum:false },
                                            interval:{ type:"number",
                                              minimum:1,
                                              exclusiveMinimum:false },
                                            time_unit:{ type:"string",
                                              "enum":[ "DAY",
                                                "HOUR",
                                                "MINUTE",
                                                "WEEK" ],
                                              "default":"DAY" } },
                                          required:[ "impressions",
                                            "interval" ] } } },
                                    required:[ "items" ] } },
                                budget_type:{ type:"string",
                                  "enum":[ "SPEND_WITH_VENDOR_FEES",
                                    "SPEND",
                                    "IMPRESSION" ] } },
                              required:[ "effective_status",
                                "type",
                                "budget_carryover",
                                "bidding_strategy",
                                "pacing_strategy",
                                "frequency_caps",
                                "budget_type" ] } } } } ] } } } },
            404:{ description:"Organization not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"List all line items",
          tags:[ "Line Items" ] } },
      "/organizations/{organization_id}/line-items/{id}":{ get:{ operationId:"LineItemsController_findOne",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the line item",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 404:{ description:"Line item not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Get a line item by ID",
          tags:[ "Line Items" ] },
        patch:{ operationId:"LineItemsController_update",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the line item",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          requestBody:{ required:true,
            content:{ "application/json":{ schema:{ type:"object",
                  properties:{ name:{ description:"The name of the line item",
                      type:"string" },
                    description:{ description:"A description for the line item",
                      type:"string",
                      nullable:true },
                    active:{ description:"Whether the line item should be active",
                      type:"boolean",
                      "default":false },
                    start_datetime:{ description:"The start date and time of the line item" },
                    end_datetime:{ description:"The end date and time of the line item" },
                    type:{ description:"The type of line item",
                      type:"string",
                      "enum":[ "VIDEO",
                        "BANNER",
                        "CTV" ],
                      "x-enumNames":[ "VIDEO",
                        "BANNER",
                        "CTV" ] },
                    budget_carryover:{ description:"The budget carry over policy of the line item",
                      type:"string",
                      "enum":[ "NONE",
                        "CARRY_OVER",
                        "EVENLY_DISTRIBUTE",
                        "PRORATED_DISTRIBUTE" ],
                      "x-enumNames":[ "NONE",
                        "CARRY_OVER",
                        "EVENLY_DISTRIBUTE",
                        "PRORATED_DISTRIBUTE" ],
                      "default":"NONE" },
                    budget_type:{ description:"The type of budget of the line item",
                      type:"string",
                      "enum":[ "SPEND_WITH_VENDOR_FEES",
                        "SPEND",
                        "IMPRESSION" ],
                      "x-enumNames":[ "SPEND_WITH_VENDOR_FEES",
                        "SPEND",
                        "IMPRESSION" ],
                      nullable:true,
                      "default":"SPEND_WITH_VENDOR_FEES" },
                    overall_budget:{ description:"The overall budget of the line item",
                      type:"number",
                      minimum:0,
                      exclusiveMinimum:true,
                      nullable:true },
                    daily_budget:{ description:"The daily budget of the line item",
                      type:"number",
                      nullable:true },
                    bidding_strategy:{ description:"The bidding strategy of the line item",
                      type:"object",
                      properties:{ type:{ type:"string",
                          "enum":[ "FLAT_CPM",
                            "CPC",
                            "CPA" ],
                          "x-enumNames":[ "FLAT_CPM",
                            "CPC",
                            "CPA" ],
                          "default":"FLAT_CPM" },
                        bid_shading_control:{ type:"string",
                          "enum":[ "NORMAL",
                            "LESS_AGGRESSIVE",
                            "MORE_AGGRESSIVE" ],
                          "x-enumNames":[ "NORMAL",
                            "LESS_AGGRESSIVE",
                            "MORE_AGGRESSIVE" ] },
                        cpm:{ type:"number" } },
                      required:[ "bid_shading_control",
                        "cpm" ] },
                    pacing_strategy:{ description:"The pacing strategy of the line item",
                      type:"object",
                      properties:{ type:{ type:"string",
                          "enum":[ "DAILY",
                            "LIFETIME",
                            "FLIGHT" ],
                          "x-enumNames":[ "Daily",
                            "Lifetime",
                            "Flight" ],
                          "default":"LIFETIME" },
                        pacing_behavior:{ type:"string",
                          "enum":[ "EVEN",
                            "AHEAD" ],
                          "x-enumNames":[ "Even",
                            "Ahead" ],
                          "default":"EVEN" },
                        catchup_behavior:{ type:"string",
                          "enum":[ "EVEN",
                            "IMMEDIATE",
                            "SMOOTH" ],
                          "x-enumNames":[ "Even",
                            "Immediate",
                            "Smooth" ],
                          "default":"EVEN" },
                        multiplier:{ type:"number",
                          nullable:true,
                          "default":1 } } },
                    vendor_fees:{ description:"The vendor fees of the line item",
                      type:"array",
                      maxItems:3,
                      items:{ type:"object",
                        properties:{ vendor_id:{ type:"string",
                            format:"uuid" },
                          name:{ type:"string",
                            minLength:1,
                            maxLength:191 },
                          type:{ type:"string",
                            "enum":[ "DEFAULT",
                              "CPM",
                              "PERCENTAGE" ],
                            "default":"DEFAULT" },
                          amount:{ description:"Required for non-default vendor fees",
                            type:"number",
                            nullable:true } },
                        required:[ "vendor_id",
                          "name" ],
                        nullable:true } },
                    frequency_caps:{ description:"The frequency caps of the line item",
                      type:"object",
                      properties:{ type:{ type:"string",
                          "enum":[ "STANDARD",
                            "IP_ADDRESS",
                            "PERSON_ID",
                            "HOUSE_HOLD_ID" ],
                          "default":"STANDARD" },
                        use_fallback:{ type:"boolean",
                          "default":true },
                        items:{ type:"array",
                          items:{ type:"object",
                            properties:{ impressions:{ type:"number",
                                minimum:1,
                                exclusiveMinimum:false },
                              interval:{ type:"number",
                                minimum:1,
                                exclusiveMinimum:false },
                              time_unit:{ type:"string",
                                "enum":[ "DAY",
                                  "HOUR",
                                  "MINUTE",
                                  "WEEK" ],
                                "default":"DAY" } },
                            required:[ "impressions",
                              "interval" ] } } },
                      required:[ "items" ] } } } } } },
          responses:{ 400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:[ { code:"invalid_type",
                        expected:"boolean",
                        received:"undefined",
                        path:[ "active" ],
                        message:"Required" } ],
                    statusCode:400 } } } },
            403:{ description:"Forbidden - Write access required",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"Line item not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Update a line item",
          tags:[ "Line Items" ] },
        "delete":{ operationId:"LineItemsController_remove",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the line item",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:[ { code:"invalid_type",
                        expected:"boolean",
                        received:"undefined",
                        path:[ "active" ],
                        message:"Required" } ],
                    statusCode:400 } } } },
            403:{ description:"Forbidden - Write access required",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"Line item not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Delete a line item",
          tags:[ "Line Items" ] } },
      "/organizations/{organization_id}/line-items/{id}/audience":{ patch:{ operationId:"LineItemsController_audience",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the line item",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          requestBody:{ required:true,
            description:"Audience targeting data",
            content:{ "application/json":{ schema:{ type:"object",
                  properties:{ prompt:{ type:"string",
                      nullable:true },
                    include:{ type:"array",
                      items:{ type:"object",
                        properties:{ id:{ type:"string",
                            format:"uuid" },
                          audience_schema_key_id:{ type:"string",
                            format:"uuid" } },
                        required:[ "id",
                          "audience_schema_key_id" ] } },
                    exclude:{ type:"array",
                      items:{ type:"object",
                        properties:{ id:{ type:"string",
                            format:"uuid" },
                          audience_schema_key_id:{ type:"string",
                            format:"uuid" } },
                        required:[ "id",
                          "audience_schema_key_id" ] } } },
                  required:[ "include",
                    "exclude" ] } } } },
          responses:{ 403:{ description:"Forbidden - Write access required",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"Line item not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Update a line item audience targeting",
          tags:[ "Line Items" ] } },
      "/organizations/{organization_id}/line-items/{id}/audience/stats":{ post:{ operationId:"LineItemsController_audience_stats",
          parameters:[ { name:"id",
              required:true,
              "in":"path",
              description:"ID of the line item",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          requestBody:{ required:true,
            description:"Audience stats query parameters",
            content:{ "application/json":{ schema:{ type:"object",
                  properties:{ first_party_audience_filter:{ type:"array",
                      items:{ type:"object",
                        properties:{ id:{ type:"string",
                            format:"uuid" },
                          included:{ type:"boolean" } },
                        required:[ "id",
                          "included" ] } },
                    audience_filter:{ type:"array",
                      items:{ type:"object",
                        properties:{ name:{ type:"string" },
                          values:{ type:"array",
                            items:{ type:"object",
                              properties:{ id:{ type:"string",
                                  format:"uuid" },
                                included:{ type:"boolean" } },
                              required:[ "id",
                                "included" ] } } },
                        required:[ "name",
                          "values" ] } },
                    days:{ type:"integer",
                      minimum:1,
                      exclusiveMinimum:false } },
                  required:[ "first_party_audience_filter",
                    "audience_filter" ] } } } },
          responses:{ 404:{ description:"Line item not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Get audience statistics for a line item",
          tags:[ "Line Items" ] } },
      "/organizations/{organization_id}/line-items/{id}/inventory":{ patch:{ operationId:"LineItemsController_inventory",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the line item",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          requestBody:{ required:true,
            description:"Inventory targeting data",
            content:{ "application/json":{ schema:{ type:"object",
                  properties:{ include:{ type:"array",
                      items:{ type:"object",
                        properties:{ id:{ type:"string",
                            format:"uuid" },
                          inventory_schema_key_id:{ type:"string",
                            format:"uuid" } },
                        required:[ "id",
                          "inventory_schema_key_id" ] } },
                    exclude:{ type:"array",
                      items:{ type:"object",
                        properties:{ id:{ type:"string",
                            format:"uuid" },
                          inventory_schema_key_id:{ type:"string",
                            format:"uuid" } },
                        required:[ "id",
                          "inventory_schema_key_id" ] } } },
                  required:[ "include",
                    "exclude" ] } } } },
          responses:{ 400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:[ { code:"invalid_type",
                        expected:"boolean",
                        received:"undefined",
                        path:[ "active" ],
                        message:"Required" } ],
                    statusCode:400 } } } },
            403:{ description:"Forbidden - Write access required",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"Line item not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Update a line item inventory targeting",
          tags:[ "Line Items" ] } },
      "/organizations/{organization_id}/line-items/{id}/first_part_audience":{ patch:{ operationId:"LineItemsController_first_part_audience",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the line item",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          requestBody:{ required:true,
            description:"First party audience targeting data",
            content:{ "application/json":{ schema:{ type:"object",
                  properties:{ include:{ type:"array",
                      items:{ type:"object",
                        properties:{ id:{ type:"string",
                            format:"uuid" },
                          audience_custom_list_schema_key_id:{ type:"string",
                            format:"uuid" } },
                        required:[ "id",
                          "audience_custom_list_schema_key_id" ] } },
                    exclude:{ type:"array",
                      items:{ type:"object",
                        properties:{ id:{ type:"string",
                            format:"uuid" },
                          audience_custom_list_schema_key_id:{ type:"string",
                            format:"uuid" } },
                        required:[ "id",
                          "audience_custom_list_schema_key_id" ] } } },
                  required:[ "include",
                    "exclude" ] } } } },
          responses:{ 400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:[ { code:"invalid_type",
                        expected:"boolean",
                        received:"undefined",
                        path:[ "active" ],
                        message:"Required" } ],
                    statusCode:400 } } } },
            403:{ description:"Forbidden - Write access required",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"Line item not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Update line item first party audience targeting",
          tags:[ "Line Items" ] } },
      "/organizations/{organization_id}/line-items/{id}/creatives":{ get:{ operationId:"LineItemsController_creatives",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the line item",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 404:{ description:"Line item not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Get creatives associated with a line item",
          tags:[ "Line Items" ] },
        post:{ operationId:"LineItemsController_connectCreatives",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the line item",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          requestBody:{ required:true,
            description:"Creative IDs to connect",
            content:{ "application/json":{ schema:{ type:"array",
                  items:{ type:"object",
                    properties:{ creative_id:{ type:"string",
                        format:"uuid" },
                      weight:{ type:"number",
                        nullable:true },
                      start_datetime:{ type:"string",
                        format:"date-time",
                        nullable:true },
                      end_datetime:{ type:"string",
                        format:"date-time",
                        nullable:true } },
                    required:[ "creative_id",
                      "weight" ] } } } } },
          responses:{ 400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:[ { code:"invalid_type",
                        expected:"boolean",
                        received:"undefined",
                        path:[ "active" ],
                        message:"Required" } ],
                    statusCode:400 } } } },
            403:{ description:"Forbidden - Write access required",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"Line item not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Connect creatives to a line item",
          tags:[ "Line Items" ] } },
      "/organizations/{organization_id}/line-items/{id}/flights":{ get:{ operationId:"LineItemsController_getFlights",
          parameters:[ { name:"id",
              required:true,
              "in":"path",
              description:"ID of the line item",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 404:{ description:"Line item not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Get the flights of a line item",
          tags:[ "Line Items" ] },
        put:{ operationId:"LineItemsController_updateFlights",
          parameters:[ { name:"id",
              required:true,
              "in":"path",
              description:"ID of the line item",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          requestBody:{ required:true,
            description:"Flights data",
            content:{ "application/json":{ schema:{ type:"array",
                  items:{ type:"object",
                    properties:{ id:{ description:"The ID of the flight",
                        type:"string",
                        format:"uuid" },
                      name:{ description:"The name of the flight",
                        type:"string" },
                      start_datetime:{ description:"The start date and time of the flight",
                        type:"string",
                        format:"date-time" },
                      end_datetime:{ description:"The end date and tieme of the flight",
                        type:"string",
                        format:"date-time" },
                      budget:{ description:"The budget of the flight",
                        type:"number" } },
                    required:[ "name",
                      "start_datetime",
                      "end_datetime",
                      "budget" ] } } } } },
          responses:{ 400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:[ { code:"invalid_type",
                        expected:"boolean",
                        received:"undefined",
                        path:[ "active" ],
                        message:"Required" } ],
                    statusCode:400 } } } },
            403:{ description:"Forbidden - Write access required",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"Line item not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Update the flights of a line item",
          tags:[ "Line Items" ] } },
      "/organizations/{organization_id}/creatives":{ post:{ operationId:"CreativesController_create",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          requestBody:{ required:true,
            description:"Data to create a creative",
            content:{ "application/json":{ schema:{ type:"object",
                  properties:{ name:{ description:"The name of the creative",
                      type:"string",
                      maxLength:191,
                      minLength:1 },
                    type:{ description:"The type of the creative",
                      type:"string",
                      "enum":[ "VIDEO",
                        "BANNER" ],
                      "x-enumNames":[ "VIDEO",
                        "BANNER" ] },
                    active:{ description:"Whether the creative is active",
                      type:"boolean",
                      "default":true },
                    click_url:{ description:"The click url of the creative",
                      type:"string",
                      format:"uri" },
                    landing_page_url:{ description:"The landing page url of the creative" },
                    third_party_pixels:{ description:"Optional third party pixels to trigger for the creative",
                      type:"array",
                      maxItems:5,
                      items:{ type:"string",
                        format:"uri" } },
                    start_datetime:{ description:"The start date and time of the creative",
                      type:"string",
                      format:"date-time",
                      nullable:true },
                    end_datetime:{ description:"The end date and time of the creative",
                      type:"string",
                      format:"date-time",
                      nullable:true },
                    description:{ description:"The description of the creative",
                      type:"string",
                      nullable:true },
                    advertiser_id:{ description:"The ID of the advertiser the creative refers to",
                      type:"string",
                      format:"uuid" } },
                  required:[ "name",
                    "type",
                    "click_url",
                    "advertiser_id" ] } } } },
          responses:{ 400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:[ { code:"invalid_type",
                        expected:"string",
                        received:"undefined",
                        path:[ "type" ],
                        message:"Required" } ],
                    statusCode:400 } } } },
            403:{ description:"Forbidden - Write access required",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404,
                    description:"Advertiser not found" } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Create a new creative",
          tags:[ "Creatives" ] },
        get:{ operationId:"CreativesController_findAll",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"page",
              required:false,
              "in":"query",
              description:"Which page of results to fetch",
              schema:{ "default":1,
                example:"1",
                type:"string" } },
            { name:"pageSize",
              required:false,
              "in":"query",
              description:"The size of a page of results to fetch",
              schema:{ "default":10,
                example:"10",
                type:"string" } },
            { name:"search",
              required:false,
              "in":"query",
              description:"Search term for filtering creatives",
              schema:{ example:"holiday campaign",
                type:"string" } },
            { name:"active",
              required:false,
              "in":"query",
              description:"Filter by active status",
              schema:{ example:true,
                type:"boolean" } },
            { name:"type",
              required:false,
              "in":"query",
              description:"Filter by media asset type",
              schema:{ example:"BANNER",
                type:"string",
                "enum":[ "VIDEO",
                  "BANNER" ] } },
            { name:"start_datetime",
              required:false,
              "in":"query",
              description:"Start date for filtering (ISO string)",
              schema:{ example:"2024-01-01T00:00:00.000Z",
                type:"string" } },
            { name:"end_datetime",
              required:false,
              "in":"query",
              description:"End date for filtering (ISO string)",
              schema:{ example:"2024-12-31T23:59:59.999Z",
                type:"string" } },
            { name:"advertiser_id",
              required:false,
              "in":"query",
              description:"Filter by advertiser ID",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"campaign_id",
              required:false,
              "in":"query",
              description:"Filter by campaign ID",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174001",
                type:"string" } },
            { name:"line_item_id",
              required:false,
              "in":"query",
              description:"Filter by line item ID",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174002",
                type:"string" } } ],
          responses:{ 200:{ description:"Successfully received model list",
              content:{ "application/json":{ schema:{ allOf:[ { type:"object",
                        properties:{ data:{ type:"array",
                            items:{ type:"object",
                              properties:{ type:{ type:"string",
                                  "enum":[ "VIDEO",
                                    "BANNER" ] },
                                active:{ type:"boolean",
                                  example:false },
                                ad_tag_creation_status:{ type:"string",
                                  "enum":[ "IN_PROGRESS",
                                    "SUCCEEDED",
                                    "FAILED",
                                    "UNKNOWN" ] } },
                              required:[ "type",
                                "active",
                                "ad_tag_creation_status" ] } },
                          meta:{ type:"object",
                            properties:{ count:{ type:"number" },
                              lastPage:{ type:"number" },
                              currentPage:{ type:"number" },
                              totalPerPage:{ type:"number" },
                              prevPage:{ type:"number",
                                nullable:true,
                                example:1 },
                              nextPage:{ type:"number",
                                nullable:true,
                                example:null } },
                            required:[ "count",
                              "lastPage",
                              "currentPage",
                              "totalPerPage",
                              "prevPage",
                              "nextPage" ] } } },
                      { properties:{ data:{ type:"array",
                            items:{ type:"object",
                              properties:{ type:{ type:"string",
                                  "enum":[ "VIDEO",
                                    "BANNER" ] },
                                active:{ type:"boolean",
                                  example:false },
                                ad_tag_creation_status:{ type:"string",
                                  "enum":[ "IN_PROGRESS",
                                    "SUCCEEDED",
                                    "FAILED",
                                    "UNKNOWN" ] } },
                              required:[ "type",
                                "active",
                                "ad_tag_creation_status" ] } } } } ] } } } },
            404:{ description:"",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404,
                    description:"Organization not found" } } } } },
          security:[ { bearer:[  ] } ],
          summary:"List all creatives",
          tags:[ "Creatives" ] } },
      "/organizations/{organization_id}/creatives/{id}":{ get:{ operationId:"CreativesController_findOne",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the creative",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 404:{ description:"",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404,
                    description:"Creative not found" } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Get a creative by ID",
          tags:[ "Creatives" ] },
        patch:{ operationId:"CreativesController_update",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the creative",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          requestBody:{ required:true,
            description:"Update creative data",
            content:{ "application/json":{ schema:{ type:"object",
                  properties:{ name:{ description:"The name of the creative",
                      type:"string",
                      maxLength:191,
                      minLength:1 },
                    active:{ description:"Whether the creative is active",
                      type:"boolean",
                      "default":true },
                    click_url:{ description:"The click url of the creative",
                      type:"string",
                      format:"uri" },
                    landing_page_url:{ description:"The landing page url of the creative" },
                    third_party_pixels:{ description:"Optional third party pixels to trigger for the creative",
                      type:"array",
                      maxItems:5,
                      items:{ type:"string",
                        format:"uri" } },
                    start_datetime:{ description:"The start date and time of the creative",
                      type:"string",
                      format:"date-time",
                      nullable:true },
                    end_datetime:{ description:"The end date and time of the creative",
                      type:"string",
                      format:"date-time",
                      nullable:true },
                    description:{ description:"The description of the creative",
                      type:"string",
                      nullable:true } } } } } },
          responses:{ 400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:[ { code:"invalid_type",
                        expected:"string",
                        received:"undefined",
                        path:[ "type" ],
                        message:"Required" } ],
                    statusCode:400 } } } },
            403:{ description:"Forbidden - Write access required",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404,
                    description:"Creative not found" } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Update a creative",
          tags:[ "Creatives" ] },
        "delete":{ operationId:"CreativesController_remove",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the creative",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 403:{ description:"Forbidden - Write access required",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404,
                    description:"Creative not found" } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Delete creative",
          tags:[ "Creatives" ] } },
      "/organizations/{organization_id}/creatives/{id}/approval":{ get:{ operationId:"CreativesController_getApproval",
          parameters:[ { name:"id",
              required:true,
              "in":"path",
              description:"ID of the creative",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 404:{ description:"",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404,
                    description:"Creative not found" } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Get the approval status of a creative",
          tags:[ "Creatives" ] } },
      "/organizations/{organization_id}/creatives/{id}/upload":{ post:{ operationId:"CreativesController_upload",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the creative",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          requestBody:{ required:true,
            description:"Creative asset file",
            content:{ "multipart/form-data":{ schema:{ type:"object",
                  properties:{ file:{ type:"string",
                      format:"binary",
                      description:"The creative asset file (image or video)" } } } } } },
          responses:{ 400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:"Invalid file provided",
                    statusCode:400 } } } },
            403:{ description:"Forbidden - Write access required",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404,
                    description:"Creative not found" } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Upload creative asset",
          tags:[ "Creatives" ] } },
      "/organizations/{organization_id}/creatives/{id}/line-items":{ get:{ operationId:"CreativesController_lineItems",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the creative",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 404:{ description:"",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404,
                    description:"Creative not found" } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Get line items associated with creative",
          tags:[ "Creatives" ] },
        post:{ operationId:"CreativesController_connectLineItems",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the creative",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          requestBody:{ required:true,
            description:"Line item IDs to connect",
            content:{ "application/json":{ schema:{ type:"array",
                  items:{ type:"object",
                    properties:{ line_item_id:{ type:"string",
                        format:"uuid" },
                      start_datetime:{ type:"string",
                        format:"date-time",
                        nullable:true },
                      end_datetime:{ type:"string",
                        format:"date-time",
                        nullable:true },
                      weight:{ type:"number",
                        maximum:100,
                        exclusiveMaximum:false,
                        minimum:0,
                        exclusiveMinimum:false } },
                    required:[ "line_item_id",
                      "weight" ] } } } } },
          responses:{ 400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:[ { code:"invalid_type",
                        expected:"string",
                        received:"undefined",
                        path:[ "line_item_id" ],
                        message:"Required" } ],
                    statusCode:400 } } } },
            403:{ description:"Forbidden - Write access required",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404,
                    description:"Creative not found" } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Connect line items to creative",
          tags:[ "Creatives" ] } },
      "/ref/advertiser_categories":{ get:{ description:"Retrieve all available advertiser categories for ad targeting",
          operationId:"StaticsController_advertiser_categories",
          parameters:[  ],
          responses:{ 200:{ description:"" } },
          summary:"Get advertiser categories",
          tags:[ "Reference resources" ] } },
      "/ref/audience/prompt":{ post:{ description:"Use AI to generate audience targeting filters based on a natural language prompt. Requires authentication.",
          operationId:"StaticsController_audiencePrompt",
          parameters:[  ],
          requestBody:{ required:true,
            description:"Natural language prompt to generate audience filter",
            content:{ "application/json":{ schema:{ type:"object",
                  properties:{ prompt:{ type:"string",
                      example:"Target young adults aged 18-34 interested in technology and gaming",
                      description:"Natural language description of the desired audience" } },
                  required:[ "prompt" ] } } } },
          responses:{ 200:{ description:"" } },
          summary:"Generate audience filter from AI prompt",
          tags:[ "Reference resources" ] } },
      "/ref/audience_schema_keys":{ get:{ description:"Retrieve all available audience schema keys for targeting configuration",
          operationId:"StaticsController_audience_schema_keys",
          parameters:[  ],
          responses:{ 200:{ description:"" } },
          summary:"Get audience schema keys",
          tags:[ "Reference resources" ] } },
      "/ref/audience_schema_keys/{id}/values":{ get:{ description:"Retrieve all available values for a specific audience schema key",
          operationId:"StaticsController_audience_schema_key_values",
          parameters:[ { name:"id",
              required:true,
              "in":"path",
              description:"The audience schema key ID",
              schema:{ example:"age_group",
                type:"string" } } ],
          responses:{ 200:{ description:"" } },
          summary:"Get values for a specific audience schema key",
          tags:[ "Reference resources" ] } },
      "/ref/inventory_schema_keys":{ get:{ description:"Retrieve all available inventory schema keys for ad placement configuration",
          operationId:"StaticsController_inventory_schema_keys",
          parameters:[  ],
          responses:{ 200:{ description:"" } },
          summary:"Get inventory schema keys",
          tags:[ "Reference resources" ] } },
      "/ref/inventory_schema_keys/{id}/values":{ get:{ description:"Retrieve all available values for a specific inventory schema key",
          operationId:"StaticsController_inventory_schema_key_values",
          parameters:[ { name:"id",
              required:true,
              "in":"path",
              schema:{ type:"string" } } ],
          responses:{ 200:{ description:"" } },
          summary:"Get values for a specific inventory schema key",
          tags:[ "Reference resources" ] } },
      "/ref/{id}/asset/banner":{ get:{ description:"Download the banner asset file for a specific creative",
          operationId:"StaticsController_getBanner",
          parameters:[ { name:"id",
              required:true,
              "in":"path",
              description:"The creative ID",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 200:{ headers:{ "Content-Disposition":{ description:"Attachment filename",
                  schema:{ type:"string",
                    example:"attachment; filename=\"document.pdf\"" } } },
              description:"",
              content:{ "application/octet-stream":{ schema:{ type:"string",
                    format:"binary" } } } } },
          summary:"Get banner asset file",
          tags:[ "Reference resources" ] } },
      "/organizations/{organization_id}/audience_custom_lists":{ post:{ description:"Creates a new custom audience list within the specified organization.",
          operationId:"AudienceCustomListsController_create",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          requestBody:{ required:true,
            content:{ "application/json":{ schema:{ type:"object",
                  properties:{ name:{ type:"string",
                      minLength:1,
                      maxLength:191 },
                    column_map:{ type:"array",
                      items:{ type:"string",
                        "enum":[ "aidem_person_id",
                          "aidem_household_id",
                          "email",
                          "phone_number",
                          "first_name",
                          "last_name",
                          "address_line_1",
                          "address_line_2",
                          "state",
                          "zip_code",
                          "auto_vin",
                          "linkedin_profile",
                          "up_id",
                          "lalvoter_id" ],
                        "x-enumNames":[ "AIDEM_PERSON_ID",
                          "AIDEM_HOUSEHOLD_ID",
                          "EMAIL",
                          "PHONE_NUMBER",
                          "FIRST_NAME",
                          "LAST_NAME",
                          "ADDRESS_LINE_1",
                          "ADDRESS_LINE_2",
                          "STATE",
                          "ZIP_CODE",
                          "AUTO_VIN",
                          "LINKEDIN_PROFILE",
                          "UP_ID",
                          "LALVOTER_ID" ],
                        nullable:true } },
                    type:{ type:"string",
                      "enum":[ "EXACT",
                        "LOOKALIKE" ],
                      "x-enumNames":[ "EXACT",
                        "LOOKALIKE" ] },
                    advertiser_id:{ type:"string",
                      format:"uuid" } },
                  required:[ "name",
                    "column_map",
                    "type",
                    "advertiser_id" ] } } } },
          responses:{ 400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:[ { code:"invalid_type",
                        expected:"string",
                        received:"undefined",
                        path:[ "advertiser_id" ],
                        message:"Required" } ],
                    statusCode:400 } } } },
            403:{ description:"Forbidden - Write access needed",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"Advertiser not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Create a new audience custom list",
          tags:[ "Audience custom lists" ] },
        get:{ operationId:"AudienceCustomListsController_findAll",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"page",
              required:false,
              "in":"query",
              description:"Which page of results to fetch",
              schema:{ "default":1,
                example:"1",
                type:"string" } },
            { name:"pageSize",
              required:false,
              "in":"query",
              description:"The size of a page of results to fetch",
              schema:{ "default":10,
                example:"10",
                type:"string" } },
            { name:"search",
              required:true,
              "in":"query",
              description:"Filter by name",
              schema:{ type:"string" } },
            { name:"type",
              required:true,
              "in":"query",
              description:"Filter by type",
              schema:{ type:"string" } },
            { name:"availability",
              required:true,
              "in":"query",
              description:"Filter by availability",
              schema:{ type:"boolean" } },
            { name:"estimated_size_min",
              required:true,
              "in":"query",
              description:"Filter by estimated size min",
              schema:{ type:"number" } },
            { name:"estimated_size_max",
              required:true,
              "in":"query",
              description:"Filter by estimated size max",
              schema:{ type:"boolean" } } ],
          responses:{ 200:{ description:"Successfully received model list",
              content:{ "application/json":{ schema:{ allOf:[ { type:"object",
                        properties:{ data:{ type:"array",
                            items:{ type:"object",
                              properties:{} } },
                          meta:{ type:"object",
                            properties:{ count:{ type:"number" },
                              lastPage:{ type:"number" },
                              currentPage:{ type:"number" },
                              totalPerPage:{ type:"number" },
                              prevPage:{ type:"number",
                                nullable:true,
                                example:1 },
                              nextPage:{ type:"number",
                                nullable:true,
                                example:null } },
                            required:[ "count",
                              "lastPage",
                              "currentPage",
                              "totalPerPage",
                              "prevPage",
                              "nextPage" ] } } },
                      { properties:{ data:{ type:"array",
                            items:{ type:"object",
                              properties:{} } } } } ] } } } },
            404:{ description:"Organization not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Get all audience custom lists",
          tags:[ "Audience custom lists" ] } },
      "/organizations/{organization_id}/audience_custom_lists/{id}":{ patch:{ description:"Updates an existing custom audience list with the provided data.",
          operationId:"AudienceCustomListsController_update",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"The organization ID",
              schema:{ format:"uuid",
                type:"string" } },
            { name:"id",
              required:true,
              "in":"path",
              description:"The audience custom list ID",
              schema:{ format:"uuid",
                type:"string" } } ],
          requestBody:{ required:true,
            content:{ "application/json":{ schema:{ type:"object",
                  properties:{ name:{ type:"string",
                      minLength:1,
                      maxLength:191 },
                    type:{ type:"string",
                      "enum":[ "EXACT",
                        "LOOKALIKE" ],
                      "x-enumNames":[ "EXACT",
                        "LOOKALIKE" ] } } } } } },
          responses:{ 400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:[ { code:"invalid_type",
                        expected:"string",
                        received:"undefined",
                        path:[ "advertiser_id" ],
                        message:"Required" } ],
                    statusCode:400 } } } },
            403:{ description:"Forbidden - Write access needed",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"Audience custom list not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Update an audience custom list",
          tags:[ "Audience custom lists" ] },
        "delete":{ description:"Permanently deletes the specified custom audience list from the organization.",
          operationId:"AudienceCustomListsController_remove",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"The organization ID",
              schema:{ format:"uuid",
                type:"string" } },
            { name:"id",
              required:true,
              "in":"path",
              description:"The audience custom list ID",
              schema:{ format:"uuid",
                type:"string" } } ],
          responses:{ 403:{ description:"Forbidden - Write access needed",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"Audience custom list not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Delete an audience custom list",
          tags:[ "Audience custom lists" ] } },
      "/organizations/{organization_id}/audience_custom_lists/{id}/upload":{ post:{ description:"Uploads a CSV file containing audience data for the specified custom list.",
          operationId:"AudienceCustomListsController_upload",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"The organization ID",
              schema:{ format:"uuid",
                type:"string" } },
            { name:"id",
              required:true,
              "in":"path",
              description:"The audience custom list ID",
              schema:{ format:"uuid",
                type:"string" } } ],
          requestBody:{ required:true,
            description:"CSV file upload",
            content:{ "multipart/form-data":{ schema:{ type:"object",
                  properties:{ file:{ type:"string",
                      format:"binary",
                      description:"CSV file containing audience data" } } } } } },
          responses:{ 400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:"file is not text/CSV",
                    statusCode:400 } } } },
            403:{ description:"Forbidden - Write access needed",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"Audience custom list not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Upload a CSV file for an audience custom list",
          tags:[ "Audience custom lists" ] } },
      "/organizations/{organization_id}/integrations":{ get:{ operationId:"IntegrationsController_getAll",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"page",
              required:false,
              "in":"query",
              description:"Which page of results to fetch",
              schema:{ "default":1,
                example:"1",
                type:"string" } },
            { name:"pageSize",
              required:false,
              "in":"query",
              description:"The size of a page of results to fetch",
              schema:{ "default":10,
                example:"10",
                type:"string" } },
            { name:"search",
              required:true,
              "in":"query",
              description:"Filter by name or ID",
              schema:{ type:"string" } },
            { name:"type",
              required:true,
              "in":"query",
              description:"Filter by type",
              schema:{ type:"string",
                "enum":[ "shopify",
                  "web_stream_pixel",
                  "conversion_api" ] } },
            { name:"name",
              required:true,
              "in":"query",
              description:"Filter by name",
              schema:{ type:"string" } },
            { name:"advertiser_id",
              required:true,
              "in":"query",
              description:"Filter by advertiser ID",
              schema:{ type:"string" } } ],
          responses:{ 200:{ description:"Successfully received model list",
              content:{ "application/json":{ schema:{ allOf:[ { type:"object",
                        properties:{ data:{ type:"array",
                            items:{ type:"object",
                              properties:{} } },
                          meta:{ type:"object",
                            properties:{ count:{ type:"number" },
                              lastPage:{ type:"number" },
                              currentPage:{ type:"number" },
                              totalPerPage:{ type:"number" },
                              prevPage:{ type:"number",
                                nullable:true,
                                example:1 },
                              nextPage:{ type:"number",
                                nullable:true,
                                example:null } },
                            required:[ "count",
                              "lastPage",
                              "currentPage",
                              "totalPerPage",
                              "prevPage",
                              "nextPage" ] } } },
                      { properties:{ data:{ type:"array",
                            items:{ type:"object",
                              properties:{} } } } } ] } } } },
            404:{ description:"",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404,
                    description:"Organization not found" } } } } },
          security:[ { bearer:[  ] } ],
          summary:"List all the integrations for an organization",
          tags:[ "Integrations" ] },
        post:{ operationId:"IntegrationsController_create",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          requestBody:{ required:true,
            content:{ "application/json":{ schema:{ type:"object",
                  properties:{ type:{ description:"The type of the integration",
                      type:"string",
                      "enum":[ "shopify",
                        "web_stream_pixel",
                        "conversion_api" ],
                      "x-enumNames":[ "Shopify",
                        "WebStreamPixel",
                        "ConversionApi" ] },
                    name:{ description:"The name of the integration",
                      type:"string",
                      minLength:1 },
                    advertiser_id:{ description:"The ID of the advertiser the integration refers to",
                      type:"string",
                      format:"uuid" } },
                  required:[ "type",
                    "name",
                    "advertiser_id" ] } } } },
          responses:{ 201:{ description:"",
              content:{ "application/json":{ schema:{ type:"object",
                    properties:{} } } } },
            400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:[ { code:"invalid_type",
                        expected:"string",
                        received:"undefined",
                        path:[ "advertiser_id" ],
                        message:"Required" } ],
                    statusCode:400 } } } },
            403:{ description:"Forbidden - Admin access required",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404,
                    description:"Organization not found" } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Create a new integration",
          tags:[ "Integrations" ] } },
      "/organizations/{organization_id}/integrations/{integration_id}":{ get:{ operationId:"IntegrationsController_getApiKey",
          parameters:[ { name:"integration_id",
              required:true,
              "in":"path",
              description:"ID of the integration",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:"Integration has incorrect type",
                    statusCode:400 } } } },
            404:{ description:"",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404,
                    description:"Integration not found" } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Get the API key of an integration",
          tags:[ "Integrations" ] } },
      "/organizations/{organization_id}/events/stats":{ post:{ operationId:"EventsController_getStats",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"The organization ID",
              schema:{ format:"uuid",
                type:"string" } } ],
          requestBody:{ required:true,
            content:{ "application/json":{ schema:{ type:"object",
                  properties:{ query:{ type:"array",
                      items:{ type:"object",
                        properties:{ advertiser_id:{ description:"The ID of the advertiser the event refers to",
                            type:"string" },
                          event_name:{ description:"The name of the event",
                            type:"string" },
                          event_source:{ description:"The source of the event",
                            type:"string",
                            "enum":[ "shopify",
                              "web_stream_pixel",
                              "conversion_api" ],
                            "x-enumNames":[ "Shopify",
                              "WebStreamPixel",
                              "ConversionApi" ] } },
                        required:[ "advertiser_id",
                          "event_name",
                          "event_source" ] } } },
                  required:[ "query" ] } } } },
          responses:{ 201:{ description:"" } },
          security:[ { bearer:[  ] } ],
          summary:"Get statistics related to an event",
          tags:[ "Organizations" ] } },
      "/organizations/{organization_id}/audience-retargets":{ get:{ description:"Retrieve a paginated list of audience retargets for the specified organization",
          operationId:"AudienceRetargetsController_findAll",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"Organization ID",
              schema:{ format:"uuid",
                example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 200:{ description:"Successfully received model list",
              content:{ "application/json":{ schema:{ allOf:[ { type:"object",
                        properties:{ data:{ type:"array",
                            items:{ type:"object",
                              properties:{ event_name:{ type:"string",
                                  "enum":[ "AddPaymentInfo",
                                    "AddToCart",
                                    "AddToWishlist",
                                    "CompleteRegistration",
                                    "Contact",
                                    "CustomEvent",
                                    "CustomizeProduct",
                                    "ConfiguratorCompletion",
                                    "Donate",
                                    "DonateRecurring",
                                    "FindLocation",
                                    "InitiateCheckout",
                                    "Lead",
                                    "Purchase",
                                    "Schedule",
                                    "Search",
                                    "StartTrial",
                                    "SubmitApplication",
                                    "Subscribe",
                                    "ViewContent",
                                    "CoverageCheck",
                                    "CallMeBack",
                                    "ClickToCall",
                                    "DownloadBrochure",
                                    "TestDriveRequest",
                                    "DealerLookup" ] },
                                lookback_window:{ type:"number",
                                  minimum:1,
                                  maximum:30 },
                                type:{ type:"string",
                                  "enum":[ "EXACT",
                                    "LOOKALIKE" ] } },
                              required:[ "event_name",
                                "lookback_window",
                                "type" ] } },
                          meta:{ type:"object",
                            properties:{ count:{ type:"number" },
                              lastPage:{ type:"number" },
                              currentPage:{ type:"number" },
                              totalPerPage:{ type:"number" },
                              prevPage:{ type:"number",
                                nullable:true,
                                example:1 },
                              nextPage:{ type:"number",
                                nullable:true,
                                example:null } },
                            required:[ "count",
                              "lastPage",
                              "currentPage",
                              "totalPerPage",
                              "prevPage",
                              "nextPage" ] } } },
                      { properties:{ data:{ type:"array",
                            items:{ type:"object",
                              properties:{ event_name:{ type:"string",
                                  "enum":[ "AddPaymentInfo",
                                    "AddToCart",
                                    "AddToWishlist",
                                    "CompleteRegistration",
                                    "Contact",
                                    "CustomEvent",
                                    "CustomizeProduct",
                                    "ConfiguratorCompletion",
                                    "Donate",
                                    "DonateRecurring",
                                    "FindLocation",
                                    "InitiateCheckout",
                                    "Lead",
                                    "Purchase",
                                    "Schedule",
                                    "Search",
                                    "StartTrial",
                                    "SubmitApplication",
                                    "Subscribe",
                                    "ViewContent",
                                    "CoverageCheck",
                                    "CallMeBack",
                                    "ClickToCall",
                                    "DownloadBrochure",
                                    "TestDriveRequest",
                                    "DealerLookup" ] },
                                lookback_window:{ type:"number",
                                  minimum:1,
                                  maximum:30 },
                                type:{ type:"string",
                                  "enum":[ "EXACT",
                                    "LOOKALIKE" ] } },
                              required:[ "event_name",
                                "lookback_window",
                                "type" ] } } } } ] } } } },
            404:{ description:"Organization not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Get all audience retargets",
          tags:[ "Audience retargets" ] },
        post:{ description:"Create a new audience retarget for the specified organization",
          operationId:"AudienceRetargetsController_create",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"Organization ID",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          requestBody:{ required:true,
            content:{ "application/json":{ schema:{ type:"object",
                  properties:{ name:{ type:"string",
                      minLength:1 },
                    advertiser_id:{ type:"string",
                      format:"uuid" },
                    event_name:{ type:"string",
                      "enum":[ "AddPaymentInfo",
                        "AddToCart",
                        "AddToWishlist",
                        "CompleteRegistration",
                        "Contact",
                        "CustomEvent",
                        "CustomizeProduct",
                        "ConfiguratorCompletion",
                        "Donate",
                        "DonateRecurring",
                        "FindLocation",
                        "InitiateCheckout",
                        "Lead",
                        "Purchase",
                        "Schedule",
                        "Search",
                        "StartTrial",
                        "SubmitApplication",
                        "Subscribe",
                        "ViewContent",
                        "CoverageCheck",
                        "CallMeBack",
                        "ClickToCall",
                        "DownloadBrochure",
                        "TestDriveRequest",
                        "DealerLookup" ],
                      "x-enumNames":[ "AddPaymentInfo",
                        "AddToCart",
                        "AddToWishlist",
                        "CompleteRegistration",
                        "Contact",
                        "CustomEvent",
                        "CustomizeProduct",
                        "ConfiguratorCompletion",
                        "Donate",
                        "DonateRecurring",
                        "FindLocation",
                        "InitiateCheckout",
                        "Lead",
                        "Purchase",
                        "Schedule",
                        "Search",
                        "StartTrial",
                        "SubmitApplication",
                        "Subscribe",
                        "ViewContent",
                        "CoverageCheck",
                        "CallMeBack",
                        "ClickToCall",
                        "DownloadBrochure",
                        "TestDriveRequest",
                        "DealerLookup" ] },
                    type:{ type:"string",
                      "enum":[ "EXACT",
                        "LOOKALIKE" ],
                      "x-enumNames":[ "EXACT",
                        "LOOKALIKE" ] },
                    lookback_window:{ type:"integer",
                      minimum:1,
                      exclusiveMinimum:false,
                      maximum:30,
                      exclusiveMaximum:false } },
                  required:[ "name",
                    "advertiser_id",
                    "event_name",
                    "type",
                    "lookback_window" ] } } } },
          responses:{ 201:{ description:"",
              content:{ "application/json":{ schema:{ type:"object",
                    properties:{ event_name:{ type:"string",
                        "enum":[ "AddPaymentInfo",
                          "AddToCart",
                          "AddToWishlist",
                          "CompleteRegistration",
                          "Contact",
                          "CustomEvent",
                          "CustomizeProduct",
                          "ConfiguratorCompletion",
                          "Donate",
                          "DonateRecurring",
                          "FindLocation",
                          "InitiateCheckout",
                          "Lead",
                          "Purchase",
                          "Schedule",
                          "Search",
                          "StartTrial",
                          "SubmitApplication",
                          "Subscribe",
                          "ViewContent",
                          "CoverageCheck",
                          "CallMeBack",
                          "ClickToCall",
                          "DownloadBrochure",
                          "TestDriveRequest",
                          "DealerLookup" ] },
                      lookback_window:{ type:"number",
                        minimum:1,
                        maximum:30 },
                      type:{ type:"string",
                        "enum":[ "EXACT",
                          "LOOKALIKE" ] } },
                    required:[ "event_name",
                      "lookback_window",
                      "type" ] } } } },
            400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:[ { code:"invalid_type",
                        expected:"string",
                        received:"undefined",
                        path:[ "advertiser_id" ],
                        message:"Required" } ],
                    statusCode:400 } } } },
            403:{ description:"Forbidden - Write access needed",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"Advertiser not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Create an audience retarget",
          tags:[ "Audience retargets" ] } },
      "/organizations/{organization_id}/audience-retargets/{id}":{ "delete":{ description:"Delete an existing audience retarget by ID",
          operationId:"AudienceRetargetsController_delete",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"Organization ID",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"id",
              required:true,
              "in":"path",
              description:"Audience retarget ID to delete",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174002",
                type:"string" } } ],
          responses:{ 403:{ description:"Forbidden - Write access needed",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Delete an audience retarget",
          tags:[ "Audience retargets" ] } },
      "/organizations/{organization_id}/line-items/{line_item_id}/audience-retargets":{ get:{ operationId:"LineItemOnAudienceRetargetController_getAll",
          parameters:[ { name:"line_item_id",
              required:true,
              "in":"path",
              description:"ID of the line item",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 200:{ description:"Successfully received model list",
              content:{ "application/json":{ schema:{ allOf:[ { type:"object",
                        properties:{ data:{ type:"array",
                            items:{ type:"object",
                              properties:{} } },
                          meta:{ type:"object",
                            properties:{ count:{ type:"number" },
                              lastPage:{ type:"number" },
                              currentPage:{ type:"number" },
                              totalPerPage:{ type:"number" },
                              prevPage:{ type:"number",
                                nullable:true,
                                example:1 },
                              nextPage:{ type:"number",
                                nullable:true,
                                example:null } },
                            required:[ "count",
                              "lastPage",
                              "currentPage",
                              "totalPerPage",
                              "prevPage",
                              "nextPage" ] } } },
                      { properties:{ data:{ type:"array",
                            items:{ type:"object",
                              properties:{} } } } } ] } } } },
            404:{ description:"Line item not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          summary:"List all the audience retarget associations of a line item",
          tags:[ "Line Items" ] },
        put:{ operationId:"LineItemOnAudienceRetargetController_createUpdate",
          parameters:[ { name:"line_item_id",
              required:true,
              "in":"path",
              description:"ID of the line item",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          requestBody:{ required:true,
            content:{ "application/json":{ schema:{ type:"array",
                  items:{ type:"object",
                    properties:{ active:{ description:"Whether the association should be active",
                        type:"boolean" },
                      audience_retarget_id:{ description:"The ID of the audience retarget",
                        type:"string",
                        format:"uuid" } },
                    required:[ "active",
                      "audience_retarget_id" ] } } } } },
          responses:{ 400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:[ { code:"invalid_type",
                        expected:"boolean",
                        received:"undefined",
                        path:[ "active" ],
                        message:"Required" } ],
                    statusCode:400 } } } },
            403:{ description:"Forbidden - Write access required",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"Line Item not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          summary:"Create a new association between a line item and one or more audience retargets",
          tags:[ "Line Items" ] } },
      "/users/{id}":{ patch:{ operationId:"UsersController_update",
          parameters:[ { name:"id",
              required:true,
              "in":"path",
              description:"ID of the user",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          requestBody:{ required:true,
            description:"Update user data",
            content:{ "application/json":{ schema:{ type:"object",
                  properties:{ first_name:{ type:"string" },
                    last_name:{ type:"string" } } } } } },
          responses:{ 200:{ description:"",
              content:{ "application/json":{ schema:{ type:"object",
                    properties:{ id:{ type:"string",
                        example:"uuid" },
                      sub:{ type:"string",
                        example:"sub" },
                      email:{ type:"string",
                        example:"email@example.com" },
                      email_verified:{ type:"object",
                        example:false },
                      first_name:{ type:"object",
                        example:"John" },
                      last_name:{ type:"object",
                        example:"Doe" } },
                    required:[ "id",
                      "sub",
                      "email",
                      "email_verified",
                      "first_name" ] } } } },
            400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:[ { code:"invalid_type",
                        expected:"string",
                        received:"number",
                        path:[ "first_name" ],
                        message:"Required" } ],
                    statusCode:400 } } } },
            403:{ description:"Forbidden - Ownership of user needed",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Update user profile",
          tags:[ "Users" ] } },
      "/users/{id}/profile-picture":{ put:{ operationId:"UsersController_uploadProfilePicture",
          parameters:[ { name:"id",
              required:true,
              "in":"path",
              description:"ID of the user",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          requestBody:{ required:true,
            description:"Profile picture file",
            content:{ "multipart/form-data":{ schema:{ type:"object",
                  properties:{ file:{ type:"string",
                      format:"binary",
                      description:"Profile picture image file" } } } } } },
          responses:{ 200:{ description:"",
              content:{ "application/json":{ schema:{ type:"object",
                    properties:{ id:{ type:"string",
                        example:"uuid" },
                      sub:{ type:"string",
                        example:"sub" },
                      email:{ type:"string",
                        example:"email@example.com" },
                      email_verified:{ type:"object",
                        example:false },
                      first_name:{ type:"object",
                        example:"John" },
                      last_name:{ type:"object",
                        example:"Doe" } },
                    required:[ "id",
                      "sub",
                      "email",
                      "email_verified",
                      "first_name" ] } } } },
            400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:"File type not supported",
                    statusCode:400 } } } },
            403:{ description:"Forbidden - Ownership of user needed",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Upload user profile picture",
          tags:[ "Users" ] } },
      "/organizations/{organization_id}/advertisers/{advertiser_id}/reporting/dashboard":{ get:{ operationId:"ReportingController_getDashboard",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"advertiser_id",
              required:true,
              "in":"path",
              schema:{ type:"string" } },
            { name:"campaign_id",
              required:false,
              "in":"query",
              description:"Campaign ID",
              schema:{ type:"string" } },
            { name:"line_item_id",
              required:false,
              "in":"query",
              description:"Line Item ID",
              schema:{ type:"string" } },
            { name:"creative_id",
              required:false,
              "in":"query",
              description:"Creative ID",
              schema:{ type:"string" } },
            { name:"group_by_fields",
              required:true,
              "in":"query",
              description:"Fields to group by",
              schema:{ type:"array",
                items:{ type:"string" } } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the advertiser",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 200:{ description:"",
              content:{ "application/json":{ schema:{ type:"array",
                    items:{ type:"object",
                      properties:{ advertiser_id:{ type:"string",
                          format:"uuid" },
                        spend:{ type:"number" },
                        impressions:{ type:"number" },
                        reach_person:{ type:"number" },
                        reach_household:{ type:"number" },
                        conversions:{ type:"number" },
                        conversion_rate:{ type:"number" },
                        conversions_value:{ type:"number" },
                        cpa:{ type:"number" },
                        roas:{ type:"number" },
                        group_fields:{ type:"object",
                          additionalProperties:{ type:"string" } } },
                      required:[ "advertiser_id",
                        "spend",
                        "impressions",
                        "reach_person",
                        "reach_household",
                        "conversions",
                        "conversion_rate",
                        "conversions_value",
                        "cpa",
                        "roas",
                        "group_fields" ] } } } } },
            404:{ description:"Advertiser not found",
              content:{ "application/json":{ example:{ message:"Not found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Get dashboard data for reporting purposes for an advertiser",
          tags:[ "Reporting" ] } },
      "/organizations/{organization_id}/advertisers/{advertiser_id}/household-reporting/impressions":{ get:{ description:"Retrieves household-level aggregated impressions reporting for a given advertiser and time range. Output is returned as CSV.",
          operationId:"ReportingController_getHouseholdReporting",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"advertiser_id",
              required:true,
              "in":"path",
              schema:{ type:"string" } },
            { name:"start_datetime",
              required:true,
              "in":"query",
              description:"Start timestamp (ISO datetime)",
              schema:{ example:"2025-01-01T00:00:00.000Z",
                type:"string" } },
            { name:"end_datetime",
              required:true,
              "in":"query",
              description:"End timestamp (ISO datetime)",
              schema:{ example:"2025-01-31T23:59:59.999Z",
                type:"string" } },
            { name:"dimension",
              required:true,
              "in":"query",
              description:"Dimension to group by (currently only address is supported)",
              schema:{ type:"string",
                "enum":[ "address" ] } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the advertiser",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 200:{ description:"CSV stream of household-level impressions aggregation",
              content:{ "text/csv":{ schema:{ type:"string",
                    example:"aidem_household_id_hash,address_primary,address_secondary,house_number,pre_direction,street_name,street_suffix,post_direction,unit_designator,unit_designator_number,zip_code,zip_code_extension,city_name,state\nabc123hash,123 Main St,,123,,Main,St,,Apt,4B,62704,,Springfield,IL\ndef456hash,456 Oak Ave,,456,,Oak,Ave,,Unit,12,73301,,Austin,TX\n" } } } },
            400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:[ { code:"invalid_type",
                        expected:"string",
                        received:"undefined",
                        path:[ "dimension" ],
                        message:"Required" } ],
                    error:"Bad Request",
                    statusCode:400 } } } },
            401:{ description:"Invalid login request",
              content:{ "application/json":{ example:{ message:"Bearer token not provided",
                    error:"Unauthorized",
                    statusCode:401 } } } },
            403:{ description:"Forbidden - Read access required",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"",
              content:{ "application/json":{ example:{ message:"Resource not found",
                    error:"Not Found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Get household-level impressions reporting data",
          tags:[ "Reporting" ] } },
      "/organizations/{organization_id}/advertisers/{advertiser_id}/person-reporting/impressions":{ get:{ description:"Retrieves person-level aggregated impressions reporting for a given advertiser and time range. Output is returned as CSV.",
          operationId:"ReportingController_getPersonReporting",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"advertiser_id",
              required:true,
              "in":"path",
              schema:{ type:"string" } },
            { name:"start_datetime",
              required:true,
              "in":"query",
              description:"Start timestamp (ISO datetime)",
              schema:{ example:"2025-01-01T00:00:00.000Z",
                type:"string" } },
            { name:"end_datetime",
              required:true,
              "in":"query",
              description:"End timestamp (ISO datetime)",
              schema:{ example:"2025-01-31T23:59:59.999Z",
                type:"string" } },
            { name:"dimension",
              required:true,
              "in":"query",
              description:"Dimension to group by (currently only linkedin_url is supported)",
              schema:{ type:"string",
                "enum":[ "linkedin_url" ] } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the advertiser",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 200:{ description:"CSV stream of person-level impressions aggregation",
              content:{ "text/csv":{ schema:{ type:"string",
                    example:"aidem_person_id_hash,linkedin_url\na1b2c3hash,https://www.linkedin.com/in/janedoe\nz9y8x7hash,https://www.linkedin.com/in/johnsmith\n" } } } },
            400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:[ { code:"invalid_type",
                        expected:"string",
                        received:"undefined",
                        path:[ "dimension" ],
                        message:"Required" } ],
                    error:"Bad Request",
                    statusCode:400 } } } },
            401:{ description:"Invalid login request",
              content:{ "application/json":{ example:{ message:"Bearer token not provided",
                    error:"Unauthorized",
                    statusCode:401 } } } },
            403:{ description:"Forbidden - Read access required",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"",
              content:{ "application/json":{ example:{ message:"Resource not found",
                    error:"Not Found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Get person-level impressions reporting data",
          tags:[ "Reporting" ] } },
      "/organizations/{organization_id}/advertisers/{advertiser_id}/reporting/impressions":{ get:{ description:"Retrieves aggregated reporting data from the impressions table within a specified time range",
          operationId:"ReportingController_getReportingImpressions",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"advertiser_id",
              required:true,
              "in":"path",
              schema:{ type:"string" } },
            { name:"start_datetime",
              required:true,
              "in":"query",
              description:"Start timestamp (ISO datetime)",
              schema:{ example:"2025-01-01T00:00:00.000Z",
                type:"string" } },
            { name:"end_datetime",
              required:true,
              "in":"query",
              description:"End timestamp (ISO datetime)",
              schema:{ example:"2025-01-31T23:59:59.999Z",
                type:"string" } },
            { name:"campaign_id",
              required:true,
              "in":"query",
              description:"Filter by specific campaign",
              schema:{ type:"string" } },
            { name:"line_item_id",
              required:true,
              "in":"query",
              description:"Filter by specific line item",
              schema:{ type:"string" } },
            { name:"creative_id",
              required:true,
              "in":"query",
              description:"Filter by specific creative",
              schema:{ type:"string" } },
            { name:"dimensions",
              required:true,
              "in":"query",
              description:"Comma-separated list of dimensions to group by (minimum 1)",
              schema:{ type:"string",
                "enum":[ "date",
                  "hour",
                  "account_id",
                  "account_name",
                  "advertiser_id",
                  "advertiser_name",
                  "campaign_id",
                  "campaign_name",
                  "line_item_id",
                  "line_item_name",
                  "creative_id",
                  "creative_name",
                  "app_bundle",
                  "app_id",
                  "app_name",
                  "domain",
                  "page_url_full",
                  "site_id",
                  "site_name",
                  "site_referrer",
                  "content_cat",
                  "content_channel_name",
                  "content_episode",
                  "content_genre",
                  "content_id",
                  "content_language",
                  "content_length",
                  "content_livestream",
                  "content_network_id",
                  "content_network_name",
                  "content_rating",
                  "content_season",
                  "content_series",
                  "content_title",
                  "connection_type",
                  "device_browser",
                  "device_browser_version",
                  "device_carrier",
                  "device_hardware_version",
                  "device_make",
                  "device_model",
                  "device_os",
                  "device_os_version",
                  "device_type",
                  "country_name",
                  "metro_name",
                  "city_name",
                  "state_name",
                  "zip_code",
                  "geolocation_source",
                  "placement",
                  "placement_type",
                  "environment_type",
                  "inventory_source",
                  "publisher_id",
                  "publisher_name",
                  "seller_id",
                  "deal_id",
                  "rewarded",
                  "video_placement",
                  "video_playback_method",
                  "video_player_size",
                  "gender",
                  "age",
                  "marital_status",
                  "ethnicity",
                  "education",
                  "income",
                  "net_worth",
                  "religion",
                  "language",
                  "credit_score",
                  "mccmnc",
                  "presence_of_cc",
                  "presence_of_gold_plat_cc",
                  "presence_of_premium_cc",
                  "presence_of_upscale_retail_cc",
                  "presence_of_bankcard",
                  "gas_dept_retail_cc",
                  "american_express_cc",
                  "american_express_gold_plat",
                  "discover_gold_premium",
                  "discover_regular",
                  "gas_retail_cc_gold_premium",
                  "mastercard_gold_premium",
                  "mastercard_regular",
                  "visa_gold_premium",
                  "visa_regular",
                  "travel_entertainment_cc",
                  "district_congressional",
                  "district_state_senate",
                  "district_state_house",
                  "district_legislative",
                  "political_contributor",
                  "registered_to_vote",
                  "department",
                  "seniority_level",
                  "company_name",
                  "company_domain",
                  "company_sic",
                  "company_naics",
                  "company_revenue",
                  "company_employee_count",
                  "company_primary_industry",
                  "number_of_persons_in_hh",
                  "number_of_adults_in_hh",
                  "number_of_children_in_hh",
                  "veteran_in_hh",
                  "children_in_hh_age_00_02",
                  "children_in_hh_age_03_05",
                  "children_in_hh_age_06_10",
                  "children_in_hh_age_11_15",
                  "children_in_hh_age_16_17",
                  "males_in_hh_18_24",
                  "females_in_hh_18_24",
                  "males_in_hh_25_34",
                  "females_in_hh_25_34",
                  "males_in_hh_35_44",
                  "females_in_hh_35_44",
                  "males_in_hh_45_54",
                  "females_in_hh_45_54",
                  "males_in_hh_55_64",
                  "females_in_hh_55_64",
                  "males_in_hh_65_74",
                  "females_in_hh_65_74",
                  "males_in_hh_75_plus",
                  "females_in_hh_75_plus",
                  "dwelling_type",
                  "home_ownership",
                  "length_of_residence",
                  "property_home_square_footage",
                  "property_land_square_footage",
                  "parking_space",
                  "home_swimming_pool",
                  "home_air_conditioning",
                  "home_heating_system",
                  "home_purchase_price",
                  "home_purchase_year",
                  "home_year_built",
                  "home_current_value",
                  "home_mortgage_amount",
                  "home_mortgage_rate",
                  "home_mortgage_type",
                  "home_mortgage_lender_name_standardized",
                  "apparel_children",
                  "apparel_infant_toddlers",
                  "apparel_men_big_tall",
                  "apparel_men",
                  "apparel_petite",
                  "apparel_women",
                  "apparel_women_plus_size",
                  "apparel_young_men",
                  "apparel_young_women",
                  "high_end_appliances",
                  "music_home_stereo",
                  "arts_and_antiques",
                  "arts_art",
                  "arts_int",
                  "theater_performing_arts",
                  "auto_work",
                  "automotive_buff",
                  "autoparts_accessories",
                  "aviation_int",
                  "books_magazines",
                  "book_buyer",
                  "book_reader",
                  "books_music_books",
                  "books_music_audio",
                  "reading_general",
                  "reading_mags",
                  "reading_audio_books",
                  "reading_sci_fi",
                  "pets_cats",
                  "pets_dogs",
                  "pets_multi",
                  "children_babycare",
                  "children_learning_toys",
                  "children_back_to_school",
                  "membership_club",
                  "gunowner",
                  "collectibles_antiques",
                  "collectibles_arts",
                  "collector_avid",
                  "collectibles_coins",
                  "collectibles_general",
                  "military_memorabilia_weapons",
                  "collectibles_sports_memorabilia",
                  "collectibles_stamps",
                  "computer_owner",
                  "consumer_electronics",
                  "computer_home_office",
                  "electronics_computers",
                  "electronics_movies_int",
                  "cooking_enthusiast",
                  "cooking_general",
                  "foods_natural",
                  "food_wines",
                  "cosmetics_beauty",
                  "crafts_hobbies_buyer",
                  "craft_int",
                  "do_it_yourselfers_typical_choice",
                  "dvd_videos",
                  "education_online",
                  "exercise_enthusiast",
                  "exercise_aerobic",
                  "exercise_running_jogging",
                  "exercise_walking",
                  "female_merch_buyer",
                  "news_financial",
                  "gaming_int",
                  "games_board_puzzles",
                  "games_pc_games",
                  "games_video",
                  "gaming_casino",
                  "gardening",
                  "gardening_farming_buyer",
                  "golf_enthusiast",
                  "collect_special_foods_buyer",
                  "health_and_beauty",
                  "dieting_weightloss",
                  "health_medical",
                  "self_improvement",
                  "career_improvement",
                  "equestrian_int",
                  "house_plants",
                  "investments_foreign",
                  "investments_realestate",
                  "invest_stock_securities",
                  "investments",
                  "invest_active",
                  "jewelry_buyer",
                  "common_living",
                  "cultural_arts_living",
                  "sporty_living",
                  "lifestyle_passion_collectibles",
                  "movie_collector",
                  "home_and_garden",
                  "photography_video_equip",
                  "photography_int",
                  "home_furnishings_decor",
                  "home_improvement",
                  "sports_leisure",
                  "luggage_buyer",
                  "history_military",
                  "music_avid_listener",
                  "music_collector",
                  "musical_instruments",
                  "music_player_device",
                  "current_affairs_politics",
                  "religious_inspiration",
                  "religious_mags",
                  "religious_contributor",
                  "science_space",
                  "sewing_knitting_needlework",
                  "smoking",
                  "sports_auto_motorcycle_racing",
                  "sports_baseball",
                  "sports_basketball",
                  "sports_football",
                  "sports_hockey",
                  "sports_soccer",
                  "boating_sailing",
                  "camping_hiking",
                  "fisher",
                  "hunter",
                  "active_motorcycle",
                  "active_nascar",
                  "active_snow_skiing",
                  "active_tennis",
                  "scuba_diving",
                  "hunting_shooting",
                  "sweepstakes_int",
                  "travel_cruises",
                  "travel_domestic",
                  "travel_intl",
                  "donor_animal_welfare",
                  "donor_arts_cultural",
                  "donor_charitable_causes",
                  "donor_children_causes",
                  "donor_environmental",
                  "donor_health_institution",
                  "donor_international_aid",
                  "donor_veterans",
                  "auto_year_1",
                  "auto_make_1",
                  "auto_model_1",
                  "auto_series_1",
                  "auto_bodyclass_1",
                  "auto_vehicle_type_1",
                  "auto_estimated_purchase_date_1",
                  "auto_fuel_type_1",
                  "auto_year_2",
                  "auto_make_2",
                  "auto_model_2",
                  "auto_series_2",
                  "auto_bodyclass_2",
                  "auto_vehicle_type_2",
                  "auto_estimated_purchase_date_2",
                  "auto_fuel_type_2",
                  "auto_year_3",
                  "auto_make_3",
                  "auto_model_3",
                  "auto_series_3",
                  "auto_bodyclass_3",
                  "auto_vehicle_type_3",
                  "auto_estimated_purchase_date_3",
                  "auto_fuel_type_3" ] } },
            { name:"metrics",
              required:true,
              "in":"query",
              description:"Comma-separated list of metrics to aggregate (minimum 1)",
              schema:{ type:"string",
                "enum":[ "bid_price",
                  "impression_cost_usd",
                  "media_spend_usd",
                  "third_party_vendor_cost_usd",
                  "third_party_vendor_cpm_fee_value",
                  "third_party_vendor_percentage_fee_value",
                  "vendor_fee_usd",
                  "impressions",
                  "reach_person",
                  "reach_household",
                  "reach_person_target_universe",
                  "reach_household_target_universe",
                  "reach_person_penetration_rate",
                  "reach_household_penetration_rate",
                  "reach_person_frequency",
                  "reach_household_frequency",
                  "conversion_rate",
                  "cpa",
                  "roas",
                  "cpm",
                  "click",
                  "video_start",
                  "video_q1",
                  "video_midpoint",
                  "video_q3",
                  "video_complete",
                  "video_close",
                  "video_fullscreen",
                  "video_mutes",
                  "video_pauses",
                  "video_resumes",
                  "video_skip",
                  "video_unmutes",
                  "add_payment_info_count",
                  "add_payment_info_value",
                  "add_to_cart_count",
                  "add_to_cart_value",
                  "add_to_wishlist_count",
                  "add_to_wishlist_value",
                  "call_me_back_count",
                  "call_me_back_value",
                  "click_to_call_count",
                  "click_to_call_value",
                  "complete_registration_count",
                  "complete_registration_value",
                  "configurator_completion_count",
                  "configurator_completion_value",
                  "contact_count",
                  "contact_value",
                  "coverage_check_count",
                  "coverage_check_value",
                  "custom_event_count",
                  "custom_event_value",
                  "customize_product_count",
                  "customize_product_value",
                  "dealer_lookup_count",
                  "dealer_lookup_value",
                  "donate_count",
                  "donate_value",
                  "donate_recurring_count",
                  "donate_recurring_value",
                  "download_brochure_count",
                  "download_brochure_value",
                  "find_location_count",
                  "find_location_value",
                  "initiate_checkout_count",
                  "initiate_checkout_value",
                  "lead_count",
                  "lead_value",
                  "page_view_count",
                  "page_view_value",
                  "purchase_count",
                  "purchase_value",
                  "schedule_count",
                  "schedule_value",
                  "search_count",
                  "search_value",
                  "start_trial_count",
                  "start_trial_value",
                  "submit_application_count",
                  "submit_application_value",
                  "subscribe_count",
                  "subscribe_value",
                  "testdrive_request_count",
                  "testdrive_request_value",
                  "view_content_count",
                  "view_content_value" ] } },
            { name:"format",
              required:true,
              "in":"query",
              description:"Output format: json (default) or csv",
              schema:{ type:"string",
                "enum":[ "json",
                  "csv" ] } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the advertiser",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 200:{ description:"Reporting data returned successfully",
              content:{ "application/json":{ schema:{ example:{ status:"success",
                      metadata:{ table:"impressions",
                        start_ts:"2025-08-26T00:00:00Z",
                        end_ts:"2025-09-02T00:00:00Z",
                        advertiser_id:"f60b7dba-ac89-4d21-bdbc-98770b5faf1e",
                        campaign_id:null,
                        lineitem_id:null,
                        creative_id:null,
                        dimensions:[ "age",
                          "gender" ],
                        metrics:[ "cpm",
                          "click" ],
                        row_count:2,
                        generated_at:"2025-09-17T09:42:06.820332+00:00" },
                      data:[ { age:"55-64",
                          click:0,
                          gender:"F",
                          cpm:null },
                        { age:"25-34",
                          click:0,
                          gender:"M",
                          cpm:null } ] } } },
                "text/csv":{ schema:{ type:"string",
                    example:"age,gender,cpm,click\n55-64,F,,0\n25-34,M,,0\n" } } } },
            400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:[ { code:"invalid_type",
                        expected:"array",
                        received:"undefined",
                        path:[ "metrics" ],
                        message:"Required" } ],
                    error:"Bad Request",
                    statusCode:400 } } } },
            401:{ description:"Invalid login request",
              content:{ "application/json":{ example:{ message:"Bearer token not provided",
                    error:"Unauthorized",
                    statusCode:401 } } } },
            403:{ description:"Forbidden - Read access required",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"",
              content:{ "application/json":{ example:{ message:"Resource not found",
                    error:"Not Found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Get aggregated impressions reporting data",
          tags:[ "Reporting" ] } },
      "/organizations/{organization_id}/advertisers/{advertiser_id}/reporting/events":{ get:{ description:"Retrieves aggregated reporting data from the events table within a specified time range",
          operationId:"ReportingController_getReportingEvents",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"advertiser_id",
              required:true,
              "in":"path",
              schema:{ type:"string" } },
            { name:"start_datetime",
              required:true,
              "in":"query",
              description:"Start timestamp (ISO datetime)",
              schema:{ example:"2025-01-01T00:00:00.000Z",
                type:"string" } },
            { name:"end_datetime",
              required:true,
              "in":"query",
              description:"End timestamp (ISO datetime)",
              schema:{ example:"2025-01-31T23:59:59.999Z",
                type:"string" } },
            { name:"campaign_id",
              required:true,
              "in":"query",
              description:"Filter by specific campaign",
              schema:{ type:"string" } },
            { name:"line_item_id",
              required:true,
              "in":"query",
              description:"Filter by specific line item",
              schema:{ type:"string" } },
            { name:"creative_id",
              required:true,
              "in":"query",
              description:"Filter by specific creative",
              schema:{ type:"string" } },
            { name:"dimensions",
              required:true,
              "in":"query",
              description:"Comma-separated list of dimensions to group by (minimum 1)",
              schema:{ type:"string",
                "enum":[ "date",
                  "hour",
                  "event_type",
                  "event_source",
                  "advertiser_id",
                  "custom_parameter_1",
                  "custom_parameter_2",
                  "custom_parameter_3",
                  "custom_parameter_4",
                  "custom_parameter_5" ] } },
            { name:"metrics",
              required:true,
              "in":"query",
              description:"Comma-separated list of metrics to aggregate (minimum 1)",
              schema:{ type:"string",
                "enum":[ "events",
                  "event_value",
                  "avg_event_value",
                  "event_units",
                  "avg_event_units" ] } },
            { name:"format",
              required:true,
              "in":"query",
              description:"Output format: json (default) or csv",
              schema:{ type:"string",
                "enum":[ "json",
                  "csv" ] } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the advertiser",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 200:{ description:"Reporting data returned successfully",
              content:{ "application/json":{ schema:{ example:{ status:"success",
                      metadata:{ table:"events",
                        start_ts:"2025-08-26T00:00:00Z",
                        end_ts:"2025-09-02T00:00:00Z",
                        advertiser_id:"f60b7dba-ac89-4d21-bdbc-98770b5faf1e",
                        campaign_id:null,
                        lineitem_id:null,
                        creative_id:null,
                        dimensions:[ "date",
                          "event_type" ],
                        metrics:[ "events",
                          "event_value" ],
                        row_count:3,
                        generated_at:"2025-01-15T10:30:00Z" },
                      data:[ { date:"2025-01-14",
                          event_type:"add_to_cart",
                          events:125,
                          event_value:5500.25 } ] } } },
                "text/csv":{ schema:{ type:"string",
                    example:"date,event_type,events,event_value\n2025-01-14,add_to_cart,125,5500.25\n" } } } },
            400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:[ { code:"invalid_type",
                        expected:"array",
                        received:"undefined",
                        path:[ "metrics" ],
                        message:"Required" } ],
                    error:"Bad Request",
                    statusCode:400 } } } },
            401:{ description:"Invalid login request",
              content:{ "application/json":{ example:{ message:"Bearer token not provided",
                    error:"Unauthorized",
                    statusCode:401 } } } },
            403:{ description:"Forbidden - Read access required",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"",
              content:{ "application/json":{ example:{ message:"Resource not found",
                    error:"Not Found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Get aggregated events reporting data",
          tags:[ "Reporting" ] } },
      "/organizations/{organization_id}/advertisers/{advertiser_id}/reporting/conversions":{ get:{ description:"Retrieves aggregated reporting data from the conversions table within a specified time range",
          operationId:"ReportingController_getReportingConversions",
          parameters:[ { name:"organization_id",
              required:true,
              "in":"path",
              description:"ID of the organization",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } },
            { name:"advertiser_id",
              required:true,
              "in":"path",
              schema:{ type:"string" } },
            { name:"start_datetime",
              required:true,
              "in":"query",
              description:"Start timestamp (ISO datetime)",
              schema:{ example:"2025-01-01T00:00:00.000Z",
                type:"string" } },
            { name:"end_datetime",
              required:true,
              "in":"query",
              description:"End timestamp (ISO datetime)",
              schema:{ example:"2025-01-31T23:59:59.999Z",
                type:"string" } },
            { name:"campaign_id",
              required:true,
              "in":"query",
              description:"Filter by specific campaign",
              schema:{ type:"string" } },
            { name:"line_item_id",
              required:true,
              "in":"query",
              description:"Filter by specific line item",
              schema:{ type:"string" } },
            { name:"creative_id",
              required:true,
              "in":"query",
              description:"Filter by specific creative",
              schema:{ type:"string" } },
            { name:"dimensions",
              required:true,
              "in":"query",
              description:"Comma-separated list of dimensions to group by (minimum 1)",
              schema:{ type:"string",
                "enum":[ "date",
                  "hour",
                  "conversion_type",
                  "conversion_source",
                  "advertiser_id",
                  "campaign_id",
                  "lineitem_id",
                  "creative_id",
                  "advertiser_name",
                  "campaign_name",
                  "lineitem_name",
                  "creative_name",
                  "custom_parameter_1",
                  "custom_parameter_2",
                  "custom_parameter_3",
                  "custom_parameter_4",
                  "custom_parameter_5",
                  "attribution_mode",
                  "conversion_window" ] } },
            { name:"metrics",
              required:true,
              "in":"query",
              description:"Comma-separated list of metrics to aggregate (minimum 1)",
              schema:{ type:"string",
                "enum":[ "conversions",
                  "conversion_value",
                  "avg_conversion_value",
                  "conversion_units",
                  "avg_conversion_units" ] } },
            { name:"format",
              required:true,
              "in":"query",
              description:"Output format: json (default) or csv",
              schema:{ type:"string",
                "enum":[ "json",
                  "csv" ] } },
            { name:"id",
              required:true,
              "in":"path",
              description:"ID of the advertiser",
              schema:{ example:"123e4567-e89b-12d3-a456-426614174000",
                type:"string" } } ],
          responses:{ 200:{ description:"Reporting data returned successfully",
              content:{ "application/json":{ schema:{ example:{ status:"success",
                      metadata:{ table:"conversions",
                        start_ts:"2025-08-26T00:00:00Z",
                        end_ts:"2025-09-02T00:00:00Z",
                        advertiser_id:"f60b7dba-ac89-4d21-bdbc-98770b5faf1e",
                        campaign_id:null,
                        lineitem_id:null,
                        creative_id:null,
                        dimensions:[ "date",
                          "conversion_type" ],
                        metrics:[ "conversions",
                          "conversion_value" ],
                        row_count:3,
                        generated_at:"2025-01-15T10:30:00Z" },
                      data:[ { date:"2025-01-14",
                          conversion_type:"purchase",
                          conversions:42,
                          conversion_value:2500.75 } ] } } },
                "text/csv":{ schema:{ type:"string",
                    example:"date,conversion_type,conversions,conversion_value\n2025-01-14,purchase,42,2500.75\n" } } } },
            400:{ description:"Validation error",
              content:{ "application/json":{ example:{ message:[ { code:"invalid_type",
                        expected:"array",
                        received:"undefined",
                        path:[ "metrics" ],
                        message:"Required" } ],
                    error:"Bad Request",
                    statusCode:400 } } } },
            401:{ description:"Invalid login request",
              content:{ "application/json":{ example:{ message:"Bearer token not provided",
                    error:"Unauthorized",
                    statusCode:401 } } } },
            403:{ description:"Forbidden - Read access required",
              content:{ "application/json":{ example:{ message:"Forbidden",
                    statusCode:403 } } } },
            404:{ description:"",
              content:{ "application/json":{ example:{ message:"Resource not found",
                    error:"Not Found",
                    statusCode:404 } } } } },
          security:[ { bearer:[  ] } ],
          summary:"Get aggregated conversions reporting data",
          tags:[ "Reporting" ] } } },
    info:{ title:"Aidem Ads API",
      description:"",
      version:"1.0",
      contact:{} },
    tags:[  ],
    servers:[  ],
    components:{ securitySchemes:{ bearer:{ scheme:"bearer",
          bearerFormat:"JWT",
          type:"http" } },
      schemas:{ User:{ type:"object",
          properties:{ id:{ type:"string",
              example:"uuid" },
            sub:{ type:"string",
              example:"sub" },
            email:{ type:"string",
              example:"email@example.com" },
            email_verified:{ type:"object",
              example:false },
            first_name:{ type:"object",
              example:"John" },
            last_name:{ type:"object",
              example:"Doe" } },
          required:[ "id",
            "sub",
            "email",
            "email_verified",
            "first_name" ] },
        CreateOrganization:{ type:"object",
          properties:{ name:{ description:"Organization name",
              type:"string",
              maxLength:191,
              minLength:1 },
            active:{ description:"Whether the organization is active",
              type:"boolean",
              "default":true },
            invoice_address:{ description:"The address to reference in invoices for the Organization",
              type:"object",
              properties:{ line1:{ type:"string" },
                line2:{ type:"string" },
                city:{ type:"string" },
                state:{ type:"string" },
                zip_code:{ type:"string" },
                country:{ description:"Two letters country code",
                  type:"string" } },
              required:[ "line1",
                "city",
                "state",
                "zip_code",
                "country" ] },
            invoice_email:{ description:"The email to send invoices to for the Organization",
              type:"string",
              format:"email" },
            invoice_name:{ description:"The name that should appear in invoices for the Organization",
              type:"string",
              minLength:1 } },
          required:[ "name",
            "invoice_address",
            "invoice_email",
            "invoice_name" ] },
        Meta:{ type:"object",
          properties:{ count:{ type:"number" },
            lastPage:{ type:"number" },
            currentPage:{ type:"number" },
            totalPerPage:{ type:"number" },
            prevPage:{ type:"number",
              nullable:true,
              example:1 },
            nextPage:{ type:"number",
              nullable:true,
              example:null } },
          required:[ "count",
            "lastPage",
            "currentPage",
            "totalPerPage",
            "prevPage",
            "nextPage" ] },
        OrganizationOutDto:{ type:"object",
          properties:{ name:{ type:"string",
              example:"Account 1" },
            id:{ type:"string",
              example:"0fa33117-4026-43ad-94fe-2a6189ef582c" },
            active:{ type:"boolean",
              example:false },
            created_at:{ format:"date-time",
              type:"string",
              example:"2011-10-05T14:48:00.000Z" },
            updated_at:{ format:"date-time",
              type:"string",
              example:"2011-10-05T14:48:00.000Z" } },
          required:[ "name",
            "id",
            "active",
            "created_at",
            "updated_at" ] },
        PatchOrganization:{ type:"object",
          properties:{ name:{ description:"Organization name",
              type:"string",
              maxLength:191,
              minLength:1 },
            active:{ description:"Whether the organization is active",
              type:"boolean",
              "default":true },
            invoice_address:{ description:"The address to reference in invoices for the Organization",
              type:"object",
              properties:{ line1:{ type:"string" },
                line2:{ type:"string" },
                city:{ type:"string" },
                state:{ type:"string" },
                zip_code:{ type:"string" },
                country:{ description:"Two letters country code",
                  type:"string" } },
              required:[ "line1",
                "city",
                "state",
                "zip_code",
                "country" ] },
            invoice_email:{ description:"The email to send invoices to for the Organization",
              type:"string",
              format:"email" },
            invoice_name:{ description:"The name that should appear in invoices for the Organization",
              type:"string",
              minLength:1 } } },
        ConnectOrganizationDto:{ type:"object",
          properties:{ role:{ description:"The role of the user with respect to the organization",
              type:"string",
              "enum":[ "admin",
                "write",
                "read",
                "restricted" ],
              "x-enumNames":[ "admin",
                "write",
                "read",
                "restricted" ] },
            email:{ description:"The email of the user",
              type:"string",
              format:"email" },
            advertisers:{ type:"array",
              items:{ type:"object",
                properties:{ id:{ description:"The id of the advertiser",
                    type:"string",
                    format:"uuid" },
                  role:{ description:"The role of the users with respect to the advertiser",
                    type:"string",
                    "enum":[ "admin",
                      "write",
                      "read" ],
                    "x-enumNames":[ "admin",
                      "write",
                      "read" ] } },
                required:[ "id",
                  "role" ] } } },
          required:[ "role",
            "email" ] },
        ImpressionsStatsDto:{ type:"object",
          properties:{ advertisers:{ description:"Advertiser IDs",
              type:"array",
              items:{ type:"string",
                format:"uuid" } },
            campaigns:{ description:"Campaign IDs",
              type:"array",
              items:{ type:"string",
                format:"uuid" } },
            line_items:{ description:"Line item IDs",
              type:"array",
              items:{ type:"string",
                format:"uuid" } },
            creatives:{ description:"Creative IDs",
              type:"array",
              items:{ type:"string",
                format:"uuid" } } } },
        CreateAdvertiser:{ type:"object",
          properties:{ name:{ description:"The name of the advertiser",
              type:"string",
              minLength:1,
              maxLength:191 },
            description:{ description:"A description to attach to the advertiser",
              type:"string",
              maxLength:191 },
            domain:{ description:"The domain the advertiser refers to",
              type:"string",
              format:"uri" },
            category_key:{ description:"The category the advertiser refers to",
              type:"string",
              maxLength:191 },
            app_bundle:{ description:"The app bundle for the advertiser",
              type:"string",
              maxLength:191 },
            active:{ description:"Whether the advertiser should be active",
              type:"boolean",
              "default":true },
            default_continent:{ description:"The continent the advertiser should operate into",
              type:"string",
              "enum":[ "EMEA",
                "NAM",
                "APAC" ],
              "x-enumNames":[ "EMEA",
                "NAM",
                "APAC" ] } },
          required:[ "name",
            "domain",
            "category_key" ] },
        AdvertiserWithDetails:{ type:"object",
          properties:{ name:{ type:"string",
              example:"Advertiser 1" },
            id:{ type:"string",
              example:"0fa33117-4026-43ad-94fe-2a6189ef582c" },
            active:{ type:"boolean",
              example:false },
            dsp_id:{ type:"object",
              example:null },
            dsp_context_status:{ type:"string",
              "enum":[ "PENDING",
                "FAILED",
                "SYNCED" ] },
            domain:{ type:"string",
              example:"https://example.com" },
            app_bundle:{ type:"object",
              example:"com.example" },
            alternative_id:{ type:"object",
              example:"123" },
            category_key:{ type:"string",
              example:"IAB19" },
            created_at:{ format:"date-time",
              type:"string",
              example:"2011-10-05T14:48:00.000Z" },
            updated_at:{ format:"date-time",
              type:"string",
              example:"2011-10-05T14:48:00.000Z" },
            description:{ type:"object",
              example:"Advertiser Description" },
            currency_key:{ type:"string",
              example:"USD" },
            default_continent:{ type:"string",
              "enum":[ "EMEA",
                "NAM",
                "APAC" ],
              example:"NAM" },
            organization_id:{ type:"string",
              example:"0fa33117-4026-43ad-94fe-2a6189ef582d" } },
          required:[ "name",
            "id",
            "active",
            "dsp_id",
            "dsp_context_status",
            "domain",
            "app_bundle",
            "alternative_id",
            "category_key",
            "created_at",
            "updated_at",
            "description",
            "currency_key",
            "default_continent",
            "organization_id" ] },
        PatchAdvertiser:{ type:"object",
          properties:{ name:{ description:"The name of the advertiser",
              type:"string",
              minLength:1,
              maxLength:191 },
            description:{ description:"A description to attach to the advertiser",
              type:"string",
              maxLength:191 },
            domain:{ description:"The domain the advertiser refers to",
              type:"string",
              format:"uri" },
            category_key:{ description:"The category the advertiser refers to",
              type:"string",
              maxLength:191 },
            app_bundle:{ description:"The app bundle for the advertiser",
              type:"string",
              maxLength:191 },
            active:{ description:"Whether the advertiser should be active",
              type:"boolean",
              "default":true },
            default_continent:{ description:"The continent the advertiser should operate into",
              type:"string",
              "enum":[ "EMEA",
                "NAM",
                "APAC" ],
              "x-enumNames":[ "EMEA",
                "NAM",
                "APAC" ] } } },
        ReportingDashboard:{ type:"array",
          items:{ type:"object",
            properties:{ advertiser_id:{ type:"string",
                format:"uuid" },
              spend:{ type:"number" },
              impressions:{ type:"number" },
              reach_person:{ type:"number" },
              reach_household:{ type:"number" },
              conversions:{ type:"number" },
              conversion_rate:{ type:"number" },
              conversions_value:{ type:"number" },
              cpa:{ type:"number" },
              roas:{ type:"number" },
              group_fields:{ type:"object",
                additionalProperties:{ type:"string" } } },
            required:[ "advertiser_id",
              "spend",
              "impressions",
              "reach_person",
              "reach_household",
              "conversions",
              "conversion_rate",
              "conversions_value",
              "cpa",
              "roas",
              "group_fields" ] } },
        CreateCampaignDto:{ type:"object",
          properties:{ name:{ description:"The name of the campaign",
              type:"string",
              maxLength:191,
              minLength:4 },
            active:{ description:"Whether the campaign should be active",
              type:"boolean",
              "default":true },
            start_datetime:{ description:"Start date and time for the campaign",
              type:"string",
              format:"date-time" },
            end_datetime:{ description:"End date and time for the campaign",
              type:"string",
              format:"date-time",
              nullable:true },
            description:{ description:"A description for the campaign",
              type:"string",
              nullable:true },
            budget:{ description:"The overall budget for the campaign",
              type:"number",
              minimum:0,
              exclusiveMinimum:true },
            daily_budget:{ description:"The daily budget for the campaign",
              type:"number",
              nullable:true },
            vendor_fees:{ description:"Vendor fees for the campaign",
              type:"array",
              maxItems:3,
              items:{ type:"object",
                properties:{ vendor_id:{ type:"string",
                    format:"uuid" },
                  name:{ type:"string",
                    minLength:1,
                    maxLength:191 },
                  type:{ type:"string",
                    "enum":[ "DEFAULT",
                      "CPM",
                      "PERCENTAGE" ],
                    "default":"DEFAULT" },
                  amount:{ description:"Required for non-default vendor fees",
                    type:"number",
                    nullable:true } },
                required:[ "vendor_id",
                  "name" ],
                nullable:true },
              nullable:true },
            frequency_caps:{ description:"Frequency caps for the campaign",
              type:"object",
              properties:{ type:{ type:"string",
                  "enum":[ "STANDARD",
                    "IP_ADDRESS",
                    "PERSON_ID",
                    "HOUSE_HOLD_ID" ],
                  "default":"STANDARD" },
                use_fallback:{ type:"boolean",
                  "default":true },
                items:{ type:"array",
                  items:{ type:"object",
                    properties:{ impressions:{ type:"number",
                        minimum:1,
                        exclusiveMinimum:false },
                      interval:{ type:"number",
                        minimum:1,
                        exclusiveMinimum:false },
                      time_unit:{ type:"string",
                        "enum":[ "DAY",
                          "HOUR",
                          "MINUTE",
                          "WEEK" ],
                        "default":"DAY" } },
                    required:[ "impressions",
                      "interval" ] } } },
              required:[ "items" ] },
            advertiser_id:{ description:"The ID of the advertiser the campaign refers to",
              type:"string",
              format:"uuid" } },
          required:[ "name",
            "start_datetime",
            "budget",
            "frequency_caps",
            "advertiser_id" ] },
        FrequencyCap:{ type:"object",
          properties:{ type:{ type:"string",
              "enum":[ "STANDARD",
                "IP_ADDRESS",
                "PERSON_ID",
                "HOUSE_HOLD_ID" ],
              "default":"STANDARD" },
            use_fallback:{ type:"boolean",
              "default":true },
            items:{ type:"array",
              items:{ type:"object",
                properties:{ impressions:{ type:"number",
                    minimum:1,
                    exclusiveMinimum:false },
                  interval:{ type:"number",
                    minimum:1,
                    exclusiveMinimum:false },
                  time_unit:{ type:"string",
                    "enum":[ "DAY",
                      "HOUR",
                      "MINUTE",
                      "WEEK" ],
                    "default":"DAY" } },
                required:[ "impressions",
                  "interval" ] } } },
          required:[ "items" ] },
        CampaignWithCount:{ type:"object",
          properties:{ frequency_caps:{ type:"object",
              properties:{ type:{ type:"string",
                  "enum":[ "STANDARD",
                    "IP_ADDRESS",
                    "PERSON_ID",
                    "HOUSE_HOLD_ID" ],
                  "default":"STANDARD" },
                use_fallback:{ type:"boolean",
                  "default":true },
                items:{ type:"array",
                  items:{ type:"object",
                    properties:{ impressions:{ type:"number",
                        minimum:1,
                        exclusiveMinimum:false },
                      interval:{ type:"number",
                        minimum:1,
                        exclusiveMinimum:false },
                      time_unit:{ type:"string",
                        "enum":[ "DAY",
                          "HOUR",
                          "MINUTE",
                          "WEEK" ],
                        "default":"DAY" } },
                    required:[ "impressions",
                      "interval" ] } } },
              required:[ "items" ] },
            start_datetime:{ format:"date-time",
              type:"string",
              example:1732795153 },
            end_datetime:{ type:"object",
              example:173279515 },
            budget_type:{ type:"string",
              "enum":[ "SPEND_WITH_VENDOR_FEES",
                "SPEND",
                "IMPRESSION" ],
              example:"SPEND_WITH_VENDOR_FEES",
              description:"The type of budget. Will always be SPEND_WITH_VENDOR_FEES" } },
          required:[ "frequency_caps",
            "start_datetime",
            "end_datetime",
            "budget_type" ] },
        PatchCampaignDto:{ type:"object",
          properties:{ name:{ description:"The name of the campaign",
              type:"string",
              maxLength:191,
              minLength:4 },
            active:{ description:"Whether the campaign should be active",
              type:"boolean",
              "default":true },
            start_datetime:{ description:"Start date and time for the campaign",
              type:"string",
              format:"date-time" },
            end_datetime:{ description:"End date and time for the campaign",
              type:"string",
              format:"date-time",
              nullable:true },
            description:{ description:"A description for the campaign",
              type:"string",
              nullable:true },
            budget:{ description:"The overall budget for the campaign",
              type:"number",
              minimum:0,
              exclusiveMinimum:true },
            daily_budget:{ description:"The daily budget for the campaign",
              type:"number",
              nullable:true },
            vendor_fees:{ description:"Vendor fees for the campaign",
              type:"array",
              maxItems:3,
              items:{ type:"object",
                properties:{ vendor_id:{ type:"string",
                    format:"uuid" },
                  name:{ type:"string",
                    minLength:1,
                    maxLength:191 },
                  type:{ type:"string",
                    "enum":[ "DEFAULT",
                      "CPM",
                      "PERCENTAGE" ],
                    "default":"DEFAULT" },
                  amount:{ description:"Required for non-default vendor fees",
                    type:"number",
                    nullable:true } },
                required:[ "vendor_id",
                  "name" ],
                nullable:true },
              nullable:true },
            frequency_caps:{ description:"Frequency caps for the campaign",
              type:"object",
              properties:{ type:{ type:"string",
                  "enum":[ "STANDARD",
                    "IP_ADDRESS",
                    "PERSON_ID",
                    "HOUSE_HOLD_ID" ],
                  "default":"STANDARD" },
                use_fallback:{ type:"boolean",
                  "default":true },
                items:{ type:"array",
                  items:{ type:"object",
                    properties:{ impressions:{ type:"number",
                        minimum:1,
                        exclusiveMinimum:false },
                      interval:{ type:"number",
                        minimum:1,
                        exclusiveMinimum:false },
                      time_unit:{ type:"string",
                        "enum":[ "DAY",
                          "HOUR",
                          "MINUTE",
                          "WEEK" ],
                        "default":"DAY" } },
                    required:[ "impressions",
                      "interval" ] } } },
              required:[ "items" ] } } },
        CreateLineItemDto:{ type:"object",
          properties:{ name:{ description:"The name of the line item",
              type:"string" },
            description:{ description:"A description for the line item",
              type:"string",
              nullable:true },
            active:{ description:"Whether the line item should be active",
              type:"boolean",
              "default":false },
            start_datetime:{ description:"The start date and time of the line item" },
            end_datetime:{ description:"The end date and time of the line item" },
            type:{ description:"The type of line item",
              type:"string",
              "enum":[ "VIDEO",
                "BANNER",
                "CTV" ],
              "x-enumNames":[ "VIDEO",
                "BANNER",
                "CTV" ] },
            advertiser_id:{ description:"The ID of the advertiser the line item refers to",
              type:"string",
              format:"uuid" },
            campaign_id:{ description:"The ID of the campaign the line item refers to",
              type:"string",
              format:"uuid" },
            budget_carryover:{ description:"The budget carry over policy of the line item",
              type:"string",
              "enum":[ "NONE",
                "CARRY_OVER",
                "EVENLY_DISTRIBUTE",
                "PRORATED_DISTRIBUTE" ],
              "x-enumNames":[ "NONE",
                "CARRY_OVER",
                "EVENLY_DISTRIBUTE",
                "PRORATED_DISTRIBUTE" ],
              "default":"NONE" } },
          required:[ "name",
            "start_datetime",
            "end_datetime",
            "type",
            "advertiser_id",
            "campaign_id" ] },
        BiddingDto:{ type:"object",
          properties:{ type:{ type:"string",
              "enum":[ "FLAT_CPM",
                "CPC",
                "CPA" ],
              "x-enumNames":[ "FLAT_CPM",
                "CPC",
                "CPA" ],
              "default":"FLAT_CPM" },
            bid_shading_control:{ type:"string",
              "enum":[ "NORMAL",
                "LESS_AGGRESSIVE",
                "MORE_AGGRESSIVE" ],
              "x-enumNames":[ "NORMAL",
                "LESS_AGGRESSIVE",
                "MORE_AGGRESSIVE" ] },
            cpm:{ type:"number" } },
          required:[ "bid_shading_control",
            "cpm" ] },
        CreatePacingStrategyDto:{ type:"object",
          properties:{ type:{ type:"string",
              "enum":[ "DAILY",
                "LIFETIME",
                "FLIGHT" ],
              "x-enumNames":[ "Daily",
                "Lifetime",
                "Flight" ],
              "default":"LIFETIME" },
            pacing_behavior:{ type:"string",
              "enum":[ "EVEN",
                "AHEAD" ],
              "x-enumNames":[ "Even",
                "Ahead" ],
              "default":"EVEN" },
            catchup_behavior:{ type:"string",
              "enum":[ "EVEN",
                "IMMEDIATE",
                "SMOOTH" ],
              "x-enumNames":[ "Even",
                "Immediate",
                "Smooth" ],
              "default":"EVEN" },
            multiplier:{ type:"number",
              nullable:true,
              "default":1 } } },
        LineItem:{ type:"object",
          properties:{ effective_status:{ type:"string",
              "enum":[ "DELIVERING",
                "DELIVERED",
                "STOPPED",
                "INACTIVE",
                "UNKNOWN" ] },
            type:{ type:"string",
              "enum":[ "VIDEO",
                "BANNER",
                "CTV" ] },
            budget_carryover:{ type:"string",
              "enum":[ "NONE",
                "CARRY_OVER",
                "EVENLY_DISTRIBUTE",
                "PRORATED_DISTRIBUTE" ] },
            bidding_strategy:{ type:"object",
              properties:{ type:{ type:"string",
                  "enum":[ "FLAT_CPM",
                    "CPC",
                    "CPA" ],
                  "x-enumNames":[ "FLAT_CPM",
                    "CPC",
                    "CPA" ],
                  "default":"FLAT_CPM" },
                bid_shading_control:{ type:"string",
                  "enum":[ "NORMAL",
                    "LESS_AGGRESSIVE",
                    "MORE_AGGRESSIVE" ],
                  "x-enumNames":[ "NORMAL",
                    "LESS_AGGRESSIVE",
                    "MORE_AGGRESSIVE" ] },
                cpm:{ type:"number" } },
              required:[ "bid_shading_control",
                "cpm" ] },
            pacing_strategy:{ type:"object",
              properties:{ type:{ type:"string",
                  "enum":[ "DAILY",
                    "LIFETIME",
                    "FLIGHT" ],
                  "x-enumNames":[ "Daily",
                    "Lifetime",
                    "Flight" ],
                  "default":"LIFETIME" },
                pacing_behavior:{ type:"string",
                  "enum":[ "EVEN",
                    "AHEAD" ],
                  "x-enumNames":[ "Even",
                    "Ahead" ],
                  "default":"EVEN" },
                catchup_behavior:{ type:"string",
                  "enum":[ "EVEN",
                    "IMMEDIATE",
                    "SMOOTH" ],
                  "x-enumNames":[ "Even",
                    "Immediate",
                    "Smooth" ],
                  "default":"EVEN" },
                multiplier:{ type:"number",
                  nullable:true,
                  "default":1 } } },
            frequency_caps:{ type:"array",
              items:{ type:"object",
                properties:{ type:{ type:"string",
                    "enum":[ "STANDARD",
                      "IP_ADDRESS",
                      "PERSON_ID",
                      "HOUSE_HOLD_ID" ],
                    "default":"STANDARD" },
                  use_fallback:{ type:"boolean",
                    "default":true },
                  items:{ type:"array",
                    items:{ type:"object",
                      properties:{ impressions:{ type:"number",
                          minimum:1,
                          exclusiveMinimum:false },
                        interval:{ type:"number",
                          minimum:1,
                          exclusiveMinimum:false },
                        time_unit:{ type:"string",
                          "enum":[ "DAY",
                            "HOUR",
                            "MINUTE",
                            "WEEK" ],
                          "default":"DAY" } },
                      required:[ "impressions",
                        "interval" ] } } },
                required:[ "items" ] } },
            budget_type:{ type:"string",
              "enum":[ "SPEND_WITH_VENDOR_FEES",
                "SPEND",
                "IMPRESSION" ] } },
          required:[ "effective_status",
            "type",
            "budget_carryover",
            "bidding_strategy",
            "pacing_strategy",
            "frequency_caps",
            "budget_type" ] },
        PatchLineItemDto:{ type:"object",
          properties:{ name:{ description:"The name of the line item",
              type:"string" },
            description:{ description:"A description for the line item",
              type:"string",
              nullable:true },
            active:{ description:"Whether the line item should be active",
              type:"boolean",
              "default":false },
            start_datetime:{ description:"The start date and time of the line item" },
            end_datetime:{ description:"The end date and time of the line item" },
            type:{ description:"The type of line item",
              type:"string",
              "enum":[ "VIDEO",
                "BANNER",
                "CTV" ],
              "x-enumNames":[ "VIDEO",
                "BANNER",
                "CTV" ] },
            budget_carryover:{ description:"The budget carry over policy of the line item",
              type:"string",
              "enum":[ "NONE",
                "CARRY_OVER",
                "EVENLY_DISTRIBUTE",
                "PRORATED_DISTRIBUTE" ],
              "x-enumNames":[ "NONE",
                "CARRY_OVER",
                "EVENLY_DISTRIBUTE",
                "PRORATED_DISTRIBUTE" ],
              "default":"NONE" },
            budget_type:{ description:"The type of budget of the line item",
              type:"string",
              "enum":[ "SPEND_WITH_VENDOR_FEES",
                "SPEND",
                "IMPRESSION" ],
              "x-enumNames":[ "SPEND_WITH_VENDOR_FEES",
                "SPEND",
                "IMPRESSION" ],
              nullable:true,
              "default":"SPEND_WITH_VENDOR_FEES" },
            overall_budget:{ description:"The overall budget of the line item",
              type:"number",
              minimum:0,
              exclusiveMinimum:true,
              nullable:true },
            daily_budget:{ description:"The daily budget of the line item",
              type:"number",
              nullable:true },
            bidding_strategy:{ description:"The bidding strategy of the line item",
              type:"object",
              properties:{ type:{ type:"string",
                  "enum":[ "FLAT_CPM",
                    "CPC",
                    "CPA" ],
                  "x-enumNames":[ "FLAT_CPM",
                    "CPC",
                    "CPA" ],
                  "default":"FLAT_CPM" },
                bid_shading_control:{ type:"string",
                  "enum":[ "NORMAL",
                    "LESS_AGGRESSIVE",
                    "MORE_AGGRESSIVE" ],
                  "x-enumNames":[ "NORMAL",
                    "LESS_AGGRESSIVE",
                    "MORE_AGGRESSIVE" ] },
                cpm:{ type:"number" } },
              required:[ "bid_shading_control",
                "cpm" ] },
            pacing_strategy:{ description:"The pacing strategy of the line item",
              type:"object",
              properties:{ type:{ type:"string",
                  "enum":[ "DAILY",
                    "LIFETIME",
                    "FLIGHT" ],
                  "x-enumNames":[ "Daily",
                    "Lifetime",
                    "Flight" ],
                  "default":"LIFETIME" },
                pacing_behavior:{ type:"string",
                  "enum":[ "EVEN",
                    "AHEAD" ],
                  "x-enumNames":[ "Even",
                    "Ahead" ],
                  "default":"EVEN" },
                catchup_behavior:{ type:"string",
                  "enum":[ "EVEN",
                    "IMMEDIATE",
                    "SMOOTH" ],
                  "x-enumNames":[ "Even",
                    "Immediate",
                    "Smooth" ],
                  "default":"EVEN" },
                multiplier:{ type:"number",
                  nullable:true,
                  "default":1 } } },
            vendor_fees:{ description:"The vendor fees of the line item",
              type:"array",
              maxItems:3,
              items:{ type:"object",
                properties:{ vendor_id:{ type:"string",
                    format:"uuid" },
                  name:{ type:"string",
                    minLength:1,
                    maxLength:191 },
                  type:{ type:"string",
                    "enum":[ "DEFAULT",
                      "CPM",
                      "PERCENTAGE" ],
                    "default":"DEFAULT" },
                  amount:{ description:"Required for non-default vendor fees",
                    type:"number",
                    nullable:true } },
                required:[ "vendor_id",
                  "name" ],
                nullable:true } },
            frequency_caps:{ description:"The frequency caps of the line item",
              type:"object",
              properties:{ type:{ type:"string",
                  "enum":[ "STANDARD",
                    "IP_ADDRESS",
                    "PERSON_ID",
                    "HOUSE_HOLD_ID" ],
                  "default":"STANDARD" },
                use_fallback:{ type:"boolean",
                  "default":true },
                items:{ type:"array",
                  items:{ type:"object",
                    properties:{ impressions:{ type:"number",
                        minimum:1,
                        exclusiveMinimum:false },
                      interval:{ type:"number",
                        minimum:1,
                        exclusiveMinimum:false },
                      time_unit:{ type:"string",
                        "enum":[ "DAY",
                          "HOUR",
                          "MINUTE",
                          "WEEK" ],
                        "default":"DAY" } },
                    required:[ "impressions",
                      "interval" ] } } },
              required:[ "items" ] } } },
        PatchAudienceDto:{ type:"object",
          properties:{ prompt:{ type:"string",
              nullable:true },
            include:{ type:"array",
              items:{ type:"object",
                properties:{ id:{ type:"string",
                    format:"uuid" },
                  audience_schema_key_id:{ type:"string",
                    format:"uuid" } },
                required:[ "id",
                  "audience_schema_key_id" ] } },
            exclude:{ type:"array",
              items:{ type:"object",
                properties:{ id:{ type:"string",
                    format:"uuid" },
                  audience_schema_key_id:{ type:"string",
                    format:"uuid" } },
                required:[ "id",
                  "audience_schema_key_id" ] } } },
          required:[ "include",
            "exclude" ] },
        AudienceStatsDto:{ type:"object",
          properties:{ first_party_audience_filter:{ type:"array",
              items:{ type:"object",
                properties:{ id:{ type:"string",
                    format:"uuid" },
                  included:{ type:"boolean" } },
                required:[ "id",
                  "included" ] } },
            audience_filter:{ type:"array",
              items:{ type:"object",
                properties:{ name:{ type:"string" },
                  values:{ type:"array",
                    items:{ type:"object",
                      properties:{ id:{ type:"string",
                          format:"uuid" },
                        included:{ type:"boolean" } },
                      required:[ "id",
                        "included" ] } } },
                required:[ "name",
                  "values" ] } },
            days:{ type:"integer",
              minimum:1,
              exclusiveMinimum:false } },
          required:[ "first_party_audience_filter",
            "audience_filter" ] },
        PatchInventoryDto:{ type:"object",
          properties:{ include:{ type:"array",
              items:{ type:"object",
                properties:{ id:{ type:"string",
                    format:"uuid" },
                  inventory_schema_key_id:{ type:"string",
                    format:"uuid" } },
                required:[ "id",
                  "inventory_schema_key_id" ] } },
            exclude:{ type:"array",
              items:{ type:"object",
                properties:{ id:{ type:"string",
                    format:"uuid" },
                  inventory_schema_key_id:{ type:"string",
                    format:"uuid" } },
                required:[ "id",
                  "inventory_schema_key_id" ] } } },
          required:[ "include",
            "exclude" ] },
        PatchFirstPartyAudienceDto:{ type:"object",
          properties:{ include:{ type:"array",
              items:{ type:"object",
                properties:{ id:{ type:"string",
                    format:"uuid" },
                  audience_custom_list_schema_key_id:{ type:"string",
                    format:"uuid" } },
                required:[ "id",
                  "audience_custom_list_schema_key_id" ] } },
            exclude:{ type:"array",
              items:{ type:"object",
                properties:{ id:{ type:"string",
                    format:"uuid" },
                  audience_custom_list_schema_key_id:{ type:"string",
                    format:"uuid" } },
                required:[ "id",
                  "audience_custom_list_schema_key_id" ] } } },
          required:[ "include",
            "exclude" ] },
        ConnectCreativesDto:{ type:"array",
          items:{ type:"object",
            properties:{ creative_id:{ type:"string",
                format:"uuid" },
              weight:{ type:"number",
                nullable:true },
              start_datetime:{ type:"string",
                format:"date-time",
                nullable:true },
              end_datetime:{ type:"string",
                format:"date-time",
                nullable:true } },
            required:[ "creative_id",
              "weight" ] } },
        FlightsDto:{ type:"array",
          items:{ type:"object",
            properties:{ id:{ description:"The ID of the flight",
                type:"string",
                format:"uuid" },
              name:{ description:"The name of the flight",
                type:"string" },
              start_datetime:{ description:"The start date and time of the flight",
                type:"string",
                format:"date-time" },
              end_datetime:{ description:"The end date and tieme of the flight",
                type:"string",
                format:"date-time" },
              budget:{ description:"The budget of the flight",
                type:"number" } },
            required:[ "name",
              "start_datetime",
              "end_datetime",
              "budget" ] } },
        CreateCreativeDto:{ type:"object",
          properties:{ name:{ description:"The name of the creative",
              type:"string",
              maxLength:191,
              minLength:1 },
            type:{ description:"The type of the creative",
              type:"string",
              "enum":[ "VIDEO",
                "BANNER" ],
              "x-enumNames":[ "VIDEO",
                "BANNER" ] },
            active:{ description:"Whether the creative is active",
              type:"boolean",
              "default":true },
            click_url:{ description:"The click url of the creative",
              type:"string",
              format:"uri" },
            landing_page_url:{ description:"The landing page url of the creative" },
            third_party_pixels:{ description:"Optional third party pixels to trigger for the creative",
              type:"array",
              maxItems:5,
              items:{ type:"string",
                format:"uri" } },
            start_datetime:{ description:"The start date and time of the creative",
              type:"string",
              format:"date-time",
              nullable:true },
            end_datetime:{ description:"The end date and time of the creative",
              type:"string",
              format:"date-time",
              nullable:true },
            description:{ description:"The description of the creative",
              type:"string",
              nullable:true },
            advertiser_id:{ description:"The ID of the advertiser the creative refers to",
              type:"string",
              format:"uuid" } },
          required:[ "name",
            "type",
            "click_url",
            "advertiser_id" ] },
        CreativeWithCounts:{ type:"object",
          properties:{ type:{ type:"string",
              "enum":[ "VIDEO",
                "BANNER" ] },
            active:{ type:"boolean",
              example:false },
            ad_tag_creation_status:{ type:"string",
              "enum":[ "IN_PROGRESS",
                "SUCCEEDED",
                "FAILED",
                "UNKNOWN" ] } },
          required:[ "type",
            "active",
            "ad_tag_creation_status" ] },
        PatchCreativeDto:{ type:"object",
          properties:{ name:{ description:"The name of the creative",
              type:"string",
              maxLength:191,
              minLength:1 },
            active:{ description:"Whether the creative is active",
              type:"boolean",
              "default":true },
            click_url:{ description:"The click url of the creative",
              type:"string",
              format:"uri" },
            landing_page_url:{ description:"The landing page url of the creative" },
            third_party_pixels:{ description:"Optional third party pixels to trigger for the creative",
              type:"array",
              maxItems:5,
              items:{ type:"string",
                format:"uri" } },
            start_datetime:{ description:"The start date and time of the creative",
              type:"string",
              format:"date-time",
              nullable:true },
            end_datetime:{ description:"The end date and time of the creative",
              type:"string",
              format:"date-time",
              nullable:true },
            description:{ description:"The description of the creative",
              type:"string",
              nullable:true } } },
        ConnectLineItemsDto:{ type:"array",
          items:{ type:"object",
            properties:{ line_item_id:{ type:"string",
                format:"uuid" },
              start_datetime:{ type:"string",
                format:"date-time",
                nullable:true },
              end_datetime:{ type:"string",
                format:"date-time",
                nullable:true },
              weight:{ type:"number",
                maximum:100,
                exclusiveMaximum:false,
                minimum:0,
                exclusiveMinimum:false } },
            required:[ "line_item_id",
              "weight" ] } },
        CreateAudienceCustomListDto:{ type:"object",
          properties:{ name:{ type:"string",
              minLength:1,
              maxLength:191 },
            column_map:{ type:"array",
              items:{ type:"string",
                "enum":[ "aidem_person_id",
                  "aidem_household_id",
                  "email",
                  "phone_number",
                  "first_name",
                  "last_name",
                  "address_line_1",
                  "address_line_2",
                  "state",
                  "zip_code",
                  "auto_vin",
                  "linkedin_profile",
                  "up_id",
                  "lalvoter_id" ],
                "x-enumNames":[ "AIDEM_PERSON_ID",
                  "AIDEM_HOUSEHOLD_ID",
                  "EMAIL",
                  "PHONE_NUMBER",
                  "FIRST_NAME",
                  "LAST_NAME",
                  "ADDRESS_LINE_1",
                  "ADDRESS_LINE_2",
                  "STATE",
                  "ZIP_CODE",
                  "AUTO_VIN",
                  "LINKEDIN_PROFILE",
                  "UP_ID",
                  "LALVOTER_ID" ],
                nullable:true } },
            type:{ type:"string",
              "enum":[ "EXACT",
                "LOOKALIKE" ],
              "x-enumNames":[ "EXACT",
                "LOOKALIKE" ] },
            advertiser_id:{ type:"string",
              format:"uuid" } },
          required:[ "name",
            "column_map",
            "type",
            "advertiser_id" ] },
        AudienceCustomList:{ type:"object",
          properties:{} },
        PatchAudienceCustomListDto:{ type:"object",
          properties:{ name:{ type:"string",
              minLength:1,
              maxLength:191 },
            type:{ type:"string",
              "enum":[ "EXACT",
                "LOOKALIKE" ],
              "x-enumNames":[ "EXACT",
                "LOOKALIKE" ] } } },
        Integration:{ type:"object",
          properties:{} },
        CreateIntegration:{ type:"object",
          properties:{ type:{ description:"The type of the integration",
              type:"string",
              "enum":[ "shopify",
                "web_stream_pixel",
                "conversion_api" ],
              "x-enumNames":[ "Shopify",
                "WebStreamPixel",
                "ConversionApi" ] },
            name:{ description:"The name of the integration",
              type:"string",
              minLength:1 },
            advertiser_id:{ description:"The ID of the advertiser the integration refers to",
              type:"string",
              format:"uuid" } },
          required:[ "type",
            "name",
            "advertiser_id" ] },
        GetStatsDto:{ type:"object",
          properties:{ query:{ type:"array",
              items:{ type:"object",
                properties:{ advertiser_id:{ description:"The ID of the advertiser the event refers to",
                    type:"string" },
                  event_name:{ description:"The name of the event",
                    type:"string" },
                  event_source:{ description:"The source of the event",
                    type:"string",
                    "enum":[ "shopify",
                      "web_stream_pixel",
                      "conversion_api" ],
                    "x-enumNames":[ "Shopify",
                      "WebStreamPixel",
                      "ConversionApi" ] } },
                required:[ "advertiser_id",
                  "event_name",
                  "event_source" ] } } },
          required:[ "query" ] },
        AudienceRetargetEntity:{ type:"object",
          properties:{ event_name:{ type:"string",
              "enum":[ "AddPaymentInfo",
                "AddToCart",
                "AddToWishlist",
                "CompleteRegistration",
                "Contact",
                "CustomEvent",
                "CustomizeProduct",
                "ConfiguratorCompletion",
                "Donate",
                "DonateRecurring",
                "FindLocation",
                "InitiateCheckout",
                "Lead",
                "Purchase",
                "Schedule",
                "Search",
                "StartTrial",
                "SubmitApplication",
                "Subscribe",
                "ViewContent",
                "CoverageCheck",
                "CallMeBack",
                "ClickToCall",
                "DownloadBrochure",
                "TestDriveRequest",
                "DealerLookup" ] },
            lookback_window:{ type:"number",
              minimum:1,
              maximum:30 },
            type:{ type:"string",
              "enum":[ "EXACT",
                "LOOKALIKE" ] } },
          required:[ "event_name",
            "lookback_window",
            "type" ] },
        AudienceRetargetCreateDto:{ type:"object",
          properties:{ name:{ type:"string",
              minLength:1 },
            advertiser_id:{ type:"string",
              format:"uuid" },
            event_name:{ type:"string",
              "enum":[ "AddPaymentInfo",
                "AddToCart",
                "AddToWishlist",
                "CompleteRegistration",
                "Contact",
                "CustomEvent",
                "CustomizeProduct",
                "ConfiguratorCompletion",
                "Donate",
                "DonateRecurring",
                "FindLocation",
                "InitiateCheckout",
                "Lead",
                "Purchase",
                "Schedule",
                "Search",
                "StartTrial",
                "SubmitApplication",
                "Subscribe",
                "ViewContent",
                "CoverageCheck",
                "CallMeBack",
                "ClickToCall",
                "DownloadBrochure",
                "TestDriveRequest",
                "DealerLookup" ],
              "x-enumNames":[ "AddPaymentInfo",
                "AddToCart",
                "AddToWishlist",
                "CompleteRegistration",
                "Contact",
                "CustomEvent",
                "CustomizeProduct",
                "ConfiguratorCompletion",
                "Donate",
                "DonateRecurring",
                "FindLocation",
                "InitiateCheckout",
                "Lead",
                "Purchase",
                "Schedule",
                "Search",
                "StartTrial",
                "SubmitApplication",
                "Subscribe",
                "ViewContent",
                "CoverageCheck",
                "CallMeBack",
                "ClickToCall",
                "DownloadBrochure",
                "TestDriveRequest",
                "DealerLookup" ] },
            type:{ type:"string",
              "enum":[ "EXACT",
                "LOOKALIKE" ],
              "x-enumNames":[ "EXACT",
                "LOOKALIKE" ] },
            lookback_window:{ type:"integer",
              minimum:1,
              exclusiveMinimum:false,
              maximum:30,
              exclusiveMaximum:false } },
          required:[ "name",
            "advertiser_id",
            "event_name",
            "type",
            "lookback_window" ] },
        LineItemOnAudienceRetargetEntity:{ type:"object",
          properties:{} },
        LineItemOnAudienceRetargetUpdateCreateDto:{ type:"array",
          items:{ type:"object",
            properties:{ active:{ description:"Whether the association should be active",
                type:"boolean" },
              audience_retarget_id:{ description:"The ID of the audience retarget",
                type:"string",
                format:"uuid" } },
            required:[ "active",
              "audience_retarget_id" ] } },
        PatchUserDto:{ type:"object",
          properties:{ first_name:{ type:"string" },
            last_name:{ type:"string" } } } } } } }